import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { createPortal } from "react-dom";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import "../css/sidebar.css";
import "../css/setTargetModal.css";
import { Tooltip, Whisper } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { Placeholder } from "rsuite";
import { toast } from "react-toastify";
import { SelectPicker } from "rsuite";
import { motion, AnimatePresence } from "framer-motion";
import { Modal } from "bootstrap";
import ArrowTrendUp from "../images/arrow-trend-up.svg";
import ArrowTrendDown from "../images/arrow-trend-down.svg";
import "../css/style.css";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FaMedal, FaTrophy, FaAward } from "react-icons/fa";
import { FaHeartCircleXmark } from "react-icons/fa6";
import { IoTrendingUp } from "react-icons/io5";
import SetTargetModal from "../component/SetTargetModal";
import { IoClose } from "react-icons/io5";
import MarketDepthIcon from "../component/MarketDepthIcon";
import TablePageSizeSelect from "../component/TablePageSizeSelect";
import CustomSelect from "../component/CustomSelect";
import "../css/watchlistTopGainers.css";
import { FaCrown } from "react-icons/fa";
import { LuPencilLine } from "react-icons/lu";
import {
  Trash2,
  Columns3,
  EllipsisVertical,
  ArrowUp,
  ArrowDown,
  Pin,
  PinOff,
  Expand,
} from "lucide-react";
import { TbTarget } from "react-icons/tb";
import { getCurrentLanguage, t } from "../i18n";
import fivePaisaWebSocketService from "../services/fivePaisaWebSocketService";
import angelOneWebSocketService, {
  buildAngelInstrumentFields,
  getAngelExchangeTypeFromHolding,
} from "../services/angelOneWebSocketService";
import fivePaisaMarketDepthStore from "../services/fivePaisaMarketDepthStore";
import {
  placeOrderViaPms,
  normalizePlaceOrderResponse,
  isFivePaisaBroker,
  runPlaceOrderAcceptedFlow,
} from "../services/placeOrderService";
import growwLivePriceService from "../services/growwLivePriceService";
import angelOneMarketDepthService, {
  normalizeAngelMarketDepth,
} from "../services/angelOneMarketDepthService";


import { PMS_SHARED_DATA_MARGIN_EVENT } from "../services/dashboardStatisticsService";

import StockCandleModal from "../component/StockCandleModal";
import MarketDepthPopover from "../component/MarketDepthPopover";


const GROW_POLL_SOURCE = "watchlist";

const CANDLE_CHART_BROKERS = new Set(["5paisa", "angelone"]);

const supportsCandleChart = (brokerType) =>
  CANDLE_CHART_BROKERS.has(String(brokerType || "").trim().toLowerCase());

const WATCHLIST_PMS_COLUMN_KEY_TO_TABLE_COL = {
  name: "Name",
  current_price: "Current Price",
  net_change: "Net Change",
  target: "Target %",
  initial_target_price: "Initial Price",
  target_price: "Target Price",
  target_percent: "Target %",
  week_52_high_low: "52WeekHigh",
  week_52_high: "52WeekHigh",
  week_52_low: "52WeekLow",
  today_high_low: "TodaysHigh",
  todays_high: "TodaysHigh",
  todays_low: "TodaysLow",
  trade_price: "Trade Price",
  quantity: "Quantity",
  profit_loss: "Profit/Loss",
  profit_pct: "Profit %",
};

const WATCHLIST_TABLE_COL_LABEL_ALIASES = {
  Target: "Target %",
  "Initial/Target Price": "Initial Price",
  "52 Week High and Low": "52WeekHigh",
  "Today's High/Low": "TodaysHigh",
  "Today High/Low": "TodaysHigh",
  "Profit/Loss": "Profit/Loss",
};

const WATCHLIST_TABLE_COL_TO_PMS_COLUMN_KEY = {
  ...Object.fromEntries(
    Object.entries(WATCHLIST_PMS_COLUMN_KEY_TO_TABLE_COL).map(
      ([apiKey, tableCol]) => [tableCol, apiKey],
    ),
  ),
  TodaysHigh: "today_high_low",
  "52WeekHigh": "week_52_high_low",
  "Initial Price": "initial_target_price",
  "Target %": "target",
  "Net Change": "net_change",
  "Profit %": "profit_pct",
};

function mapWatchlistPmsColumnToTableCol(columnKey, columnLabel) {
  const rawColumnKey = String(columnKey || "").trim();
  const key = String(columnKey || "").toLowerCase().trim();
  if (WATCHLIST_PMS_COLUMN_KEY_TO_TABLE_COL[key]) {
    return WATCHLIST_PMS_COLUMN_KEY_TO_TABLE_COL[key];
  }
  const label = String(columnLabel || "").trim();
  if (WATCHLIST_TABLE_COL_LABEL_ALIASES[label]) {
    return WATCHLIST_TABLE_COL_LABEL_ALIASES[label];
  }
  const known = new Set([
    "Name",
    "Current Price",
    "Net Change",
    "Trade Price",
    "TodaysHigh",
    "TodaysLow",
    "Profit %",
    "Quantity",
    "Profit/Loss",
    "52WeekHigh",
    "52WeekLow",
    "Initial Price",
    "Target Price",
    "Target %",
    "Actions",
  ]);
  if (known.has(label)) return label;
  // For additional columns (e.g. "sector"), keep PMS column_key as-is.
  if (rawColumnKey) return rawColumnKey;
  return null;
}

function buildWatchlistTableColumnOrderFromPms(columnsPayload) {
  if (!Array.isArray(columnsPayload) || columnsPayload.length === 0)
    return null;
  const sorted = [...columnsPayload].sort(
    (a, b) => Number(a.sort_order) - Number(b.sort_order),
  );
  const out = [];
  const seen = new Set();
  for (const c of sorted) {
    const selected =
      c.is_selected === "1" || c.is_selected === 1 || c.is_selected === true;
    const active =
      c.is_active === "1" || c.is_active === 1 || c.is_active === true;
    if (!selected || !active) continue;
    const col = mapWatchlistPmsColumnToTableCol(c.column_key, c.column_label);
    if (!col || col === "Actions") continue;
    if (seen.has(col)) continue;
    seen.add(col);
    out.push(col);
  }
  if (!out.includes("Actions")) out.push("Actions");
  return out.length ? out : null;
}

function normalizeAdditionalColumnKey(key) {
  return String(key || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

function resolveAdditionalColumnValue(additionalData, colKey) {
  if (!additionalData || typeof additionalData !== "object") return undefined;
  if (additionalData[colKey] !== undefined) return additionalData[colKey];
  const targetKey = normalizeAdditionalColumnKey(colKey);
  if (!targetKey) return undefined;
  for (const [k, v] of Object.entries(additionalData)) {
    if (normalizeAdditionalColumnKey(k) === targetKey) return v;
  }
  return undefined;
}

function Watchlist(props) {
  // All initialization and Declaration
  const [holdings, setHoldings] = useState([]);

  // WebSocket related state variables
  const [liveUpdateTrigger, setLiveUpdateTrigger] = useState(0);
  const [updateWatchlistTrigger, setUpdateWatchlistTrigger] = useState(0);
  const tabName = "Watchlist";
  const searchInputRef = useRef(null);
  const [tabs, setTabs] = useState([
    "First Watchlist",
    "Top Growth",
  ]);

  const [activeTab, setActiveTab] = useState("First Watchlist");
  const [highlightPosition, setHighlightPosition] = useState({
    left: 0,
    width: 0,
  });
  const [isLoading, setIsLoading] = useState(false); 
  // Market depth state (stores the latest order book for subscribed stock)
  const [marketDepth, setMarketDepth] = useState([]);
  const [currentMDModal, setcurrentMDModal] = useState(null);

  // SearchBar 2
  const [isAddWatchlistDisabled, setIsAddWatchlistDisabled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [watchlistSearchQuery, setWatchlistSearchQuery] = useState("");
  const watchlistSearchInputRef = useRef(null);


  const [newWatchlistName, setNewWatchlistName] = useState("");
  const [watchlistError, setWatchlistError] = useState("");
  const [userWatchlists, setUserWatchlists] = useState([]); // This should be populated from API response
  const [userWatchlistMeta, setUserWatchlistMeta] = useState([]);
  const [activeWatchlistId, setActiveWatchlistId] = useState(null);

  const [editWatchlistCurrentName, setEditWatchlistCurrentName] = useState("");
  const [editWatchlistNewName, setEditWatchlistNewName] = useState("");
  const [editWatchlistError, setEditWatchlistError] = useState("");
  const [showEditWatchlistPopover, setShowEditWatchlistPopover] = useState(false);
  const [editWatchlistPopoverPos, setEditWatchlistPopoverPos] = useState({
    top: 0,
    left: 0,
  });
  const editWatchlistButtonRef = useRef(null);
  const editWatchlistPopoverRef = useRef(null);

  // Top Gainers Table States
  const [topGainersSearchQuery, setTopGainersSearchQuery] = useState("");
  const [topGainersSortBy, setTopGainersSortBy] = useState("");
  const [topGainersSortOrder, setTopGainersSortOrder] = useState("desc");
  const [topGainersCurrentPage, setTopGainersCurrentPage] = useState(1);
  const [topGainersPageSize, setTopGainersPageSize] = useState(20);
  const topGainersSearchInputRef = useRef(null);

  const [showMarketDepth, setShowMarketDepth] = useState(false);
  const [marketDepthPosition, setMarketDepthPosition] = useState({
    top: 0,
    left: 0,
  });
  const marketDepthButtonRef = useRef(null);
  const marketDepthPopoverRef = useRef(null);

  const [watchlistTabs, setWatchlistTabs] = useState({});

  const handleTopGainersSort = (field) => {
    if (topGainersSortBy === field) {
      // Cycle through: asc → desc → none
      if (topGainersSortOrder === "asc") {
        setTopGainersSortOrder("desc");
      } else if (topGainersSortOrder === "desc") {
        // Reset to no sorting
        setTopGainersSortBy("");
        setTopGainersSortOrder("asc");
      }
    } else {
      // First click - set to asc
      setTopGainersSortBy(field);
      setTopGainersSortOrder("asc");
    }
    setTopGainersCurrentPage(1);
  };

  // Top Gainers Page Change Handler
  const handleTopGainersPageChange = (pageNumber) => {
    setTopGainersCurrentPage(pageNumber);
  };

  // Top Gainers Page Size Change Handler
  const handleTopGainersPageSizeChange = (e) => {
    setTopGainersPageSize(Number(e.target.value));
    setTopGainersCurrentPage(1);
  };

  // Inside your component
  const navigate = useNavigate();
  const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());
  const tr = useCallback((key) => t(key, currentLanguage), [currentLanguage]);

  const topGainerCategoryOptions = useMemo(
    () => [
      { value: "allSec", label: tr("allSecurities") },
      { value: "NIFTY", label: tr("nifty50") },
      { value: "BANKNIFTY", label: tr("bankNifty") },
      { value: "NIFTYNEXT50", label: tr("niftyNext50") },
      { value: "FOSec", label: tr("foSecurities") },
      { value: "SecGtr20", label: "Securities > ₹20" },
      { value: "SecLwr20", label: "Securities < ₹20" },
    ],
    [tr],
  );

  const getItemsRangeText = useCallback(
    (from, to, total) =>
      `${from} ${tr("to")} ${to} ${tr("of")} ${total} ${tr("items")}`,
    [tr],
  );

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language || getCurrentLanguage());
    };
    window.addEventListener("app-language-change", handleLanguageChange);
    return () =>
      window.removeEventListener("app-language-change", handleLanguageChange);
  }, []);

  // Delete From Watchlist
  const [selectedOrderId, setSelectedOrderId] = useState({
    Name: "",
    ID: "",
  });

  // table search
  const [searchQuery, setSearchQuery] = useState("");
  const [activeHeaderMenu, setActiveHeaderMenu] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    column: null,
    direction: null,
  });
  const [simpleSortMenu, setSimpleSortMenu] = useState(null);
  const [quickStrategySortConfig, setQuickStrategySortConfig] = useState({
    tab1: { column: null, direction: null },
    tab2: { column: null, direction: null },
  });
  const [pinnedColumns, setPinnedColumns] = useState({});
  const [columnWidths, setColumnWidths] = useState({});

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Top Gainers States
  const [topGainersData, setTopGainersData] = useState(null); // All categories data
  const [selectedCategory, setSelectedCategory] = useState("allSec"); // Default: All Securities
  const [currentTopGainers, setCurrentTopGainers] = useState([]); // Current category stocks
  const [isLoadingTopGainers, setIsLoadingTopGainers] = useState(false);

  const sharedData = JSON.parse(localStorage.getItem("sharedData") || "null");
  const pmsApiBaseUrl =
    process.env.REACT_APP_PMS_API_BASE_URL || "https://pmsapi.infomanav.in";
  const isGrowBroker =
    String(sharedData?.broker_type || localStorage.getItem("broker_type") || "")
      .toLowerCase() === "grow";
  const isAngelOneBroker =
    String(sharedData?.broker_type || localStorage.getItem("broker_type") || "")
      .toLowerCase() === "angelone";

  const getOrderLivePriceCacheKey = (order) => {
    if (!order) return "";
    if (isAngelOneBroker) {
      return String(
        order?.token || order?.Token || order?.scripcode || order?.ScripCode || "",
      ).trim();
    }
    if (order?.Exch === "N") {
      return order?.NseCode || order?.scripcode || order?.Scripcode || "";
    }
    return order?.BseCode || order?.scripcode || order?.Scripcode || "";
  };

  const readMarginFromSharedStorage = () => {
    try {
      const raw = localStorage.getItem("sharedData");
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data?.margin === undefined || data?.margin === null || data?.margin === "") {
        return null;
      }
      const n = Number(data.margin);
      return Number.isFinite(n) ? n : null;
    } catch {
      return null;
    }
  };
  const [pmsHeaderMargin, setPmsHeaderMargin] = useState(readMarginFromSharedStorage);

  useEffect(() => {
    const handler = (e) => {
      const m = e?.detail?.margin;
      if (m === undefined || m === null) return;
      const n = Number(m);
      if (!Number.isFinite(n)) return;
      setPmsHeaderMargin(n);
    };
    window.addEventListener(PMS_SHARED_DATA_MARGIN_EVENT, handler);
    return () => window.removeEventListener(PMS_SHARED_DATA_MARGIN_EVENT, handler);
  }, []);

  const staticWatchlistTabs = ["Top Growth"];

  class BaseWatchlistAdapter {
    numberOrZero = (value) => {
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    };

    stringOrDefault = (value, fallback = "") =>
      value === null || value === undefined || value === "" ? fallback : String(value);

    numberOrNull = (value) => {
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    };

    pickLatestTarget = (targetData = []) => {
      if (!Array.isArray(targetData) || targetData.length === 0) return {};
      return [...targetData]
        .filter((item) => item && typeof item === "object")
        .sort(
          (a, b) =>
            new Date(b?.created_at || 0).getTime() - new Date(a?.created_at || 0).getTime(),
        )[0] || {};
    };

    sanitizeAdditionalData = (value) => {
      if (!value || typeof value !== "object" || Array.isArray(value)) return null;
      return value;
    };

    pick52WeekRange = (row = {}, stocksData = {}, additionalData = null) => {
      const high = this.numberOrNull(
        additionalData?.["52WeekHigh"] ??
        additionalData?.week_52_high ??
        stocksData?.week_52_high ??
        stocksData?.["52WeekHigh"] ??
        row?.["52WeekHigh"],
      );
      const low = this.numberOrNull(
        additionalData?.["52WeekLow"] ??
        additionalData?.week_52_low ??
        stocksData?.week_52_low ??
        stocksData?.["52WeekLow"] ??
        row?.["52WeekLow"],
      );
      return { high52Week: high, low52Week: low };
    };

    pickTodayRange = (row = {}, stocksData = {}, additionalData = null) => {
      const ohlc = stocksData?.ohlc || {};
      const todayHigh = this.numberOrNull(
        additionalData?.today_high ??
        additionalData?.TodaysHigh ??
        stocksData?.High ??
        stocksData?.high ??
        stocksData?.day_high ??
        stocksData?.high_trade_range ??
        ohlc?.high ??
        row?.TodaysHigh ??
        row?.day_high ??
        row?.high,
      );
      const todayLow = this.numberOrNull(
        additionalData?.today_low ??
        additionalData?.TodaysLow ??
        stocksData?.Low ??
        stocksData?.low ??
        stocksData?.day_low ??
        stocksData?.low_trade_range ??
        ohlc?.low ??
        row?.TodaysLow ??
        row?.day_low ??
        row?.low,
      );
      return { todayHigh, todayLow };
    };

    normalizeWatchlistRows = (rows = [], watchlistName = "") =>
      rows.map((row) => ({ ...row, watchlistName }));
  }

  class FivePaisaWatchlistAdapter extends BaseWatchlistAdapter {
    normalizeWatchlistRows = (rows = [], watchlistName = "") =>
      rows.map((row = {}) => {
        const stocksData = row?.stocks_data || {};
        const hasTargetData = Array.isArray(row?.target_data) && row.target_data.length > 0;
        const targetData = this.pickLatestTarget(row?.target_data);
        const additionalData = this.sanitizeAdditionalData(row?.nova_extra_data);
        const exch = this.stringOrDefault(row?.stock_exch || row?.exch, "N").charAt(0).toUpperCase();
        const exchType = this.stringOrDefault(row?.stock_exch_type || row?.exchType, "C").charAt(0).toUpperCase();
        const scripCode = this.numberOrZero(row?.stock_scrip_code || row?.script_code || row?.scripcode);
        const fullName = this.stringOrDefault(row?.stock_full_name, row?.stock_name || row?.name || "");
        const ltp = this.numberOrZero(
          stocksData?.LastRate ??
          stocksData?.LastTradedPrice ??
          row?.ltp ??
          row?.current_price ??
          row?.CurrentPrice,
        );
        const previousClose = this.numberOrZero(stocksData?.PClose ?? row?.prev_close ?? row?.pclose);
        const { high52Week, low52Week } = this.pick52WeekRange(row, stocksData, additionalData);
        const { todayHigh, todayLow } = this.pickTodayRange(row, stocksData, additionalData);
        return {
          ...row,
          watchlistName,
          id: this.stringOrDefault(row?.id, ""),
          Exch: exch,
          exch,
          ExchType: exchType,
          exchType,
          ScripCode: scripCode,
          scripcode: scripCode,
          Scripcode: scripCode,
          script_code: this.stringOrDefault(row?.script_code, scripCode),
          Name: this.stringOrDefault(row?.stock_name || row?.name, ""),
          name: this.stringOrDefault(row?.stock_name || row?.name, ""),
          Symbol: this.stringOrDefault(row?.stock_name || row?.name, ""),
          FullName: fullName,
          ISIN: this.stringOrDefault(row?.stock_isin, ""),
          ltp,
          CurrentPrice: ltp,
          "Current Price": ltp,
          PClose: previousClose,
          "52WeekHigh": high52Week,
          "52WeekLow": low52Week,
          additionalData,
          TodaysHigh: todayHigh,
          TodaysLow: todayLow,
          volume: this.numberOrZero(stocksData?.Volume ?? stocksData?.TotalQty ?? row?.volume),
          hasTargetData,
          initialPrice: this.numberOrZero(
            targetData?.initialPrice ?? targetData?.initial_price ?? row?.initialPrice,
          ),
          targetPrice: this.numberOrZero(targetData?.targetPrice ?? row?.targetPrice),
          target_logic: this.stringOrDefault(targetData?.target_logic, row?.target_logic),
          targetReason: this.stringOrDefault(
            targetData?.targetReason ?? targetData?.target_reason ?? row?.targetReason,
          ),
          targetReasonDetails: this.stringOrDefault(
            targetData?.targetReasonDetails ??
            targetData?.target_reason_details ??
            row?.targetReasonDetails,
          ),
          createdDate: this.stringOrDefault(targetData?.created_at ?? row?.created, ""),
        };
      });
  }

  class GrowwWatchlistAdapter extends BaseWatchlistAdapter {
    normalizeWatchlistRows = (rows = [], watchlistName = "") =>
      rows.map((row = {}) => {
        const stocksData = row?.stocks_data || {};
        const ohlc = stocksData?.ohlc || {};
        const hasTargetData = Array.isArray(row?.target_data) && row.target_data.length > 0;
        const targetData = this.pickLatestTarget(row?.target_data);
        const additionalData = this.sanitizeAdditionalData(row?.nova_extra_data);
        const exchangeRaw = this.stringOrDefault(row?.stock_exchange || row?.exchange, "NSE").toUpperCase();
        const exch = exchangeRaw.startsWith("B")
          ? "B"
          : exchangeRaw.startsWith("M")
            ? "M"
            : "N";
        const tradingSymbol = this.stringOrDefault(
          row?.stock_trading_symbol || row?.trading_symbol,
          "",
        );
        const scripCode = this.numberOrZero(row?.stock_exchange_token);
        const fullName = this.stringOrDefault(
          row?.full_name,
          row?.stock_full_name || row?.stock_name || tradingSymbol,
        );
        const ltp = this.numberOrZero(
          stocksData?.last_price ??
          stocksData?.ltp ??
          ohlc?.close ??
          ohlc?.open ??
          row?.ltp ??
          row?.current_price ??
          row?.CurrentPrice,
        );
        const previousClose = this.numberOrZero(
          stocksData?.PClose ??
          stocksData?.previous_close ??
          stocksData?.pc ??
          ohlc?.close ??
          stocksData?.close ??
          ohlc?.open ??
          stocksData?.open ??
          row?.prev_close ??
          row?.pclose,
        );
        const { high52Week, low52Week } = this.pick52WeekRange(row, stocksData, additionalData);
        const { todayHigh, todayLow } = this.pickTodayRange(row, stocksData, additionalData);
        return {
          ...row,
          watchlistName,
          id: this.stringOrDefault(row?.id, ""),
          Exch: exch,
          exch,
          ExchType: "C",
          exchType: "C",
          ScripCode: scripCode,
          scripcode: scripCode,
          Scripcode: scripCode,
          script_code: this.stringOrDefault(row?.script_code, scripCode),
          Name: tradingSymbol,
          name: tradingSymbol,
          Symbol: tradingSymbol,
          TradingSymbol: tradingSymbol,
          FullName: fullName,
          full_name: this.stringOrDefault(row?.full_name, fullName),
          ISIN: this.stringOrDefault(row?.stock_isin, ""),
          ltp,
          CurrentPrice: ltp,
          "Current Price": ltp,
          PClose: previousClose,
          "52WeekHigh": high52Week,
          "52WeekLow": low52Week,
          additionalData,
          TodaysHigh: todayHigh,
          TodaysLow: todayLow,
          dayOpen: this.numberOrZero(ohlc?.open),
          volume: this.numberOrZero(stocksData?.volume ?? row?.volume),
          hasTargetData,
          initialPrice: this.numberOrZero(
            targetData?.initialPrice ?? targetData?.initial_price ?? row?.initialPrice,
          ),
          targetPrice: this.numberOrZero(targetData?.targetPrice ?? row?.targetPrice),
          target_logic: this.stringOrDefault(targetData?.target_logic, row?.target_logic),
          targetReason: this.stringOrDefault(
            targetData?.targetReason ?? targetData?.target_reason ?? row?.targetReason,
          ),
          targetReasonDetails: this.stringOrDefault(
            targetData?.targetReasonDetails ??
            targetData?.target_reason_details ??
            row?.targetReasonDetails,
          ),
          createdDate: this.stringOrDefault(targetData?.created_at ?? row?.created, ""),
        };
      });
  }

  class AngelOneWatchlistAdapter extends BaseWatchlistAdapter {
    normalizeWatchlistRows = (rows = [], watchlistName = "") =>
      rows.map((row = {}) => {
        const marketQuote = row?.market_quote || {};
        const stocksData = row?.stocks_data || {};
        const quoteStocksData = {
          ltp: marketQuote.ltp,
          last_price: marketQuote.ltp,
          previous_close: marketQuote.close,
          close: marketQuote.close,
          high: marketQuote.high,
          low: marketQuote.low,
          open: marketQuote.open,
          volume: marketQuote.tradeVolume,
          week_52_high: marketQuote["52WeekHigh"],
          week_52_low: marketQuote["52WeekLow"],
          "52WeekHigh": marketQuote["52WeekHigh"],
          "52WeekLow": marketQuote["52WeekLow"],
          net_change: marketQuote.netChange,
          day_change: marketQuote.netChange,
          day_change_perc: marketQuote.percentChange,
        };
        const mergedStocksData = { ...stocksData, ...quoteStocksData };
        const hasTargetData = Array.isArray(row?.target_data) && row.target_data.length > 0;
        const targetData = this.pickLatestTarget(row?.target_data);
        const additionalData = this.sanitizeAdditionalData(row?.nova_extra_data);
        const exchangeRaw = this.stringOrDefault(
          row?.exch_seg || marketQuote.exchange,
          "NSE",
        ).toUpperCase();
        const exch = exchangeRaw.startsWith("B")
          ? "B"
          : exchangeRaw.startsWith("M")
            ? "M"
            : "N";
        const token = this.stringOrDefault(
          row?.token || marketQuote.symbolToken,
          "",
        );
        const scripCode = this.numberOrZero(token);
        const fields = buildAngelInstrumentFields({
          name: row?.name,
          symbol: row?.symbol || marketQuote.tradingSymbol,
          token,
          exch_seg: exchangeRaw,
          instrumenttype: row?.instrumenttype,
          expiry: row?.expiry,
        });
        const tokenKey = token || String(scripCode || "");
        const tradingSymbol = this.stringOrDefault(
          row?.symbol || marketQuote.tradingSymbol || fields.tradingSymbol,
          "",
        );
        const ltp = this.numberOrZero(
          marketQuote.ltp ??
          mergedStocksData.ltp ??
          mergedStocksData.last_price ??
          row?.ltp ??
          row?.current_price ??
          row?.CurrentPrice,
        );
        const previousClose = this.numberOrZero(
          marketQuote.close ??
          mergedStocksData.previous_close ??
          mergedStocksData.close ??
          row?.prev_close ??
          row?.pclose,
        );
        const quoteRow = {
          ...row,
          "52WeekHigh": marketQuote["52WeekHigh"],
          "52WeekLow": marketQuote["52WeekLow"],
          high: marketQuote.high,
          low: marketQuote.low,
        };
        const { high52Week, low52Week } = this.pick52WeekRange(
          quoteRow,
          mergedStocksData,
          additionalData,
        );
        const { todayHigh, todayLow } = this.pickTodayRange(
          quoteRow,
          mergedStocksData,
          additionalData,
        );
        const marketDepth = normalizeAngelMarketDepth(marketQuote.depth);
        const netChange = this.numberOrZero(marketQuote.netChange);
        const netChangePercent = this.numberOrZero(marketQuote.percentChange);

        return {
          ...row,
          watchlistName,
          id: this.stringOrDefault(row?.id, ""),
          Exch: exch,
          exch,
          ExchType: exch === "M" || fields.isDerivative ? "D" : "C",
          exchType: exch === "M" || fields.isDerivative ? "D" : "C",
          ScripCode: scripCode,
          scripcode: tokenKey,
          Scripcode: scripCode,
          script_code: tokenKey,
          token: tokenKey,
          Token: tokenKey,
          symboltoken: tokenKey,
          tradingsymbol: tradingSymbol,
          InstrumentName: fields.instrumentName,
          Name: tradingSymbol,
          name: tradingSymbol,
          Symbol: tradingSymbol,
          TradingSymbol: tradingSymbol,
          FullName: fields.fullName,
          full_name: fields.fullName,
          ExchSeg: exchangeRaw,
          Expiry: fields.expiry,
          InstrumentType: fields.instrumentType,
          market_quote: marketQuote,
          marketDepth,
          stocks_data: mergedStocksData,
          ltp,
          CurrentPrice: ltp,
          "Current Price": ltp,
          PClose: previousClose,
          "52WeekHigh": high52Week,
          "52WeekLow": low52Week,
          additionalData,
          TodaysHigh: todayHigh,
          TodaysLow: todayLow,
          dayOpen: this.numberOrZero(marketQuote.open ?? mergedStocksData.open),
          volume: this.numberOrZero(
            marketQuote.tradeVolume ?? mergedStocksData.volume ?? row?.volume,
          ),
          netChange,
          netChangePercent,
          hasTargetData,
          initialPrice: this.numberOrZero(
            targetData?.initialPrice ?? targetData?.initial_price ?? row?.initialPrice,
          ),
          targetPrice: this.numberOrZero(targetData?.targetPrice ?? row?.targetPrice),
          target_logic: this.stringOrDefault(targetData?.target_logic, row?.target_logic),
          targetReason: this.stringOrDefault(
            targetData?.targetReason ?? targetData?.target_reason ?? row?.targetReason,
          ),
          targetReasonDetails: this.stringOrDefault(
            targetData?.targetReasonDetails ??
            targetData?.target_reason_details ??
            row?.targetReasonDetails,
          ),
          createdDate: this.stringOrDefault(targetData?.created_at ?? row?.created, ""),
        };
      });
  }

  const getWatchlistAdapter = (brokerFlag) => {
    const normalizedFlag = String(brokerFlag || "").toLowerCase();
    if (normalizedFlag === "grow") return new GrowwWatchlistAdapter();
    if (normalizedFlag === "angelone") return new AngelOneWatchlistAdapter();
    if (normalizedFlag === "5paisa") return new FivePaisaWatchlistAdapter();
    return new BaseWatchlistAdapter();
  };

  const chunkItems = (items = [], size = 50) => {
    const chunks = [];
    for (let i = 0; i < items.length; i += size) {
      chunks.push(items.slice(i, i + size));
    }
    return chunks;
  };

  const getGrowPollingKeyFromHolding = (holding = {}) => {
    const symbol = String(holding?.TradingSymbol || holding?.Symbol || holding?.name || "").trim().toUpperCase();
    if (!symbol) return "";
    const exchangePrefix = holding?.Exch === "B" ? "BSE" : holding?.Exch === "M" ? "MCX" : "NSE";
    return `${exchangePrefix}_${symbol}`;
  };

  const stopWatchlistLiveUpdates = () => {
    if (watchlistWsSubscriptionsRef.current.length) {
      fivePaisaWebSocketService.unsubscribeMarketFeed(watchlistWsSubscriptionsRef.current);
      watchlistWsSubscriptionsRef.current = [];
    }
    if (angelWatchlistWsSubscriptionsRef.current.length) {
      angelOneWebSocketService.unsubscribeMarketFeed(
        angelWatchlistWsSubscriptionsRef.current,
      );
      angelWatchlistWsSubscriptionsRef.current = [];
    }
    growWatchlistUnsubscribeRef.current?.();
    growWatchlistUnsubscribeRef.current = null;
    growwLivePriceService.stopPolling(GROW_POLL_SOURCE);
  };

  // Refs for caching live data and WebSocket
  const subscribedScripCodes = useRef(new Set());
  const lastSubscribedHoldings = useRef([]);
  const liveRerenderTimeoutRef = useRef(null);
  const lastFetchRunRef = useRef({ key: "", at: 0 });
  const wsStatusUnsubRef = useRef(null);
  const wsPriceUnsubRef = useRef(null);
  const wsErrorUnsubRef = useRef(null);
  const mdStoreUnsubRef = useRef(null);
  const topGainersInitialLoadDoneRef = useRef(false);
  const selectedTopGainerCategoryRef = useRef("allSec");
  // Used to ignore stale responses when fetchHoldings is called multiple times quickly.
  const watchlistFetchIdRef = useRef(0);
  const activeWatchlistIdRef = useRef(null);
  const userWatchlistMetaRef = useRef([]);
  const watchlistWsSubscriptionsRef = useRef([]);
  const angelWatchlistWsSubscriptionsRef = useRef([]);
  const growWatchlistUnsubscribeRef = useRef(null);
  const angelWsStatusUnsubRef = useRef(null);
  const angelWsPriceUnsubRef = useRef(null);
  const angelWsErrorUnsubRef = useRef(null);
  const angelMdServiceUnsubRef = useRef(null);

  const livePriceCache = useRef({});
  const liveHighCache = useRef({});
  const liveLowCache = useRef({});
  const livePCloseCache = useRef({});
  const liveDiffCache = useRef({});
  const liveChangePercentageCache = useRef({});
  const liveVolumeCache = useRef({});
  const livePLCache = useRef({});

  const currentMDModalRef = useRef(null);

  const OrderType = [
    { value: "Market Order", label: tr("marketOrder") },
    { value: "Limit Order", label: tr("limitOrder") },
  ];

  const [orderType, setOrderType] = useState("Market Order");
  const [isPreview, setIsPreview] = useState(false);

  const [columns, setColumns] = useState([
    "Name",
    "Current Price",
    "Net Change",
    "Initial Price",
    "Target Price",
    "Target %",
    "52WeekHigh",
    "52WeekLow",
    "Actions",
  ]);

  const [buySellModalDetails, setBuySellModalDetails] = useState({
    FullName: "",
    Symbol: "",
    Type: "Buy", // hardcoded for buy function, will create separate for sell
    OrderQty: 1, // default 1
    LimitPrice: 0, // default 0
    order: null, // complete order object for future use
  });

  const formatNumber = (num) => {
    if (num === null || num === undefined) return "-";
    const number = parseFloat(num);
    if (isNaN(number)) return "-";

    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Drag-N-Drop
  // Add these in your component
  const [draggedColumn, setDraggedColumn] = useState(null);
  const [columnOrder, setColumnOrder] = useState(columns); // start with columns prop or state

  const [targetDetails, setTargetDetails] = useState();
  const [targetReasonModalData, setTargetReasonModalData] = useState({
    stockName: "",
    reason: "",
    details: "",
  });

  const defaultColumns = [
    "Name",
    "Current Price",
    "Net Change",
    "Trade Price",
    "TodaysHigh",
    "TodaysLow",
    "Profit %",
    "Quantity",
    "Profit/Loss",
    "52WeekHigh",
    "52WeekLow",
    "Initial Price",
    "Target Price",
    "Target %",
  ];


  const [additionalColumnConfig, setAdditionalColumnConfig] = useState([
    {
      colName: "52WeekHighDate",
      UIName: "52 Week High Date",
      colStatus: false,
    },
    { colName: "52WeekLowDate", UIName: "52 Week Low Date", colStatus: false },
    { colName: "volume", UIName: "Volume", colStatus: false },
    {
      colName: "avgVolume10days",
      UIName: "Average Volume 10 Days",
      colStatus: false,
    },
    {
      colName: "avgVolume30days",
      UIName: "Average Volume 30 Days",
      colStatus: false,
    },
    { colName: "marketcap", UIName: "Market Capitalization", colStatus: false },
    {
      colName: "usdMarketCap",
      UIName: "USD Market Capitalization",
      colStatus: false,
    },
    { colName: "peTTM", UIName: "PE TTM", colStatus: false },
    { colName: "peAnnual", UIName: "Annual PE", colStatus: false },
    { colName: "pbAnnual", UIName: "Annual PB", colStatus: false },
    {
      colName: "epsTTM",
      UIName: "EPS Trailing Twelve Months",
      colStatus: false,
    },
    { colName: "epsAnnual", UIName: "Annual EPS", colStatus: false },
    {
      colName: "dividendPerShareTTM",
      UIName: "Dividend Per Share TTM",
      colStatus: false,
    },
    {
      colName: "dividendPerShareAnnual",
      UIName: "Annual Dividend Per Share",
      colStatus: false,
    },
    {
      colName: "currentDividendYieldTTM",
      UIName: "Dividend Yield TTM",
      colStatus: false,
    },
    { colName: "sector", UIName: "Sector", colStatus: false },
    { colName: "industry", UIName: "Industry", colStatus: false },
    { colName: "company_symbol", UIName: "Company Symbol", colStatus: false },
    { colName: "exchange", UIName: "Exchange", colStatus: false },
    { colName: "change1D", UIName: "1 Day Change", colStatus: false },
    {
      colName: "change1DPercent",
      UIName: "1 Day Change Percent",
      colStatus: false,
    },
    {
      colName: "bookValuePerShareAnnual",
      UIName: "Annual Book Value Per Share",
      colStatus: false,
    },
    { colName: "beta", UIName: "Beta", colStatus: false },
    { colName: "ipoDate", UIName: "IPO Date", colStatus: false },
    { colName: "employeeTotal", UIName: "Total Employees", colStatus: false },
    // { colName: "id", UIName: "ID", colStatus: false },
    { colName: "isin", UIName: "ISIN", colStatus: false },
    { colName: "ticker", UIName: "Ticker", colStatus: false },
    { colName: "created_at", UIName: "Created At", colStatus: false },
    { colName: "updated_at", UIName: "Updated At", colStatus: false },
    { colName: "currency", UIName: "Currency", colStatus: false },
    { colName: "country", UIName: "Country", colStatus: false },
    { colName: "company_country", UIName: "Company Country", colStatus: false },
    {
      colName: "exchange_country",
      UIName: "Exchange Country",
      colStatus: false,
    },
    { colName: "exchange_symbol", UIName: "Exchange Symbol", colStatus: false },
    {
      colName: "analyst_recommendation_weighted_avg",
      UIName: "Analyst Recommendation Weighted Avg",
      colStatus: false,
    },
    { colName: "ranking", UIName: "Ranking", colStatus: false },
    {
      colName: "recommendationWeightedAverage",
      UIName: "Recommendation Weighted Average",
      colStatus: false,
    },
    {
      colName: "assets_growth_1y",
      UIName: "Assets Growth 1 Year",
      colStatus: false,
    },
    {
      colName: "assets_growth_3y",
      UIName: "Assets Growth 3 Years",
      colStatus: false,
    },
    {
      colName: "assets_growth_5y",
      UIName: "Assets Growth 5 Years",
      colStatus: false,
    },
    {
      colName: "cashFlowPerShareAnnual",
      UIName: "Annual Cash Flow Per Share",
      colStatus: false,
    },
    {
      colName: "cashFlowPerShareQuarterly",
      UIName: "Quarterly Cash Flow Per Share",
      colStatus: false,
    },
    {
      colName: "cashPerSharePerShareAnnual",
      UIName: "Annual Cash Per Share",
      colStatus: false,
    },
    {
      colName: "cashPerSharePerShareQuarterly",
      UIName: "Quarterly Cash Per Share",
      colStatus: false,
    },
    {
      colName: "bookValuePerShareQuarterly",
      UIName: "Quarterly Book Value Per Share",
      colStatus: false,
    },
    { colName: "currentAssets", UIName: "Current Assets", colStatus: false },
    {
      colName: "currentAssets_year",
      UIName: "Current Assets Year",
      colStatus: false,
    },
    {
      colName: "dividendYieldIndicatedAnnual",
      UIName: "Annual Dividend Yield Indicated",
      colStatus: false,
    },
    {
      colName: "doubtful_revenue_percent",
      UIName: "Doubtful Revenue Percent",
      colStatus: false,
    },
    {
      colName: "ebit_estimate_annual",
      UIName: "Annual EBIT Estimate",
      colStatus: false,
    },
    {
      colName: "ebitdPerShareAnnual",
      UIName: "Annual EBITD Per Share",
      colStatus: false,
    },
    {
      colName: "ebitdPerShareTTM",
      UIName: "EBITD Per Share TTM",
      colStatus: false,
    },
    {
      colName: "enterpriseValue",
      UIName: "Enterprise Value",
      colStatus: false,
    },
    {
      colName: "epsBasicExclExtraItemsTTM",
      UIName: "Basic EPS Excluding Extraordinary Items TTM",
      colStatus: false,
    },
    { colName: "epsGrowth3Y", UIName: "EPS Growth 3 Years", colStatus: false },
    { colName: "epsGrowth5Y", UIName: "EPS Growth 5 Years", colStatus: false },
    {
      colName: "epsGrowthQuarterlyYoy",
      UIName: "EPS Quarterly Growth YoY",
      colStatus: false,
    },
    {
      colName: "epsGrowthTTMYoy",
      UIName: "EPS TTM Growth YoY",
      colStatus: false,
    },
    {
      colName: "epsNormalizedAnnual",
      UIName: "Annual Normalized EPS",
      colStatus: false,
    },
    {
      colName: "equity_to_assets_annual",
      UIName: "Equity to Assets Annual",
      colStatus: false,
    },
    {
      colName: "equity_to_assets_quarterly",
      UIName: "Equity to Assets Quarterly",
      colStatus: false,
    },
    { colName: "ev_fcf", UIName: "EV to Free Cash Flow", colStatus: false },
    {
      colName: "halal_revenue_percent",
      UIName: "Halal Revenue Percent",
      colStatus: false,
    },
    {
      colName: "insiderOwnership",
      UIName: "Insider Ownership",
      colStatus: false,
    },
    {
      colName: "institutionOwnership",
      UIName: "Institution Ownership",
      colStatus: false,
    },
    {
      colName: "interestBearingAssetsRatio",
      UIName: "Interest Bearing Assets Ratio",
      colStatus: false,
    },
    {
      colName: "interestBearingDebtRatio",
      UIName: "Interest Bearing Debt Ratio",
      colStatus: false,
    },
    {
      colName: "intrestbearing_asset_percent",
      UIName: "Interest Bearing Asset Percent",
      colStatus: false,
    },
    {
      colName: "long_term_debt_growth_1y",
      UIName: "Long-Term Debt Growth 1 Year",
      colStatus: false,
    },
    {
      colName: "long_term_debt_growth_3y",
      UIName: "Long-Term Debt Growth 3 Years",
      colStatus: false,
    },
    {
      colName: "long_term_debt_growth_5y",
      UIName: "Long-Term Debt Growth 5 Years",
      colStatus: false,
    },
    {
      colName: "longTermDebt_equityAnnual",
      UIName: "Annual Long Term Debt to Equity",
      colStatus: false,
    },
    {
      colName: "longTermDebt_equityQuarterly",
      UIName: "Quarterly Long Term Debt to Equity",
      colStatus: false,
    },
    {
      colName: "marketCap_change_3y",
      UIName: "Market Cap Change 3 Years",
      colStatus: false,
    },
    {
      colName: "marketCapClassification",
      UIName: "Market Cap Classification",
      colStatus: false,
    },
    {
      colName: "musaffa_esg_ranking",
      UIName: "Musaffa ESG Ranking",
      colStatus: false,
    },
    {
      colName: "musaffa_esg_score",
      UIName: "Musaffa ESG Score",
      colStatus: false,
    },
    {
      colName: "musaffaHalalRating",
      UIName: "Musaffa Halal Rating",
      colStatus: false,
    },
    {
      colName: "musaffaIndustry",
      UIName: "Musaffa Industry",
      colStatus: false,
    },
    { colName: "musaffaSector", UIName: "Musaffa Sector", colStatus: false },
    {
      colName: "net_income_annual",
      UIName: "Annual Net Income",
      colStatus: false,
    },
    {
      colName: "net_income_quarterly",
      UIName: "Quarterly Net Income",
      colStatus: false,
    },
    {
      colName: "netProfitMarginAnnual",
      UIName: "Annual Net Profit Margin",
      colStatus: false,
    },
    {
      colName: "netProfitMarginTTM",
      UIName: "Net Profit Margin TTM",
      colStatus: false,
    },
    {
      colName: "next_earnings_date",
      UIName: "Next Earnings Date",
      colStatus: false,
    },
    {
      colName: "nothalal_revenue_percent",
      UIName: "Non-Halal Revenue Percent",
      colStatus: false,
    },
    {
      colName: "operatingMarginAnnual",
      UIName: "Annual Operating Margin",
      colStatus: false,
    },
    {
      colName: "operatingMarginTTM",
      UIName: "Operating Margin TTM",
      colStatus: false,
    },
    { colName: "payoutRatioTTM", UIName: "Payout Ratio TTM", colStatus: false },
    { colName: "pbQuarterly", UIName: "Quarterly PB", colStatus: false },
    { colName: "pc", UIName: "Price to Cash Flow", colStatus: false },
    { colName: "pcfShareTTM", UIName: "PCF Per Share TTM", colStatus: false },
    {
      colName: "peBasicExclExtraTTM",
      UIName: "Basic PE Excluding Extraordinary TTM",
      colStatus: false,
    },
    {
      colName: "peExclExtraAnnual",
      UIName: "Annual PE Excluding Extraordinary",
      colStatus: false,
    },
    {
      colName: "peExclExtraTTM",
      UIName: "PE Excluding Extraordinary TTM",
      colStatus: false,
    },
    {
      colName: "peInclExtraTTM",
      UIName: "PE Including Extraordinary TTM",
      colStatus: false,
    },
    {
      colName: "peNormalizedAnnual",
      UIName: "Annual Normalized PE",
      colStatus: false,
    },
    {
      colName: "pfcfShareAnnual",
      UIName: "Annual PFCF Per Share",
      colStatus: false,
    },
    { colName: "pfcfShareTTM", UIName: "PFCF Per Share TTM", colStatus: false },
    {
      colName: "pretaxMarginAnnual",
      UIName: "Annual Pre-Tax Margin",
      colStatus: false,
    },
    {
      colName: "price_tangiblebook_value_annual",
      UIName: "Annual Price Tangible Book Value",
      colStatus: false,
    },
    {
      colName: "price_tangiblebook_value_quarterly",
      UIName: "Quarterly Price Tangible Book Value",
      colStatus: false,
    },
    {
      colName: "price_to_tangible_book_ratio_annual",
      UIName: "Annual Price to Tangible Book Ratio",
      colStatus: false,
    },
    {
      colName: "price_to_tangible_book_ratio_quarterly",
      UIName: "Quarterly Price to Tangible Book Ratio",
      colStatus: false,
    },
    {
      colName: "priceChange1M",
      UIName: "Price Change 1 Month",
      colStatus: false,
    },
    {
      colName: "priceChange1MPercent",
      UIName: "Price Change 1 Month Percent",
      colStatus: false,
    },
    {
      colName: "priceChange1W",
      UIName: "Price Change 1 Week",
      colStatus: false,
    },
    {
      colName: "priceChange1WPercent",
      UIName: "Price Change 1 Week Percent",
      colStatus: false,
    },
    {
      colName: "priceChange3M",
      UIName: "Price Change 3 Months",
      colStatus: false,
    },
    {
      colName: "priceChange3MPercent",
      UIName: "Price Change 3 Months Percent",
      colStatus: false,
    },
    {
      colName: "priceChange6M",
      UIName: "Price Change 6 Months",
      colStatus: false,
    },
    {
      colName: "priceChange6MPercent",
      UIName: "Price Change 6 Months Percent",
      colStatus: false,
    },
    {
      colName: "priceChangeYTD",
      UIName: "Price Change Year to Date",
      colStatus: false,
    },
    {
      colName: "priceChangeYTDPercent",
      UIName: "Price Change Year to Date Percent",
      colStatus: false,
    },
    {
      colName: "priceLastUpdated",
      UIName: "Price Last Updated",
      colStatus: false,
    },
    { colName: "psAnnual", UIName: "Annual Price to Sales", colStatus: false },
    { colName: "psTTM", UIName: "Price to Sales TTM", colStatus: false },
    {
      colName: "ptbvAnnual",
      UIName: "Annual Price to Tangible Book Value",
      colStatus: false,
    },
    {
      colName: "ptbvQuarterly",
      UIName: "Quarterly Price to Tangible Book Value",
      colStatus: false,
    },
    {
      colName: "revenue_estimate_annual",
      UIName: "Annual Revenue Estimate",
      colStatus: false,
    },
    {
      colName: "revenue_estimate_quarterly",
      UIName: "Quarterly Revenue Estimate",
      colStatus: false,
    },
    {
      colName: "revenueGrowthQuarterlyYoy",
      UIName: "Quarterly Revenue Growth YoY",
      colStatus: false,
    },
    {
      colName: "revenueGrowthTTMYoy",
      UIName: "Revenue Growth TTM YoY",
      colStatus: false,
    },
    {
      colName: "revenuePerShareAnnual",
      UIName: "Annual Revenue Per Share",
      colStatus: false,
    },
    {
      colName: "revenuePerShareTTM",
      UIName: "Revenue Per Share TTM",
      colStatus: false,
    },
    {
      colName: "revenueShareGrowth5Y",
      UIName: "Revenue Share Growth 5 Years",
      colStatus: false,
    },
    { colName: "roa5Y", UIName: "Return on Assets 5 Years", colStatus: false },
    { colName: "roaRfy", UIName: "Return on Assets Rfy", colStatus: false },
    { colName: "roaTTM", UIName: "Return on Assets TTM", colStatus: false },
    { colName: "ROE", UIName: "Return on Equity", colStatus: false },
    { colName: "roe5Y", UIName: "Return on Equity 5 Years", colStatus: false },
    {
      colName: "roiAnnual",
      UIName: "Annual Return on Investment",
      colStatus: false,
    },
    {
      colName: "sharesOutStanding",
      UIName: "Shares Outstanding",
      colStatus: false,
    },
    {
      colName: "sharia_compliance",
      UIName: "Sharia Compliance",
      colStatus: false,
    },
    { colName: "status", UIName: "Status", colStatus: false },
    {
      colName: "tangibleBookValuePerShareAnnual",
      UIName: "Annual Tangible Book Value Per Share",
      colStatus: false,
    },
    {
      colName: "tangibleBookValuePerShareQuarterly",
      UIName: "Quarterly Tangible Book Value Per Share",
      colStatus: false,
    },
    {
      colName: "total_debt_growth_1y",
      UIName: "Total Debt Growth 1 Year",
      colStatus: false,
    },
    {
      colName: "total_debt_growth_3y",
      UIName: "Total Debt Growth 3 Years",
      colStatus: false,
    },
    {
      colName: "total_debt_growth_5y",
      UIName: "Total Debt Growth 5 Years",
      colStatus: false,
    },
    {
      colName: "totalDebt_totalEquityAnnual",
      UIName: "Annual Total Debt to Equity",
      colStatus: false,
    },
    {
      colName: "totalDebt_totalEquityQuarterly",
      UIName: "Quarterly Total Debt to Equity",
      colStatus: false,
    },
    {
      colName: "totalReturn_1W",
      UIName: "Total Return 1 Week",
      colStatus: false,
    },
    {
      colName: "totalReturn_3Y",
      UIName: "Total Return 3 Years",
      colStatus: false,
    },
    {
      colName: "totalReturn_5Y",
      UIName: "Total Return 5 Years",
      colStatus: false,
    },
    {
      colName: "totalReturn_YTD",
      UIName: "Total Return Year to Date",
      colStatus: false,
    },
  ]);

  const [additionalColCheckedNames, setAdditionalColCheckedNames] = useState(
    additionalColumnConfig
      .filter((col) => col.colStatus)
      .map((col) => col.colName),
  );
  const [tempCheckedNames, setTempCheckedNames] = useState(
    additionalColCheckedNames,
  );
  const [showAdditionalColumnsDropdown, setShowAdditionalColumnsDropdown] = useState(false);
  const [additionalColumnsDropdownPos, setAdditionalColumnsDropdownPos] = useState({
    top: 0,
    left: 0,
  });
  const additionalColumnsButtonRef = useRef(null);
  const additionalColumnsDropdownRef = useRef(null);
  const [pmsColumnLabelMap, setPmsColumnLabelMap] = useState({});
  const additionalColumnsScrollRef = useRef(null);

  const [selectedStock, setSelectedStock] = useState(null);

  const [columnSearch, setColumnSearch] = useState("");
  const sortedColumns = [...additionalColumnConfig].sort((a, b) => {
    const aChecked = tempCheckedNames.includes(a.colName);
    const bChecked = tempCheckedNames.includes(b.colName);

    if (aChecked === bChecked) return 0;
    return aChecked ? -1 : 1; // checked first
  });

  const filteredColumns = sortedColumns.filter((col) =>
    col.UIName.toLowerCase().includes(columnSearch.toLowerCase().trim()),
  );


  
  const handleRowClick = (holding) => {
    setSelectedStock(holding);
  };

  const broker_type = String(
    localStorage.getItem("broker_type") || sharedData?.broker_type || "",
  ).toLowerCase();


  //----------------------------// useEffects //----------------------------//

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  useEffect(() => {
    console.log("//////////activeTab is changed:", activeTab);
  }, [activeTab]);

  useEffect(() => {
    console.log("ggggg1 active tab changed activeTab:", activeTab);
  }, [activeTab]);

  useEffect(() => {
    activeWatchlistIdRef.current = activeWatchlistId;
  }, [activeWatchlistId]);

  useEffect(() => {
    userWatchlistMetaRef.current = userWatchlistMeta;
  }, [userWatchlistMeta]);

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  useEffect(() => {
    console.log("debuggggg updateWatchlistTrigger effect fired", {
      updateWatchlistTrigger,
      tabName,
      activeTab,
    });
    const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
    const brokerFlag = String(
      localStorage.getItem("broker_type") || sharedData?.broker_type || "",
    ).toLowerCase();
    if (!userId || !brokerFlag) {
      console.log("debuggggg missing user context for fetchHoldings", {
        hasUserId: !!userId,
        hasBrokerFlag: !!brokerFlag,
      });
      setIsLoading(false);
      setHoldings([]);
      return;
    }
    // React StrictMode in dev can run effects twice on mount. De-duplicate same trigger.
    const runKey = `${userId}:${brokerFlag}:${updateWatchlistTrigger}`;
    const now = Date.now();
    if (
      lastFetchRunRef.current.key === runKey &&
      now - lastFetchRunRef.current.at < 1200
    ) {
      console.log("debuggggg skipping duplicate fetchHoldings effect", {
        runKey,
      });
      return;
    }
    lastFetchRunRef.current = { key: runKey, at: now };
    fetchHoldings();
  }, [updateWatchlistTrigger]);

  useEffect(() => {
    if (activeTab !== "Top Growth") {
      return undefined;
    }

    const runFetchTopGainers = () => {
      fetchTopGainers(
        sharedData.accessToken,
        sharedData.ClientCode,
        sharedData.api_key,
      );
    };

    runFetchTopGainers();
    const intervalId = setInterval(runFetchTopGainers, 5000);

    return () => clearInterval(intervalId);
  }, [
    activeTab,
    sharedData.accessToken,
    sharedData.ClientCode,
    sharedData.api_key,
  ]);

  useEffect(() => {
    selectedTopGainerCategoryRef.current = selectedCategory;
  }, [selectedCategory]);

  useEffect(() => {
    if (isGrowBroker || isAngelOneBroker) {
      return undefined;
    }

    wsStatusUnsubRef.current = fivePaisaWebSocketService.onStatus(() => {});

    wsPriceUnsubRef.current = fivePaisaWebSocketService.onPrice((tick) => {
      if (tick) handleLivePriceUpdate(tick);
    });

    wsErrorUnsubRef.current = fivePaisaWebSocketService.onError((err) => {
      console.error("WS Service Error:", err);
    });

    mdStoreUnsubRef.current = fivePaisaMarketDepthStore.subscribe((snap) => {
      const details = Array.isArray(snap?.activeDepthData)
        ? snap.activeDepthData
        : [];
      setMarketDepth(details);
    });

    fivePaisaWebSocketService.connect();

    return () => {
      wsStatusUnsubRef.current?.();
      wsPriceUnsubRef.current?.();
      wsErrorUnsubRef.current?.();
      mdStoreUnsubRef.current?.();
      wsStatusUnsubRef.current = null;
      wsPriceUnsubRef.current = null;
      wsErrorUnsubRef.current = null;
      mdStoreUnsubRef.current = null;
    };
  }, [isGrowBroker, isAngelOneBroker]);

  useEffect(() => {
    if (!isAngelOneBroker) {
      return undefined;
    }

    angelWsStatusUnsubRef.current = angelOneWebSocketService.onStatus(() => {});

    angelWsPriceUnsubRef.current = angelOneWebSocketService.onPrice((tick) => {
      if (tick) handleLivePriceUpdate(tick);
    });

    angelWsErrorUnsubRef.current = angelOneWebSocketService.onError((err) => {
      console.error("AngelOne WS Service Error:", err);
    });

    angelOneWebSocketService.connect();

    return () => {
      angelWsStatusUnsubRef.current?.();
      angelWsPriceUnsubRef.current?.();
      angelWsErrorUnsubRef.current?.();
      angelWsStatusUnsubRef.current = null;
      angelWsPriceUnsubRef.current = null;
      angelWsErrorUnsubRef.current = null;
    };
  }, [isAngelOneBroker]);

  useEffect(() => {
    if (!isAngelOneBroker) {
      angelOneMarketDepthService.closeDepth();
      return undefined;
    }

    angelMdServiceUnsubRef.current = angelOneMarketDepthService.subscribe(
      (depth) => {
        setMarketDepth(Array.isArray(depth) ? depth : []);
      },
    );

    return () => {
      angelMdServiceUnsubRef.current?.();
      angelMdServiceUnsubRef.current = null;
      angelOneMarketDepthService.closeDepth();
    };
  }, [isAngelOneBroker]);

  useEffect(() => () => {
    stopWatchlistLiveUpdates();
  }, []);

  // Initialize highlight position on mount
  useEffect(() => {
    const activeButton = document.querySelector(".tab-button.active");
    if (activeButton) {
      updateHighlightPosition(activeButton);
    }
  }, [activeTab]);

  // Add this useEffect - runs sorting check every 10 seconds
  useEffect(() => {
    if (!currentTopGainers || currentTopGainers.length === 0) return;

    const sortInterval = setInterval(() => {
      // ✅ Re-sort every 10 seconds based on live prices
      const autoSortedStocks = [...currentTopGainers].sort((a, b) => {
        const scripCodeA = a.scripcode;
        const scripCodeB = b.scripcode;

        // Get live prices from cache
        const aLivePrice = livePriceCache.current[scripCodeA] || a.ltp;
        const bLivePrice = livePriceCache.current[scripCodeB] || b.ltp;

        // Get previous close prices
        const aPClose =
          livePCloseCache.current[scripCodeA] ||
          findTopGainerStockData(selectedCategory, a)?.prev_price ||
          a.ltp;
        const bPClose =
          livePCloseCache.current[scripCodeB] ||
          findTopGainerStockData(selectedCategory, b)?.prev_price ||
          b.ltp;

        // Calculate live change %
        const aPerChange = ((aLivePrice - aPClose) / aPClose) * 100;
        const bPerChange = ((bLivePrice - bPClose) / bPClose) * 100;

        // Sort by change % descending (highest first)
        return bPerChange - aPerChange;
      });

      // ✅ Update currentTopGainers with sorted data
      setCurrentTopGainers(autoSortedStocks);
      console.log("🔄 [10s] Auto-sorted Top Gainers by live change %");
    }, 10000); // 10 seconds = 10000 milliseconds

    // Cleanup interval on unmount or when dependencies change
    return () => clearInterval(sortInterval);
  }, [selectedCategory, topGainersData]); // Re-create interval if category changes

  // MarketDepth
  useEffect(() => {
    const modalEl = document.getElementById("MarketDepthModal");
    if (modalEl) {
      // Attach event listener
      modalEl.addEventListener("hidden.bs.modal", handleModalClose);
    }
    // Cleanup when component unmounts
    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleModalClose);
      }
    };
  }, []);

  useEffect(() => {
    currentMDModalRef.current = currentMDModal;
  }, [currentMDModal]);

  useEffect(() => {
    console.log("📉New Modal Data: ", currentMDModal);
  }, [currentMDModal]);

  useEffect(() => {
    console.log(
      "✅✅✅New setUpdateWatchlistTrigger: ",
      updateWatchlistTrigger,
    );
  }, [updateWatchlistTrigger]);

  useEffect(() => {
    console.log(
      "📉New additionalColCheckedNames Data: ",
      additionalColCheckedNames,
    );
  }, [additionalColCheckedNames]);

  useEffect(() => {
    console.log("📉New additionalColumnConfig Data: ", additionalColumnConfig);
  }, [additionalColumnConfig]);

  useEffect(() => {
    if (!showAdditionalColumnsDropdown) return undefined;
    const handleOutside = (event) => {
      if (
        !event.target.closest(".watchlist-columns-dropdown") &&
        !event.target.closest(".watchlist-columns-btn")
      ) {
        setShowAdditionalColumnsDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    window.addEventListener("resize", updateAdditionalColumnsDropdownPosition);
    window.addEventListener("scroll", updateAdditionalColumnsDropdownPosition, true);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      window.removeEventListener("resize", updateAdditionalColumnsDropdownPosition);
      window.removeEventListener("scroll", updateAdditionalColumnsDropdownPosition, true);
    };
  }, [showAdditionalColumnsDropdown, updateAdditionalColumnsDropdownPosition]);

  // Click-outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        marketDepthPopoverRef.current &&
        !marketDepthPopoverRef.current.contains(event.target) &&
        marketDepthButtonRef.current &&
        !marketDepthButtonRef.current.contains(event.target)
      ) {
        closeMarketDepthPopover();
      }
    };

    if (showMarketDepth) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMarketDepth]);

  const pingNotification = () => {
    try {
      const audio = new Audio("/sounds/notifications.mp3");
      audio.play().catch((error) => {
        console.error("Failed to play notification sound:", error);
      });
    } catch (error) {
      console.error("Error creating audio:", error);
    }
  };

  // Common toast options
  const toastOptions = {
    position: "top-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "light",
  };

  // Success toast function
  const showSuccessToast = (message) => {
    toast.success(message, {
      ...toastOptions,
      icon: "✅",
    });
    pingNotification();
  };

  // Error toast function
  const showErrorToast = (message) => {
    toast.error(message, {
      ...toastOptions,
      icon: "⚠️",
    });
    pingNotification();
  };

  // Error toast function
  const showWarningToast = (message) => {
    toast.warn(message, {
      ...toastOptions,
      icon: "⚠️",
    });
    pingNotification();
  };

  const handleMarketDepthClick = (holding, e) => {
    const button = e.currentTarget;
    const buttonRect = button.getBoundingClientRect();

    const popoverWidth = 480;
    const popoverHeight = 500;
    const padding = 16;

    let left = buttonRect.left - popoverWidth - 12;
    let top = buttonRect.top - 20;

    // Check if popover goes off-screen on the left
    if (left < padding) {
      left = buttonRect.right + 12;
    }

    // Check if popover goes off-screen on top
    if (top < padding) {
      top = buttonRect.top + buttonRect.height + 12;
    }

    // Check if popover goes off-screen on bottom
    if (top + popoverHeight > window.innerHeight - padding) {
      top = window.innerHeight - popoverHeight - padding;
    }

    // Check if popover goes off-screen on right
    if (left + popoverWidth > window.innerWidth - padding) {
      left = window.innerWidth - popoverWidth - padding;
    }

    setMarketDepthPosition({
      top: Math.max(padding, top),
      left: Math.max(padding, left),
    });
    setShowMarketDepth(true);
    setcurrentMDModal(holding);
    if (isAngelOneBroker) {
      const cachedDepth = Array.isArray(holding?.marketDepth)
        ? holding.marketDepth
        : normalizeAngelMarketDepth(holding?.market_quote?.depth);
      if (cachedDepth.length) {
        setMarketDepth(cachedDepth);
      }
    }
    subscribeToMarketDepth(holding);
  };

  //----------------------------//  New watchlist Functions //----------------------------//
  const handleCreateWatchlist = async () => {
    // Clear previous errors
    setWatchlistError("");

    // Trim input
    const trimmedName = newWatchlistName.trim();

    // Validation
    if (!trimmedName) {
      setWatchlistError(tr("watchlistNameCannotBeEmpty"));
      return;
    }

    if (trimmedName.length > 30) {
      setWatchlistError(tr("watchlistNameUnder30"));
      return;
    }

    // Check for duplicates (case-insensitive)
    const isDuplicate = userWatchlists.some(
      (name) => name.toLowerCase() === trimmedName.toLowerCase(),
    );

    if (isDuplicate) {
      setWatchlistError(tr("watchlistNameAlreadyExists"));
      return;
    }

    // Check limit
    if (userWatchlists.length >= 5) {
      setWatchlistError(tr("maximum5WatchlistsAllowed"));
      return;
    }

    // API call
    try {
      const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      const brokerFlag = String(
        localStorage.getItem("broker_type") || sharedData?.broker_type || "",
      ).toLowerCase();
      if (!userId || !brokerFlag) {
        setWatchlistError(tr("failedToCreateWatchlist"));
        return;
      }

      const response = await fetch(
        `${pmsApiBaseUrl}/api/v1/watchlist/create`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_id: userId,
            broker_flag: brokerFlag,
            watchlist_name: trimmedName,
          }),
        },
      );

      const data = await response.json();
      const apiData = data?.data || {};
      const status = String(apiData?.status || "").toLowerCase();
      const message = apiData?.message || tr("failedToCreateWatchlist");

      if (status === "success") {
        // Show success message
        showSuccessToast(message);

        // Clear input and errors
        setNewWatchlistName("");
        setWatchlistError("");

        // ✅ Close modal programmatically using Bootstrap's data-bs-dismiss
        const closeButton = document.querySelector(
          '#createNewWatchlistModal [data-bs-dismiss="modal"]',
        );
        if (closeButton) {
          closeButton.click();
        }

        // Switch to new watchlist and refresh via new watchlist/list flow.
        setActiveTab(trimmedName);
        setActiveWatchlistId(null);
        await fetchHoldings({ watchlistName: trimmedName });
      } else {
        setWatchlistError(message);
      }
    } catch (error) {
      console.error("Error creating watchlist:", error);
      setWatchlistError(tr("failedToCreateWatchlist"));
    }
  };

  //----------------------------//  target % notification Functions //----------------------------//
  const checkStockTargets = () => {
    holdings.forEach((holding) => {
      const target = parseFloat(holding.targetPrice);
      const initial = parseFloat(holding.initialPrice);
      const scripCode = holding.ScripCode;
      const livePrice = parseFloat(livePriceCache.current[scripCode]);
      const currentPrice = !isNaN(livePrice)
        ? livePrice
        : parseFloat(holding["Current Price"]);

      // Skip if any values are invalid
      if (
        isNaN(target) ||
        isNaN(initial) ||
        target === initial ||
        isNaN(currentPrice)
      ) {
        return;
      }

      const targetLogic = holding.target_logic;
      let percent;

      // Calculate target percentage
      if (targetLogic === "lower_target") {
        percent = 100 - ((currentPrice - target) / target) * 100;
      } else {
        percent = ((currentPrice - target) / target) * 100 + 100;
      }

      // Check if target reached (>= 100%) and not yet notified
      if (percent >= 100 && holding.isNotified === 0) {
        // Call API to send notification
        const payload = {
          userId: holding.userId,
          source: "watchlist", // or wherever this data comes from (watchlist, portfolio, etc.)
          scripcode: holding.scripcode,
          exch: holding?.exch?.charAt(0),
          exchType: holding?.exchType?.charAt(0),
          name: holding.name,
          FullName: holding.FullName || holding.name,
          targetPrice: holding.targetPrice,
          initialPrice: holding.initialPrice,
          target_logic: holding.target_logic,
        };

        fetch(
          "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=notifyWatchlistTarget",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.status === "success") {
              console.log(
                `✅ Notification sent successfully for ${holding.name}`,
              );
              showSuccessToast(
                `Hurry!, ${holding.name} has reached the target percentage`,
              );

              // Update local state to reflect isNotified = 1
              holding.isNotified = 1;
              setUpdateWatchlistTrigger(updateWatchlistTrigger + 1);
            } else {
              console.error("❌ Notification failed:", data.message);
            }
          })
          .catch((error) => {
            console.error("❌ Error sending notification:", error);
          });

        console.log(`✅ Target notification triggered for ${holding.name}`);
      }
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      checkStockTargets();
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval); // Cleanup
  }, [holdings, livePriceCache]);

  const openAdditionalColumnsDropdown = (event) => {
    const anchor = event?.currentTarget || additionalColumnsButtonRef.current;
    if (!anchor) return;
    setColumnSearch("");
    const rect = anchor.getBoundingClientRect();
    const popoverWidth = 320;
    const viewportPadding = 10;
    const left = Math.min(
      Math.max(viewportPadding, rect.right - popoverWidth),
      window.innerWidth - popoverWidth - viewportPadding,
    );
    setAdditionalColumnsDropdownPos({
      top: rect.bottom + 8,
      left,
    });
    setShowAdditionalColumnsDropdown(true);
  };

  function updateAdditionalColumnsDropdownPosition() {
    const anchor = additionalColumnsButtonRef.current;
    if (!anchor) return;
    const rect = anchor.getBoundingClientRect();
    const popoverWidth = 320;
    const viewportPadding = 10;
    const left = Math.min(
      Math.max(viewportPadding, rect.right - popoverWidth),
      window.innerWidth - popoverWidth - viewportPadding,
    );
    setAdditionalColumnsDropdownPos({
      top: rect.bottom + 8,
      left,
    });
  }

  const applyAdditionalColumnsSelection = async (checkedNames) => {
    try {
      const orderedDefaultCols = columnOrder.filter((col) =>
        defaultColumns.includes(col),
      );
      const additionalCols = checkedNames.filter(
        (col) => !defaultColumns.includes(col),
      );
      const newColOrder = [...orderedDefaultCols, ...additionalCols];

      setTempCheckedNames(checkedNames);
      setAdditionalColCheckedNames(checkedNames);
      setColumnOrder(newColOrder);
      setAdditionalColumnConfig((prev) =>
        prev.map((col) => ({
          ...col,
          colStatus: checkedNames.includes(col.colName),
        })),
      );

      await appendSelectedExtraColumns(checkedNames);
      await saveColumnOrder(newColOrder);
      setUpdateWatchlistTrigger((prev) => prev + 1);
    } catch (error) {
      console.error("❌ Error applying columns:", error);
    }
  };

  // Checkbox change handler (instant apply)
  const handleCheckboxChange = (colName, isChecked) => {
    const nextChecked = isChecked
      ? [...tempCheckedNames, colName]
      : tempCheckedNames.filter((name) => name !== colName);
    applyAdditionalColumnsSelection(Array.from(new Set(nextChecked)));
  };

  const resetColumnOrder = async () => {
    try {
      const userId =
        Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      const userEmail =
        sharedData?.Email_ID ||
        sharedData?.email ||
        localStorage.getItem("email") ||
        "";
      const pmsBrokerFlag = isGrowBroker ? "grow" : "5paisa";
      if (!userId || !userEmail) {
        console.warn("resetColumnOrder: missing user context");
        return;
      }

      const response = await fetch(`${pmsApiBaseUrl}/api/v1/columns/order/reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          broker_flag: pmsBrokerFlag,
          module_name: "watchlist",
          user_id: userId,
          email: userEmail,
        }),
      });

      if (!response.ok) {
        let errorMsg = `HTTP error! status: ${response.status}`;
        try {
          const errorData = await response.json();
          if (errorData && errorData.message) {
            errorMsg = errorData.message;
          }
        } catch { }
        throw new Error(errorMsg);
      }

      const data = await response.json();

      if (data?.data?.status === "success") {
        console.log("✅ Column order reset successfully");
        setTempCheckedNames([]);
        setAdditionalColCheckedNames([]);
        setColumnOrder(defaultColumns);
        setAdditionalColumnConfig((prev) =>
          prev.map((col) => ({ ...col, colStatus: false })),
        );
        setUpdateWatchlistTrigger((prev) => prev + 1);
      } else {
        console.error("❌ Failed to reset columns: ", data);
      }
    } catch (error) {
      console.error("❌ Error resetting column order:", error);
    }
  };

  // Add this useEffect to detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1099);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Add this handler for dropdown
  const handleDropdownChange = (e) => {
    const selectedTab = e.target.value;
    setActiveTab(selectedTab);
    const isStaticTab = staticWatchlistTabs.includes(selectedTab);
    if (!isStaticTab) {
      const selectedMeta = (userWatchlistMetaRef.current || []).find(
        (item) => item.name === selectedTab,
      );
      const nextWatchlistId = selectedMeta?.id || null;
      setActiveWatchlistId(nextWatchlistId);
      activeWatchlistIdRef.current = nextWatchlistId;
      fetchHoldings({
        watchlistId: nextWatchlistId,
        watchlistName: selectedTab,
        skipList: true,
      });
    } else {
      // Invalidate any in-flight watchlist-data request so it cannot override static tab selection.
      watchlistFetchIdRef.current += 1;
      setActiveWatchlistId(null);
    }
  };

  const handleTabClick = (tab, event) => {
    setActiveTab(tab);
    updateHighlightPosition(event.currentTarget);
    const isStaticTab = staticWatchlistTabs.includes(tab);
    if (!isStaticTab) {
      const selectedMeta = (userWatchlistMetaRef.current || []).find(
        (item) => item.name === tab,
      );
      const nextWatchlistId = selectedMeta?.id || null;
      setActiveWatchlistId(nextWatchlistId);
      activeWatchlistIdRef.current = nextWatchlistId;
      fetchHoldings({
        watchlistId: nextWatchlistId,
        watchlistName: tab,
        skipList: true,
      });
    } else {
      // Invalidate any in-flight watchlist-data request so it cannot override static tab selection.
      watchlistFetchIdRef.current += 1;
      setActiveWatchlistId(null);
    }
  };

  const handleTabHover = (_tab, event) => {
    updateHighlightPosition(event.currentTarget);
  };

  const handleTabLeave = () => {
    const activeButton = document.querySelector(".tab-button.active");
    if (activeButton) {
      updateHighlightPosition(activeButton);
    }
  };

  const updateHighlightPosition = (button) => {
    if (!button?.closest) return;
    const container = button.closest(".tabs-scroll");
    if (!container) return;
    const containerRect = container.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();

    setHighlightPosition({
      left: buttonRect.left - containerRect.left,
      width: buttonRect.width,
    });
  };

  const sendMessageToWebSocket = (
    holding,
    clientCode,
    status = "Watchlist",
  ) => {
    if (isGrowBroker) return;
    const getFirstChar = (val) => {
      if (val == null) return "";
      const str = String(val);
      return str.length ? str.charAt(0) : "";
    };

    let ScripCode = 0;
    if (status === "Search") {
      ScripCode =
        Number(holding.Scripcode) ||
        Number(holding.ScripCode) ||
        Number(holding.scripcode) ||
        0;
    } else {
      ScripCode = Number(holding.scripcode) || Number(holding.ScripCode) || 0;
    }

    const exch = getFirstChar(holding.exch ?? holding.Exch);
    const exchType = getFirstChar(holding.exchType ?? holding.ExchType);

    if (!ScripCode || !exch || !exchType) {
      console.warn("⚠️ Skipping Top Gainers websocket subscription:", holding);
      return;
    }

    fivePaisaWebSocketService.subscribeMarketFeed([
      { Exch: exch, ExchType: exchType, ScripCode },
    ]);
    console.log(`✅ Subscribed to ${holding.name} (${ScripCode})`);

    if (!subscribedScripCodes.current) {
      subscribedScripCodes.current = new Set();
    }
    subscribedScripCodes.current.add(ScripCode);
  };


  const handleLivePriceUpdate = (data) => {
    const {
      Token: scriptCode,
      LastRate: lastRateValue,
      PClose,
      Volume,
      High, // ✅ Added
      Low, // ✅ Added
    } = data;

    if (!scriptCode || lastRateValue === undefined) return;

    if (!livePriceCache.current) livePriceCache.current = {};
    if (!livePCloseCache.current) livePCloseCache.current = {};
    if (!liveDiffCache.current) liveDiffCache.current = {};
    if (!liveChangePercentageCache.current)
      liveChangePercentageCache.current = {};
    if (!liveVolumeCache.current) liveVolumeCache.current = {};
    if (!livePLCache.current) livePLCache.current = {};
    if (!liveHighCache.current) liveHighCache.current = {}; // ✅ Added
    if (!liveLowCache.current) liveLowCache.current = {}; // ✅ Added

    livePriceCache.current[scriptCode] = lastRateValue;
    livePCloseCache.current[scriptCode] = PClose;
    liveDiffCache.current[scriptCode] = lastRateValue - PClose;
    liveChangePercentageCache.current[scriptCode] =
      ((lastRateValue - PClose) / PClose) * 100;
    liveVolumeCache.current[scriptCode] = Volume;
    liveHighCache.current[scriptCode] = High; // ✅ Added
    liveLowCache.current[scriptCode] = Low; // ✅ Added

    const totalPL = lastRateValue - PClose;
    livePLCache.current[scriptCode] =
      `${totalPL.toFixed(2)} (${liveChangePercentageCache.current[scriptCode].toFixed(2)}%)`;

    // Throttle UI re-rendering: websocket can push many ticks and full table
    // renders can lag, leaving some rows at stale/0 values briefly.
    if (!liveRerenderTimeoutRef.current) {
      liveRerenderTimeoutRef.current = setTimeout(() => {
        liveRerenderTimeoutRef.current = null;
        setLiveUpdateTrigger((prev) => prev + 1);
      }, 200);
    }
  };

  /**
   * Fetch Top Gainers Data from NSE API
   */
  const normalizeTopGainerCategoryLabel = (categoryKey, legends = []) => {
    const matchedLegend = legends.find(([key]) => key === categoryKey);
    return matchedLegend?.[1] || categoryKey;
  };

  const normalizeTopGainerCategories = (categories = {}, legends = []) => {
    return Object.fromEntries(
      Object.entries(categories).map(([categoryKey, categoryValue]) => {
        const rawStocks = Array.isArray(categoryValue?.data) ? categoryValue.data : [];
        const normalizedStocks = rawStocks.map((stock, index) => {
          const fallbackScripCode = `${categoryKey}:${stock.symbol}:${index}`;

          return {
            ...stock,
            rank: stock.rank ?? index + 1,
            ScripCode: stock.ScripCode ?? fallbackScripCode,
            FullName: stock.FullName || stock.fullName || stock.symbol || "-",
            Exch: stock.Exch || (stock.market_type === "B" ? "B" : "N"),
            ExchType: stock.ExchType || "C",
            __lookupKey: String(stock.ScripCode ?? fallbackScripCode),
          };
        });

        return [
          categoryKey,
          {
            label:
              categoryValue?.label ||
              normalizeTopGainerCategoryLabel(categoryKey, legends),
            key: categoryValue?.key || categoryKey,
            data: normalizedStocks,
            count: categoryValue?.count ?? normalizedStocks.length,
            timestamp: categoryValue?.timestamp || "",
          },
        ];
      }),
    );
  };

  const mapTopGainerStocksForView = (categoryData = []) => {
    return categoryData.map((stock) => ({
      scripcode: stock.ScripCode,
      name: stock.symbol,
      fullName: stock.FullName || stock.symbol,
      exch: stock.Exch,
      exchType: stock.ExchType,
      ltp: stock.ltp,
      perChange: stock.perChange,
      symbol: stock.symbol,
      rank: stock.rank,
    }));
  };

  const findTopGainerStockData = (categoryKey, stock) => {
    const categoryStocks = topGainersData?.[categoryKey]?.data || [];
    const stockScripCode = String(stock?.scripcode ?? stock?.ScripCode ?? "");
    const stockSymbol = String(stock?.symbol ?? "");

    return categoryStocks.find((item) => {
      const itemScripCode = String(
        item?.ScripCode ?? item?.__lookupKey ?? "",
      );
      return itemScripCode === stockScripCode || item?.symbol === stockSymbol;
    });
  };

  const fetchTopGainers = async (AccessToken, ClientCode, api_key) => {
    const shouldShowLoader = !topGainersInitialLoadDoneRef.current;
    if (shouldShowLoader) {
      setIsLoadingTopGainers(true);
    }
    const url = "https://pmsapi.infomanav.in/api/v1/top-gainers";

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" },
      });

      let responseData;
      try {
        responseData = await response.json();
      } catch (parseError) {
        console.warn("Non-JSON response received:", await response.text());
        if (shouldShowLoader) {
          setTopGainersData(null);
          setSelectedCategory("allSec");
        }
        setIsLoadingTopGainers(false);
        return;
      }

      // ⭐ Check if response is successful
      if (responseData.status !== "success" || !responseData.data) {
        console.error("❌ Invalid response:", responseData);
        if (shouldShowLoader) {
          setTopGainersData(null);
        }
        setIsLoadingTopGainers(false);
        return;
      }

      // ⭐ Normalize new API response to the old UI shape
      const categoriesData = normalizeTopGainerCategories(
        responseData.data.categories,
        responseData.data.legends,
      );

      setTopGainersData(categoriesData);
      topGainersInitialLoadDoneRef.current = true;
      console.log(
        "✅ Top Gainers Data Fetched:",
        Object.keys(categoriesData).length,
        "categories",
      );

      // ⭐ Get stocks from selected category (default: allSec)
      const activeCategory = selectedTopGainerCategoryRef.current || "allSec";
      let selectedCategoryData = categoriesData[activeCategory]?.data || [];

      // ⭐ FIX: Filter out negative gainers from "Top Growth" tab (keep only perChange > 0)
      if (activeCategory === "allSec") {
        selectedCategoryData = selectedCategoryData.filter(
          (stock) => stock.perChange > 0,
        );
        console.log(
          "🔥 Filtered allSec to positive gainers only:",
          selectedCategoryData.length,
          "stocks",
        );
      }

      if (selectedCategoryData.length > 0) {
        // ⭐ Transform to match watchlist format for WebSocket
        const topGainersStocks = mapTopGainerStocksForView(selectedCategoryData);

        setCurrentTopGainers(topGainersStocks);
        console.log(
          "📊 Category:",
          activeCategory,
          "-",
          topGainersStocks.length,
          "stocks with ScripCode",
        );

        // ⭐ Subscribe to WebSocket when ready
        const subscribeWhenReady = () => {
          const checkConnection = () => {
            if (fivePaisaWebSocketService.isConnected()) {
              console.log("🚀 WebSocket ready, subscribing to Top Gainers...");

              topGainersStocks.forEach((stock) => {
                if (Number(stock.scripcode) > 0) {
                  sendMessageToWebSocket(stock, ClientCode, "TopGainers");
                }
              });

              console.log(
                "✅ Subscribed to",
                topGainersStocks.length,
                "top gainers",
              );
            } else {
              console.log(
                "⏳ Waiting for WebSocket connection for Top Gainers...",
              );
              setTimeout(checkConnection, 500);
            }
          };

          // Start checking after 1 second
          setTimeout(checkConnection, 1000);
        };

        subscribeWhenReady();
        setIsLoadingTopGainers(false);
      } else {
        console.warn("⚠️ No stocks found in selected category");
        setIsLoadingTopGainers(false);
      }
    } catch (error) {
      console.error("❌ Error fetching Top Gainers:", error);
      if (shouldShowLoader) {
        setTopGainersData(null);
        setCurrentTopGainers([]);
      }
      setIsLoadingTopGainers(false);
    }
  };

  /**
   * Handle category change (All Securities, NIFTY, Bank Nifty, etc.)
   */
  const handleCategoryChange = (categoryKey) => {
    if (!topGainersData || !topGainersData[categoryKey]) {
      console.warn("⚠️ Category not found:", categoryKey);
      return;
    }

    selectedTopGainerCategoryRef.current = categoryKey;
    setSelectedCategory(categoryKey);
    const categoryData = topGainersData[categoryKey].data;

    // Transform to match watchlist format (only stocks with ScripCode)
    const topGainersStocks = mapTopGainerStocksForView(categoryData);

    setCurrentTopGainers(topGainersStocks);
    console.log(
      "🔄 Category changed to:",
      categoryKey,
      "-",
      topGainersStocks.length,
      "stocks",
    );

    // ⭐ Re-subscribe to WebSocket for new category
    if (fivePaisaWebSocketService.isConnected()) {
      topGainersStocks.forEach((stock) => {
        if (Number(stock.scripcode) > 0) {
          sendMessageToWebSocket(stock, sharedData.ClientCode, "TopGainers");
        }
      });
      console.log("✅ Re-subscribed to", topGainersStocks.length, "stocks");
    }
  };

  const fetchHoldings = async (options = {}) => {
    const fetchId = ++watchlistFetchIdRef.current;
    setIsLoading(true);

    const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
    const brokerFlag = String(
      localStorage.getItem("broker_type") || sharedData?.broker_type || "",
    ).toLowerCase();
    const adapter = getWatchlistAdapter(brokerFlag);

    if (!userId || !brokerFlag) {
      setTabs([...staticWatchlistTabs]);
      setActiveTab(staticWatchlistTabs[0]);
      setHoldings([]);
      setIsLoading(false);
      return;
    }

    const userEmail =
      sharedData?.Email_ID ||
      sharedData?.email ||
      localStorage.getItem("email") ||
      "";
    const pmsBrokerFlag = brokerFlag === "grow" ? "grow" : "5paisa";

    try {
      if (userEmail) {
        try {
          const extraColsResponse = await fetch(
            `${pmsApiBaseUrl}/api/v1/columns/extra`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                user_id: userId,
                email: userEmail,
                broker_flag: pmsBrokerFlag,
                module_name: "watchlist",
              }),
            },
          );
          const extraColsPayload = await extraColsResponse.json();
          const extraColsData = extraColsPayload?.data;
          const extraCols = Array.isArray(extraColsData?.columns)
            ? extraColsData.columns
            : [];
          if (extraColsData?.status === "success" && extraCols.length) {
            const mappedAdditionalCols = extraCols
              .map((c) => {
                const colName = String(c?.column_key || "").trim();
                if (!colName) return null;
                return {
                  colName,
                  UIName: String(c?.column_label || colName).trim(),
                  colStatus: Number(c?.is_selected) === 1,
                };
              })
              .filter(Boolean);

            setAdditionalColumnConfig(mappedAdditionalCols);

            const selectedExtraCols = mappedAdditionalCols
              .filter((c) => c.colStatus)
              .map((c) => c.colName);
            setAdditionalColCheckedNames(selectedExtraCols);
            setTempCheckedNames(selectedExtraCols);
          }
        } catch (extraErr) {
          console.warn("Failed to fetch extra watchlist columns from PMS", extraErr);
        }

        const colOrderResponse = await fetch(
          `${pmsApiBaseUrl}/api/v1/columns/list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              user_id: userId,
              email: userEmail,
              broker_flag: pmsBrokerFlag,
              module_name: "watchlist",
            }),
          },
        );
        const colOrderPayload = await colOrderResponse.json();
        const colData = colOrderPayload?.data;
        const apiColumns = colData?.columns;
        if (colData?.status === "success" && Array.isArray(apiColumns)) {
          const nextLabelMap = {};
          for (const c of apiColumns) {
            const mappedCol = mapWatchlistPmsColumnToTableCol(
              c?.column_key,
              c?.column_label,
            );
            const label = String(c?.column_label || "").trim();
            if (mappedCol && label) nextLabelMap[mappedCol] = label;
          }
          setPmsColumnLabelMap(nextLabelMap);

          const nextOrder = buildWatchlistTableColumnOrderFromPms(apiColumns);
          if (nextOrder?.length) {
            setColumnOrder(nextOrder);
            setColumns(nextOrder);

            const additionalColsFromAPI = nextOrder.filter(
              (col) => !defaultColumns.includes(col),
            );
            setAdditionalColumnConfig((prevConfig) =>
              prevConfig.map((col) => ({
                ...col,
                colStatus: false,
              })),
            );
            setAdditionalColumnConfig((prevConfig) =>
              prevConfig.map((col) => ({
                ...col,
                colStatus: additionalColsFromAPI.includes(col.colName)
                  ? true
                  : col.colStatus,
              })),
            );
          } else {
            console.warn(
              "PMS watchlist columns empty after mapping, using default",
            );
          }
        } else {
          console.warn("Failed to fetch column order from PMS, using default");
        }
      }
    } catch (error) {
      console.error("Error fetching watchlist column order:", error);
    }

    try {
      let watchlistMeta = [];
      if (options?.skipList === true) {
        watchlistMeta = Array.isArray(userWatchlistMetaRef.current)
          ? userWatchlistMetaRef.current
          : [];
      } else {
        const listResponse = await fetch(`${pmsApiBaseUrl}/api/v1/watchlist/list`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_id: userId,
            broker_flag: brokerFlag,
          }),
        });
        const listJson = await listResponse.json();
        const listData = listJson?.data || {};
        let watchlists = Array.isArray(listData?.watchlists) ? listData.watchlists : [];

        // Auto-create the first watchlist when user has none, then refetch list.
        if (watchlists.length === 0) {
          try {
            await fetch(`${pmsApiBaseUrl}/api/v1/watchlist/create`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                user_id: userId,
                broker_flag: brokerFlag,
                watchlist_name: "First Watchlist",
              }),
            });

            const refetchResponse = await fetch(`${pmsApiBaseUrl}/api/v1/watchlist/list`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                user_id: userId,
                broker_flag: brokerFlag,
              }),
            });
            const refetchJson = await refetchResponse.json();
            const refetchData = refetchJson?.data || {};
            watchlists = Array.isArray(refetchData?.watchlists)
              ? refetchData.watchlists
              : [];
          } catch (createError) {
            console.error("Error auto-creating first watchlist:", createError);
          }
        }

        watchlistMeta = watchlists
          .map((item) => ({
            id: String(item?.id || "").trim(),
            name: String(item?.watchlist_name || "").trim(),
          }))
          .filter((item) => item.id && item.name);
      }

      if (fetchId !== watchlistFetchIdRef.current) return;

      if (options?.skipList !== true) {
        setUserWatchlistMeta(watchlistMeta);
        setUserWatchlists(watchlistMeta.map((item) => item.name));
        setTabs([...watchlistMeta.map((item) => item.name), ...staticWatchlistTabs]);
      }

      if (!watchlistMeta.length) {
        stopWatchlistLiveUpdates();
        setActiveWatchlistId(null);
        setTabs([...staticWatchlistTabs]);
        setActiveTab(staticWatchlistTabs[0]);
        setHoldings([]);
        setIsLoading(false);
        setLiveUpdateTrigger((prev) => prev + 1);
        return;
      }

      const preferredWatchlistId = String(options?.watchlistId || "").trim();
      const preferredWatchlistName = String(options?.watchlistName || "").trim();
      const isTabSwitchFetch = options?.skipList === true;
      const selectedWatchlist = isTabSwitchFetch
        ? watchlistMeta.find(
          (item) =>
            String(item.id) === preferredWatchlistId ||
            item.name === preferredWatchlistName,
        )
        : watchlistMeta.find(
          (item) =>
            String(item.id) === preferredWatchlistId ||
            item.name === preferredWatchlistName ||
            String(item.id) === String(activeWatchlistIdRef.current || "") ||
            item.name === activeTab,
        ) || watchlistMeta[0];

      if (!selectedWatchlist) {
        // During dynamic tab switch, never fallback to another watchlist.
        setIsLoading(false);
        return;
      }
      const selectedWatchlistName = selectedWatchlist.name;
      const selectedWatchlistId = selectedWatchlist.id;

      if (!isTabSwitchFetch) {
        setActiveTab(selectedWatchlistName);
      }
      setActiveWatchlistId(selectedWatchlistId);
      activeWatchlistIdRef.current = selectedWatchlistId;

      const dataResponse = await fetch(`${pmsApiBaseUrl}/api/v1/watchlist/data`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          watchlist_id: Number(selectedWatchlistId),
          user_id: userId,
          flag: brokerFlag,
          // search:"",
          search: String(options?.search ?? watchlistSearchQuery ?? "").trim(),
        }),
      });
      const dataJson = await dataResponse.json();
      const dataPayload = dataJson?.data || {};
      const rawSymbols = Array.isArray(dataPayload?.symbols) ? dataPayload.symbols : [];

      if (fetchId !== watchlistFetchIdRef.current) return;

      const normalizedHoldings = adapter.normalizeWatchlistRows(
        rawSymbols,
        selectedWatchlistName,
      );

      stopWatchlistLiveUpdates();
      livePriceCache.current = {};
      livePCloseCache.current = {};
      liveDiffCache.current = {};
      liveChangePercentageCache.current = {};
      liveVolumeCache.current = {};
      livePLCache.current = {};
      liveHighCache.current = {};
      liveLowCache.current = {};

      normalizedHoldings.forEach((holding) => {
        const cacheKey =
          brokerFlag === "angelone"
            ? String(holding?.token || holding?.Token || "").trim()
            : Number(holding?.ScripCode || holding?.scripcode || 0);
        if (!cacheKey) return;
        const mq = holding?.market_quote || {};
        const ltp = Number(
          holding?.["Current Price"] ||
            holding?.CurrentPrice ||
            holding?.ltp ||
            mq?.ltp ||
            0,
        );
        if (Number.isFinite(ltp) && ltp > 0) {
          livePriceCache.current[cacheKey] = ltp;
          const pClose = Number(holding?.PClose || mq?.close || ltp);
          if (Number.isFinite(pClose)) {
            livePCloseCache.current[cacheKey] = pClose;
            const diff = Number.isFinite(holding?.netChange)
              ? Number(holding.netChange)
              : ltp - pClose;
            liveDiffCache.current[cacheKey] = diff;
            liveChangePercentageCache.current[cacheKey] =
              Number.isFinite(holding?.netChangePercent)
                ? Number(holding.netChangePercent)
                : pClose !== 0
                  ? (diff / pClose) * 100
                  : 0;
          }
          if (Number.isFinite(mq?.high)) {
            liveHighCache.current[cacheKey] = Number(mq.high);
          }
          if (Number.isFinite(mq?.low)) {
            liveLowCache.current[cacheKey] = Number(mq.low);
          }
        }
      });

      setHoldings(normalizedHoldings);
      lastSubscribedHoldings.current = normalizedHoldings;

      if (brokerFlag === "5paisa" && normalizedHoldings.length > 0) {
        const wsItems = normalizedHoldings
          .map((holding) => ({
            Exch: String(holding?.Exch || "").charAt(0),
            ExchType: String(holding?.ExchType || "C").charAt(0),
            ScripCode: Number(holding?.ScripCode || holding?.scripcode || 0),
          }))
          .filter((item) => item.Exch && item.ExchType && item.ScripCode);

        fivePaisaWebSocketService.connect();
        chunkItems(wsItems, 50).forEach((batch) => {
          fivePaisaWebSocketService.subscribeMarketFeed(batch);
          watchlistWsSubscriptionsRef.current = [
            ...watchlistWsSubscriptionsRef.current,
            ...batch,
          ];
        });
      } else if (brokerFlag === "grow" && normalizedHoldings.length > 0) {
        const pollingKeys = normalizedHoldings
          .map((holding) => getGrowPollingKeyFromHolding(holding))
          .filter(Boolean);
        growwLivePriceService.setSymbols(GROW_POLL_SOURCE, pollingKeys);
        growWatchlistUnsubscribeRef.current = growwLivePriceService.subscribe((payload) => {
          let updated = false;
          normalizedHoldings.forEach((holding) => {
            const key = getGrowPollingKeyFromHolding(holding);
            if (!key) return;
            const ltp = Number(payload?.[key]);
            const cacheKey = Number(holding?.ScripCode || holding?.scripcode || 0);
            if (!cacheKey || !Number.isFinite(ltp)) return;
            livePriceCache.current[cacheKey] = ltp;
            updated = true;
          });
          if (updated) setLiveUpdateTrigger((prev) => prev + 1);
        });
        growwLivePriceService.startPolling(1000);
      } else if (brokerFlag === "angelone" && normalizedHoldings.length > 0) {
        const wsItems = normalizedHoldings
          .map((holding) => ({
            exchangeType: getAngelExchangeTypeFromHolding(holding),
            token: String(
              holding?.token || holding?.Token || holding?.script_code || "",
            ).trim(),
          }))
          .filter((item) => item.exchangeType && item.token);

        angelOneWebSocketService.connect();
        chunkItems(wsItems, 50).forEach((batch) => {
          angelOneWebSocketService.subscribeMarketFeed(batch);
          angelWatchlistWsSubscriptionsRef.current = [
            ...angelWatchlistWsSubscriptionsRef.current,
            ...batch,
          ];
        });
      }

      setIsLoading(false);
      setLiveUpdateTrigger((prev) => prev + 1);
    } catch (error) {
      console.error("Error fetching watchlist data:", error);
      if (fetchId === watchlistFetchIdRef.current) {
        stopWatchlistLiveUpdates();
        setTabs([...staticWatchlistTabs]);
        setActiveTab(staticWatchlistTabs[0]);
        setHoldings([]);
        setIsLoading(false);
      }
    }
  };


  const handlePreview = () => setIsPreview(true);
  const handleGoBack = () => setIsPreview(false);

  const SettingBuyModalDetails = (stockData, Type) => {
    setBuySellModalDetails((prevState) => ({
      ...prevState,
      FullName: stockData.FullName || stockData.fullName || "",
      Symbol: stockData.Symbol || stockData.symbol || stockData.name || "",
      Type: Type,
      OrderQty: 1,
      LimitPrice: 0,
      order: stockData, // store complete order object
    }));
  };

  const openBuySellFromStockPreview = (stockData, Type) => {
    if (!stockData) return;
    setIsPreview(false);
    SettingBuyModalDetails(stockData, Type);
    const el = document.getElementById("BuySellModal");
    if (!el) return;
    // Preview page sits above default Bootstrap modal stacking — lift ticket above it
    el.style.zIndex = "4100";
    const modal = Modal.getOrCreateInstance(el);
    modal.show();
    requestAnimationFrame(() => {
      document.querySelectorAll(".modal-backdrop").forEach((backdrop) => {
        backdrop.style.zIndex = "4050";
      });
    });
  };

  const filteredHoldings = holdings.filter((holding) => {
    if (!searchQuery) return true;

    const searchLower = searchQuery.toLowerCase();
    const name = (holding.name || "").toLowerCase();
    const fullName = (holding.FullName || "").toLowerCase();

    return name.includes(searchLower) || fullName.includes(searchLower);
  });

  const getWatchlistSortableValue = useCallback((holding, columnKey) => {
    if (!holding || !columnKey) return "";
    switch (columnKey) {
      case "Name":
        return String(holding.full_name || holding.FullName || holding.name || "").toLowerCase();
      case "Current Price":
        return Number(holding.CurrentPrice || holding["Current Price"] || holding.initialPrice || 0);
      case "Net Change":
        return Number(
          holding?.stocks_data?.day_change_perc ??
          holding?.stocks_data?.day_change ??
          holding?.change_percentage ??
          0,
        );
      case "Target Price":
        return Number(holding.targetPrice || 0);
      case "Target %": {
        const target = Number(holding.targetPrice || 0);
        const currentPrice = Number(
          holding.CurrentPrice || holding["Current Price"] || holding.initialPrice || 0,
        );
        if (!Number.isFinite(target) || target === 0 || !Number.isFinite(currentPrice)) return 0;
        const targetLogic = holding.target_logic;
        if (targetLogic === "lower_target") {
          return 100 - ((currentPrice - target) / target) * 100;
        }
        return ((currentPrice - target) / target) * 100 + 100;
      }
      case "Days":
        return Number(holding.days || 0);
      case "DaysLeft":
        return Number(holding.days_remaining || 0);
      default:
        return String(
          holding[columnKey] ?? holding[columnKey?.replace(/\s+/g, "")] ?? "",
        ).toLowerCase();
    }
  }, []);

  const sortedHoldings = useMemo(() => {
    if (!sortConfig?.column || !sortConfig?.direction) {
      // console.log('📊 No sorting applied, returning filtered holdings:', filteredHoldings.length);
      return filteredHoldings;
    }
    console.log('📊 Applying sorting:', sortConfig);
    const sorted = [...filteredHoldings].sort((a, b) => {
      const valueA = getWatchlistSortableValue(a, sortConfig.column);
      const valueB = getWatchlistSortableValue(b, sortConfig.column);
      if (typeof valueA === "number" && typeof valueB === "number") {
        return valueA - valueB;
      }
      return String(valueA).localeCompare(String(valueB));
    });
    const result = sortConfig.direction === "desc" ? sorted.reverse() : sorted;
    console.log('📊 Sorted result:', result.length, 'items');
    return result;
  }, [filteredHoldings, getWatchlistSortableValue, sortConfig]);

  const handleWatchlistHeaderSort = useCallback((column, direction) => {
    console.log('🔄 Sorting triggered:', { column, direction });
    setSortConfig({ column, direction });
    setCurrentPage(1);
    setActiveHeaderMenu(null);
  }, []);

  const getColumnDisplayWidth = useCallback(
    (column) => {
      if (columnWidths[column]) return columnWidths[column];
      if (column === "Name") return 220;
      if (column === "Actions") return 120;
      return 160;
    },
    [columnWidths],
  );

  const pinnedOffsets = useMemo(() => {
    const left = {};
    const right = {};
    let leftOffset = 0;
    columnOrder.forEach((column) => {
      if (pinnedColumns[column] === "left") {
        left[column] = leftOffset;
        leftOffset += getColumnDisplayWidth(column);
      }
    });

    let rightOffset = getColumnDisplayWidth("Actions");
    [...columnOrder].reverse().forEach((column) => {
      if (column === "Actions") return;
      if (pinnedColumns[column] === "right") {
        right[column] = rightOffset;
        rightOffset += getColumnDisplayWidth(column);
      }
    });
    return { left, right };
  }, [columnOrder, pinnedColumns, getColumnDisplayWidth]);

  const handlePinColumn = useCallback((column, pinSide) => {
    if (column === "Actions") return;
    setPinnedColumns((prev) => ({ ...prev, [column]: pinSide }));
    setActiveHeaderMenu(null);
  }, []);

  const handleUnpinColumn = useCallback((column) => {
    setPinnedColumns((prev) => {
      if (!prev[column]) return prev;
      const next = { ...prev };
      delete next[column];
      return next;
    });
    setActiveHeaderMenu(null);
  }, []);

  const handleAutoSizeColumn = useCallback(
    (column) => {
      if (column === "Actions") return;
      console.log('🔧 Auto-sizing column:', column);

      // Get header text length
      const headerText = String(column || "");
      const headerLen = headerText.length;

      // Sample data for width calculation
      const sampleData = sortedHoldings.slice(0, Math.min(200, sortedHoldings.length));

      // Calculate maximum content length
      const sampleMaxLen = sampleData.reduce((maxLen, row) => {
        let rawValue;

        // Try different ways to get the value
        if (column === "Name") {
          rawValue = row?.full_name || row?.FullName || row?.name || "";
        } else {
          rawValue = row?.[column] ??
            row?.[String(column || "").replace(/\s+/g, "")] ??
            getWatchlistSortableValue(row, column);
        }

        const len = String(rawValue ?? "").length;
        return Math.max(maxLen, len);
      }, headerLen);

      // Improved width calculation
      let computedWidth;
      if (column === "Name") {
        // Special handling for Name column - use character-based calculation with padding
        computedWidth = Math.min(450, Math.max(200, sampleMaxLen * 8 + 60));
      } else {
        // For other columns, use slightly larger multiplier
        computedWidth = Math.min(380, Math.max(120, sampleMaxLen * 10 + 50));
      }

      console.log('🔧 Column width calculation:', {
        column,
        sampleMaxLen,
        computedWidth,
        sampleSize: sampleData.length
      });

      setColumnWidths((prev) => ({ ...prev, [column]: computedWidth }));
      setActiveHeaderMenu(null);
    },
    [getWatchlistSortableValue, sortedHoldings],
  );

  const applyPinnedHeaderPriority = useCallback(
    (el, col) => {
      if (!el) return;
      el.style.removeProperty("z-index");
      el.style.removeProperty("left");
      el.style.removeProperty("right");
      if (pinnedColumns[col] === "left") {
        el.style.setProperty("z-index", "1300", "important");
        el.style.setProperty("left", `${pinnedOffsets.left[col] || 0}px`, "important");
        return;
      }
      if (col === "Actions") {
        el.style.setProperty("z-index", "1200", "important");
        el.style.setProperty("right", "0px", "important");
        return;
      }
      if (pinnedColumns[col] === "right") {
        el.style.setProperty("z-index", "1250", "important");
        el.style.setProperty("right", `${pinnedOffsets.right[col] || 0}px`, "important");
      }
    },
    [pinnedColumns, pinnedOffsets],
  );

  const renderWatchlistHeaderMenu = useCallback(
    (col) => {
      if (col === "Actions") return null;
      const isOpen = activeHeaderMenu?.column === col;
      const selectedDirection = sortConfig?.column === col ? sortConfig?.direction : null;
      const isPinned = Boolean(pinnedColumns[col]);
      const isPinnedLeft = pinnedColumns[col] === "left";
      const isPinnedRight = pinnedColumns[col] === "right";
      const menu = isOpen ? (
        <div
          className="wl-th-menu-popover"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          style={{
            position: "fixed",
            top: activeHeaderMenu?.top ?? 0,
            left: activeHeaderMenu?.left ?? 0,
            width: 184,
            background: "#ffffff",
            borderRadius: 12,
            border: "1px solid #dde3ea",
            boxShadow: "0 10px 24px rgba(18, 34, 51, 0.18)",
            padding: "7px",
            zIndex: 1200,
          }}
        >
          <button
            type="button"
            onClick={() => handleWatchlistHeaderSort(col, "asc")}
            style={{
              width: "100%",
              border: "none",
              background: selectedDirection === "asc" ? "#f4f8ff" : "transparent",
              textAlign: "left",
              padding: "7px 9px",
              borderRadius: 8,
              color: "#44546a",
              fontWeight: 500,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <ArrowUp size={14} />
              <span>Sort Ascending</span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => handleWatchlistHeaderSort(col, "desc")}
            style={{
              width: "100%",
              border: "none",
              background: selectedDirection === "desc" ? "#f4f8ff" : "transparent",
              textAlign: "left",
              padding: "7px 9px",
              borderRadius: 8,
              color: "#44546a",
              fontWeight: 500,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <ArrowDown size={14} />
              <span>Sort Descending</span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => handlePinColumn(col, "left")}
            disabled={isPinnedLeft}
            style={{
              width: "100%",
              border: "none",
              background: "transparent",
              textAlign: "left",
              padding: "7px 9px",
              borderRadius: 8,
              color: isPinnedLeft ? "#b2bcc8" : "#6f7f92",
              fontWeight: 500,
              fontSize: 13,
              cursor: isPinnedLeft ? "not-allowed" : "pointer",
            }}
          >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <Pin size={14} />
              <span>Pin Left</span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => handlePinColumn(col, "right")}
            disabled={isPinnedRight}
            style={{
              width: "100%",
              border: "none",
              background: "transparent",
              textAlign: "left",
              padding: "7px 9px",
              borderRadius: 8,
              color: isPinnedRight ? "#b2bcc8" : "#6f7f92",
              fontWeight: 500,
              fontSize: 13,
              cursor: isPinnedRight ? "not-allowed" : "pointer",
            }}
          >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <Pin size={14} />
              <span>Pin Right</span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => handleUnpinColumn(col)}
            disabled={!isPinned}
            style={{
              width: "100%",
              border: "none",
              background: "transparent",
              textAlign: "left",
              padding: "7px 9px",
              borderRadius: 8,
              color: isPinned ? "#6f7f92" : "#d0d7e0",
              fontWeight: 500,
              fontSize: 13,
              cursor: isPinned ? "pointer" : "not-allowed",
            }}
          >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <PinOff size={14} />
              <span>Unpin</span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => handleAutoSizeColumn(col)}
            style={{
              width: "100%",
              border: "none",
              background: "transparent",
              textAlign: "left",
              padding: "7px 9px",
              borderRadius: 8,
              color: "#6f7f92",
              fontWeight: 500,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <Expand size={14} />
              <span>Auto-size Column</span>
            </span>
          </button>
        </div>
      ) : null;

      return (
        <div
          className="wl-th-menu-wrap"
          style={{
            position: "absolute",
            right: col === "Name" ? 4 : 6,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <button
            type="button"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const rect = e.currentTarget.getBoundingClientRect();
              const menuWidth = 184;
              const viewportPadding = 8;
              const computedLeft = Math.min(
                Math.max(viewportPadding, rect.right - menuWidth),
                window.innerWidth - menuWidth - viewportPadding,
              );
              setActiveHeaderMenu((prev) =>
                prev?.column === col
                  ? null
                  : {
                    column: col,
                    top: rect.bottom + 6,
                    left: computedLeft,
                  },
              );
            }}
            style={{
              border: "none",
              background: "transparent",
              width: 24,
              height: 24,
              padding: 0,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#7f8a99",
              lineHeight: 1,
              cursor: "pointer",
              borderRadius: 6,
            }}
            aria-label={`Open ${col} menu`}
          >
            <EllipsisVertical size={14} strokeWidth={2.2} />
          </button>
          {menu && typeof document !== "undefined" ? createPortal(menu, document.body) : null}
        </div>
      );
    },
    [
      activeHeaderMenu,
      handleAutoSizeColumn,
      handlePinColumn,
      handleUnpinColumn,
      handleWatchlistHeaderSort,
      pinnedColumns,
      sortConfig,
    ],
  );

  const getQuickStrategySortValue = useCallback(
    (holding, columnKey) => {
      if (!holding) return "";
      const scripCode = holding.scripcode;
      const livePrice = Number(livePriceCache.current?.[scripCode] || 0);
      const baseCurrent = Number(holding["Current Price"] || 0);
      const currentPriceVal = Number.isFinite(livePrice) && livePrice > 0 ? livePrice : baseCurrent;
      const previousCloseVal = Number(livePCloseCache.current?.[scripCode] || holding["Current Price"] || 0);

      switch (columnKey) {
        case "Name":
          return String(holding.FullName || holding.name || "").toLowerCase();
        case "Symbol":
          return String(holding.name || "").toLowerCase();
        case "Exchange": {
          const exchLabel =
            holding?.exch?.charAt(0) === "N"
              ? "NSE"
              : holding?.exch?.charAt(0) === "B"
                ? "BSE"
                : holding?.exch?.charAt(0) === "M"
                  ? "MCX"
                  : String(holding.exch || "");
          const exchTypeLabel = holding?.exchType?.charAt(0) === "C" ? "-CASH" : "-DERIVATIVES";
          return `${exchLabel}${exchTypeLabel}`.toLowerCase();
        }
        case "Current Price":
          return Number.isFinite(currentPriceVal) ? currentPriceVal : 0;
        case "Net Change": {
          if (!previousCloseVal) return 0;
          return ((currentPriceVal - previousCloseVal) / previousCloseVal) * 100;
        }
        case "TodaysHigh":
          return Number(holding["Today's High"] || 0);
        case "TodaysLow":
          return Number(holding["Today's Low"] || 0);
        case "52WeekHigh":
          return Number(holding["52 Week High"] || 0);
        case "52WeekLow":
          return Number(holding["52 Week Low"] || 0);
        default:
          return String(holding[columnKey] ?? "").toLowerCase();
      }
    },
    [],
  );

  const sortQuickStrategyRows = useCallback(
    (rows, config) => {
      if (!config?.column || !config?.direction) return rows;
      const sorted = [...rows].sort((a, b) => {
        const valueA = getQuickStrategySortValue(a, config.column);
        const valueB = getQuickStrategySortValue(b, config.column);
        if (typeof valueA === "number" && typeof valueB === "number") {
          return valueA - valueB;
        }
        return String(valueA).localeCompare(String(valueB));
      });
      return config.direction === "desc" ? sorted.reverse() : sorted;
    },
    [getQuickStrategySortValue],
  );

  const handleQuickStrategySort = useCallback((tabKey, column, direction) => {
    setQuickStrategySortConfig((prev) => ({
      ...prev,
      [tabKey]: { column, direction },
    }));
    setSimpleSortMenu(null);
    setCurrentPage(1);
  }, []);

  const renderQuickStrategyHeaderMenu = useCallback(
    (tabKey, column) => {
      if (column === "Actions") return null;
      const isOpen = simpleSortMenu?.tab === tabKey && simpleSortMenu?.column === column;
      const selectedDirection =
        quickStrategySortConfig?.[tabKey]?.column === column
          ? quickStrategySortConfig?.[tabKey]?.direction
          : null;

      const menu = isOpen ? (
        <div
          className="wl-th-menu-popover"
          style={{
            position: "fixed",
            top: simpleSortMenu?.top ?? 0,
            left: simpleSortMenu?.left ?? 0,
            width: 176,
            borderRadius: 10,
            border: "1px solid #dde6f2",
            background: "#fff",
            boxShadow: "0 10px 28px rgba(15, 23, 42, 0.18)",
            padding: 6,
            zIndex: 1300,
          }}
        >
          <button
            type="button"
            onClick={() => handleQuickStrategySort(tabKey, column, "asc")}
            style={{
              width: "100%",
              border: "none",
              borderRadius: 8,
              textAlign: "left",
              padding: "7px 9px",
              background: selectedDirection === "asc" ? "#f4f8ff" : "transparent",
              color: "#42556e",
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            ↑ Sort Ascending
          </button>
          <button
            type="button"
            onClick={() => handleQuickStrategySort(tabKey, column, "desc")}
            style={{
              width: "100%",
              border: "none",
              borderRadius: 8,
              textAlign: "left",
              padding: "7px 9px",
              background: selectedDirection === "desc" ? "#f4f8ff" : "transparent",
              color: "#42556e",
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            ↓ Sort Descending
          </button>
        </div>
      ) : null;

      return (
        <div
          className="wl-th-menu-wrap"
          style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)" }}
        >
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const rect = e.currentTarget.getBoundingClientRect();
              const menuWidth = 176;
              const viewportPadding = 8;
              const computedLeft = Math.min(
                Math.max(viewportPadding, rect.right - menuWidth),
                window.innerWidth - menuWidth - viewportPadding,
              );
              setSimpleSortMenu((prev) =>
                prev?.tab === tabKey && prev?.column === column
                  ? null
                  : {
                    tab: tabKey,
                    column,
                    top: rect.bottom + 6,
                    left: computedLeft,
                  },
              );
            }}
            style={{
              border: "none",
              background: "transparent",
              width: 22,
              height: 22,
              padding: 0,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#8091a7",
              borderRadius: 6,
              cursor: "pointer",
            }}
            aria-label={`Sort ${column}`}
          >
            <EllipsisVertical size={14} strokeWidth={2.2} />
          </button>
          {menu && typeof document !== "undefined" ? createPortal(menu, document.body) : null}
        </div>
      );
    },
    [handleQuickStrategySort, quickStrategySortConfig, simpleSortMenu],
  );

  useEffect(() => {
    if (!activeHeaderMenu) return undefined;
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".wl-th-menu-wrap, .wl-th-menu-popover")) {
        setActiveHeaderMenu(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [activeHeaderMenu]);

  useEffect(() => {
    if (!showEditWatchlistPopover) return undefined;
    const handleOutside = (event) => {
      if (
        !event.target.closest(".watchlist-edit-popover") &&
        !event.target.closest(".watchlist-title-edit-btn")
      ) {
        setShowEditWatchlistPopover(false);
      }
    };
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setShowEditWatchlistPopover(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [showEditWatchlistPopover]);

  useEffect(() => {
    if (!simpleSortMenu) return undefined;
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".wl-th-menu-wrap, .wl-th-menu-popover")) {
        setSimpleSortMenu(null);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [simpleSortMenu]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredHoldings.length]);

  const totalPages = Math.ceil(sortedHoldings.length / pageSize);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle page size change
  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1); // Reset to first page when page size changes
  };

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 3;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 2) {
        for (let i = 1; i <= 3; i++) pageNumbers.push(i);
      } else if (currentPage >= totalPages - 1) {
        for (let i = totalPages - 2; i <= totalPages; i++) pageNumbers.push(i);
      } else {
        for (let i = currentPage - 1; i <= currentPage + 1; i++)
          pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  //----------------------------//  Add new Watchlist Functions //----------------------------//`

  const handleDeleteWatchlist = async () => {
    try {
      const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      const brokerFlag = String(
        localStorage.getItem("broker_type") || sharedData?.broker_type || "",
      ).toLowerCase();
      const selectedMeta = (userWatchlistMetaRef.current || []).find(
        (item) => item.name === activeTab,
      );
      const watchlistId = Number(selectedMeta?.id || activeWatchlistId || 0);

      if (!watchlistId || !userId || !brokerFlag) {
        showErrorToast(tr("failedToDeleteWatchlist"));
        return;
      }

      const response = await fetch(
        `${pmsApiBaseUrl}/api/v1/watchlist/delete`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            watchlist_id: watchlistId,
            user_id: userId,
            broker_flag: brokerFlag,
          }),
        },
      );

      const data = await response.json();
      const apiData = data?.data || {};
      const status = String(apiData?.status || "").toLowerCase();
      const message = apiData?.message || tr("failedToDeleteWatchlist");

      if (status === "success") {
        showSuccessToast(message);

        // Close modal
        const closeButton = document.querySelector(
          '#deleteWatchlistConfirmModal [data-bs-dismiss="modal"]',
        );
        if (closeButton) {
          closeButton.click();
        }

        // Refresh list + tabs + active selection via new flow.
        setActiveWatchlistId(null);
        await fetchHoldings();
      } else {
        showErrorToast(message);
      }
    } catch (error) {
      console.error("Error deleting watchlist:", error);
      showErrorToast(tr("failedToDeleteWatchlist"));
    }
  };

  //----------------------------//  Edit Watchlist Name Functions //----------------------------//
  const handleEditWatchlist = async () => {
    setEditWatchlistError("");

    const trimmedName = (editWatchlistNewName || "").trim();
    if (!trimmedName) {
      setEditWatchlistError(tr("watchlistNameCannotBeEmpty"));
      return;
    }

    if (trimmedName.length > 30) {
      setEditWatchlistError(tr("watchlistNameUnder30"));
      return;
    }

    // Duplicate check (case-insensitive), excluding current name
    const currentLower = (editWatchlistCurrentName || "").toLowerCase();
    const trimmedLower = trimmedName.toLowerCase();

    const isDuplicate = userWatchlists.some(
      (name) =>
        name.toLowerCase() === trimmedLower &&
        name.toLowerCase() !== currentLower,
    );
    if (isDuplicate) {
      setEditWatchlistError(tr("watchlistNameAlreadyExists"));
      return;
    }

    try {
      const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      const brokerFlag = String(
        localStorage.getItem("broker_type") || sharedData?.broker_type || "",
      ).toLowerCase();
      const selectedMeta = (userWatchlistMetaRef.current || []).find(
        (item) => item.name === editWatchlistCurrentName,
      );
      const watchlistId = Number(selectedMeta?.id || activeWatchlistId || 0);
      if (!watchlistId || !userId || !brokerFlag) {
        setEditWatchlistError("Failed to update watchlist");
        return;
      }

      const response = await fetch(
        `${pmsApiBaseUrl}/api/v1/watchlist/rename`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            watchlist_id: watchlistId,
            user_id: userId,
            broker_flag: brokerFlag,
            new_watchlist_name: trimmedName,
          }),
        },
      );

      const data = await response.json();
      const apiData = data?.data || {};
      const isSuccess = String(apiData?.status || "").toLowerCase() === "success";
      const message = apiData?.message || "Failed to update watchlist";

      if (isSuccess) {
        setShowEditWatchlistPopover(false);

        // Toast only (no inline success in modal UI)
        showSuccessToast(message || "Watchlist updated");

        // Refresh watchlist list + active data through new flow.
        setActiveTab(trimmedName);
        setActiveWatchlistId(null);
        await fetchHoldings({ watchlistName: trimmedName });
      } else {
        setEditWatchlistError(message || "Failed to update watchlist");
      }
    } catch (error) {
      console.error("Error updating watchlist:", error);
      setEditWatchlistError(tr("failedToCreateWatchlist"));
    }
  };

  const openEditWatchlistPopover = useCallback(
    (event) => {
      const anchor = event?.currentTarget || editWatchlistButtonRef.current;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      const popoverWidth = 320;
      const viewportPadding = 12;
      const left = Math.min(
        Math.max(viewportPadding, rect.right - popoverWidth),
        window.innerWidth - popoverWidth - viewportPadding,
      );
      setEditWatchlistPopoverPos({
        top: rect.bottom + 10,
        left: left + 200,
      });
      setShowEditWatchlistPopover(true);
    },
    [],
  );

  const openSetTargetModal = (holding, fallbackCurrentPrice) => {
    const cacheKey =
      String(holding?.token || holding?.Token || holding?.scripcode || "").trim() ||
      holding?.scripcode ||
      holding?.ScripCode;

    const livePrice = cacheKey
      ? livePriceCache.current?.[cacheKey]
      : undefined;

    const previousClose = cacheKey
      ? livePCloseCache.current?.[cacheKey]
      : undefined;

    const resolvedCurrentPrice = livePrice ?? fallbackCurrentPrice ?? 0;

    const updatedData = {
      ...holding,
      initialPrice: resolvedCurrentPrice,
      modalCurrentPrice: resolvedCurrentPrice,
      PreviousClose:
        previousClose ?? holding?.PClose ?? holding?.PreviousClose ?? undefined,
      modalPreviousClose:
        previousClose ??
        holding?.PClose ??
        holding?.PreviousClose ??
        holding?.["Current Price"] ??
        holding?.previousClose ??
        fallbackCurrentPrice ??
        0,
    };
  
    // ✅ 1. set state FIRST
    setTargetDetails(updatedData);
  
    // ✅ 2. open modal AFTER React updates
    setTimeout(() => {
      const modalElement = document.getElementById("SetTargetModal");
      if (!modalElement) return;
  
      const modal = Modal.getOrCreateInstance(modalElement);
  
      modal.show();
    }, 0);
  };

  const handleConfirmDelete = async () => {
    if (!selectedOrderId) return;
    const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
    const brokerFlag = String(
      localStorage.getItem("broker_type") || sharedData?.broker_type || "",
    ).toLowerCase();
    const selectedMeta = (userWatchlistMetaRef.current || []).find(
      (item) => item.name === activeTab,
    );
    const watchlistId = Number(selectedMeta?.id || activeWatchlistId || 0);

    if (!watchlistId || !userId || !brokerFlag) {
      showErrorToast("Failed to remove stock from watchlist.");
      return;
    }

    const rawExch = String(
      selectedOrderId?.Exch || selectedOrderId?.exch || selectedOrderId?.exchange || "",
    )
      .trim()
      .toUpperCase();
    const exchangeFor5Paisa = rawExch.charAt(0) || "N";
    const exchangeForGrow =
      rawExch.startsWith("B") ? "BSE" : rawExch.startsWith("M") ? "MCX" : "NSE";
    const scriptCode = String(
      selectedOrderId?.script_code ||
      selectedOrderId?.scripcode ||
      selectedOrderId?.ScripCode ||
      selectedOrderId?.Scripcode ||
      "",
    ).trim();
    const tradingSymbol = String(
      selectedOrderId?.TradingSymbol ||
      selectedOrderId?.trading_symbol ||
      selectedOrderId?.Symbol ||
      selectedOrderId?.Name ||
      selectedOrderId?.name ||
      "",
    ).trim();

    let data;
    if (brokerFlag === "grow") {
      if (!tradingSymbol) {
        showErrorToast("Trading symbol missing for selected stock.");
        return;
      }
      data = {
        action: "remove",
        watchlist_id: watchlistId,
        user_id: userId,
        broker_flag: brokerFlag,
        trading_symbol: tradingSymbol,
        exchange: exchangeForGrow,
      };
    } else {
      if (!scriptCode) {
        showErrorToast("Script code missing for selected stock.");
        return;
      }
      data = {
        action: "remove",
        watchlist_id: watchlistId,
        user_id: userId,
        broker_flag: brokerFlag,
        script_code: scriptCode,
        exchange: exchangeFor5Paisa,
      };
    }

    try {
      const response = await fetch(`${pmsApiBaseUrl}/api/v1/watchlist/symbol`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      const apiData = responseData?.data || {};
      const status = String(apiData?.status || "").toLowerCase();
      const message = apiData?.message || "Failed to remove stock from watchlist.";

      if (response.ok && status === "success") {
        showSuccessToast(message || "Stock removed from your Watchlist.");
        await fetchHoldings({
          watchlistId: watchlistId,
          watchlistName: activeTab,
          skipList: true,
        });
      } else {
        showErrorToast(message);
      }
    } catch (error) {
      console.error("Error removing stock from watchlist:", error);
      showErrorToast("Failed to remove stock from watchlist.");
    }
  };

  // Initial "Delete" Button
  const handleDeleteClick = (orderId) => {
    setSelectedOrderId(orderId);
  };

  // Cancel mid way
  const handleCancelDelete = () => {
    console.log("✅✅✅❌ Cancel clicked");
    setSelectedOrderId(null);
  };

  const subscribeToMarketDepth = (holding) => {
    if (!holding) return;

    if (isAngelOneBroker) {
      const userId =
        Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      angelOneMarketDepthService.openDepth(holding, {
        pmsApiBaseUrl,
        userId,
      });
      console.log(
        `📊 Subscribed to AngelOne Market Depth for ${holding.name} (${holding.scripcode || holding.symboltoken})`,
      );
      return;
    }

    if (!isGrowBroker) {
      fivePaisaMarketDepthStore.openDepth(holding);
      console.log(
        `📊 Subscribed to Market Depth for ${holding.name} (${holding.scripcode})`,
      );
    }
  };

  const unsubscribeFromMarketDepth = () => {
    if (isAngelOneBroker) {
      angelOneMarketDepthService.closeDepth();
      console.log("📉🔴 Unsubscribed from AngelOne MarketDepth");
      return;
    }

    if (!isGrowBroker) {
      fivePaisaMarketDepthStore.closeDepth();
      console.log("📉🔴 Unsubscribed from MarketDepth");
    }
  };

  const handleModalClose = () => {
    console.log("📉📉📉 MarketDepth modal closed!");

    if (currentMDModalRef.current) {
      console.log("📉 Unsubscribing to:", currentMDModalRef.current);
      unsubscribeFromMarketDepth();
      console.log("📉 Unsubscribed");

      // Clear the ref so it doesn't hold stale data
      currentMDModalRef.current = null;
      setMarketDepth([]);
    }
  };

  const closeMarketDepthPopover = () => {
    unsubscribeFromMarketDepth();
    setcurrentMDModal(null);
    setMarketDepth([]);
    setShowMarketDepth(false);
  };

  async function getCDSLRecordCount(userId) {
    console.log("🔍 getCDSLRecordCount - Starting function");
    console.log("📋 Input userId:", userId);

    const apiUrl =
      "https://beta.infomanav.in/keep/zerodhaAPI/api.php?xAction=getCDSLRecord";
    console.log("🌐 API URL:", apiUrl);

    try {
      console.log("📤 Preparing to send request...");

      const requestBody = { userId: userId };
      console.log("📦 Request body:", JSON.stringify(requestBody));

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      console.log("📥 Response received");
      console.log("✅ Response status:", response.status);
      console.log("📊 Response statusText:", response.statusText);
      console.log("🔗 Response OK:", response.ok);

      if (!response.ok) {
        console.error("❌ Response not OK - throwing error");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      console.log("🔄 Parsing response as JSON...");
      const data = await response.json();
      console.log("📋 Raw response data:", data);

      const count = data.count;
      console.log("🔢 Extracted count:", count);
      console.log("✅ getCDSLRecordCount - Function completed successfully");

      return count;
    } catch (error) {
      console.error("💥 Error in getCDSLRecordCount:");
      console.error("❌ Error message:", error.message);
      console.error("📊 Full error object:", error);
      console.log("🔄 Returning default value: 0");

      // Return 0 as default if error occurs
      return 0;
    }
  }

  const fetchDataPortfolio = (watchlist, transactionSide, status) => {
    console.log("🚀 fetchDataPortfolio - Starting function");
    console.log("📊 Input parameters:");
    console.log("   - watchlist:", watchlist);
    console.log("   - transactionSide:", transactionSide);
    console.log("   - status:", status);

    const Exch = watchlist.Exch;
    console.log("🏛️ Exchange (Exch):", Exch);

    const ExchType = Exch === "M" ? "D" : "C";
    console.log(
      "📈 Exchange Type (ExchType):",
      ExchType,
      `(${Exch === "M" ? "Derivative" : "Cash"})`,
    );

    const Name = watchlist.FullName || watchlist.name;
    console.log("🏢 Company Name:", Name);

    let Scripcode = "";

    if (status === "Portfolio") {
      // ✨ Use Number conversion for ScripCode with fallback
      Scripcode = Number(watchlist.ScripCode) || Number(watchlist.scripcode);
      console.log("📋 Portfolio mode - Using pre-calculated ScripCode:");
      console.log(
        `   - Exchange is ${watchlist.Exch}, ScripCode: ${Scripcode}`,
      );
      console.log(
        `   - NseCode: ${watchlist.NseCode}, BseCode: ${watchlist.BseCode}`,
      );
      console.log(`   - Selected Scripcode: ${Scripcode}`);
    } else {
      Scripcode = watchlist.Scripcode;
      console.log("📝 Watchlist mode - Using direct Scripcode:", Scripcode);
    }

    let watchlist_price = "0";
    let min_qty = "0";

    // ✅ Get values from modal state instead of DOM
    watchlist_price =
      orderType === "Market Order"
        ? "0"
        : buySellModalDetails.LimitPrice.toString();
    min_qty = buySellModalDetails.OrderQty.toString();

    console.log("💰 Price & Quantity from modal:");
    console.log("   - Execution (Market/Limit):", orderType);
    console.log("   - Price (watchlist_price):", watchlist_price);
    console.log("   - Quantity (min_qty):", min_qty);
    console.log("   - buySellModalDetails:", buySellModalDetails);

    const userId = sharedData.ID;
    console.log("👤 User ID:", userId);
    console.log("📱 sharedData object:", sharedData);

    const order_type = transactionSide;
    console.log("📊 Final order_type (Buy/Sell):", order_type);

    // Create a JavaScript object with the request data
    const requestData = {
      ExchType,
      order_type,
      Exch,
      Name,
      Scripcode,
      watchlist_price,
      min_qty,
      userId,
    };

    console.log("📦 Complete request data object:");
    console.log(JSON.stringify(requestData, null, 2));

    // ✅ CDSL validation for 5paisa Sell only (not Grow / AngelOne)
    if (transactionSide === "Sell" && isAngelOneBroker) {
      console.log("🛑 SELL order (AngelOne) - skipping CDSL validation");
      executeBuySellOrderPortfolio(
        requestData,
        watchlist,
        transactionSide,
        status,
      );
    } else if (transactionSide === "Sell") {
      console.log("🛑 SELL order detected - checking CDSL validation");
      getCDSLRecordCount(userId)
        .then((count) => {
          console.log("✅ CDSL validation completed");
          console.log("🔢 CDSL Record Count:", count);

          if (count === 0) {
            console.error(
              "❌ CDSL Record Count is 0 - cannot place sell order",
            );
            console.log("🚫 Sell order blocked - CDSL setup required");
            // TODO: Show error modal - user needs to complete CDSL setup
            // document.getElementById("modalClick").click();
          } else {
            console.log(
              "✅ CDSL validation passed - proceeding with sell order",
            );
            executeBuySellOrderPortfolio(
              requestData,
              watchlist,
              transactionSide,
              status,
            );
          }
        })
        .catch((error) => {
          console.error("💥 Error getting CDSL count:", error);
          console.log(
            "⚠️ CDSL validation failed - proceeding with order anyway",
          );
          // Proceed with order anyway or show error
          executeBuySellOrderPortfolio(
            requestData,
            watchlist,
            transactionSide,
            status,
          );
        });
    } else if (transactionSide === "Buy") {
      console.log("💚 BUY order detected - no CDSL validation needed");
      console.log("🚀 Proceeding directly to order execution");
      executeBuySellOrderPortfolio(
        requestData,
        watchlist,
        transactionSide,
        status,
      );
    } else {
      console.error("❓ Unknown transaction side:", transactionSide);
    }

    console.log("🏁 fetchDataPortfolio - Function end");
  };


  const executeBuySellOrderPortfolio = (
    requestData,
    watchlist,
    transactionSide,
    status,
  ) => {
    console.log("🔧 executeBuySellOrderPortfolio - Starting function");
    console.log("📥 Input parameters:");
    console.log("   - requestData:", requestData);
    console.log("   - watchlist:", watchlist);
    console.log("   - transactionSide:", transactionSide);
    console.log("   - status:", status);

    // ✅ REMOVED: Database call - now happens AFTER order placement
    console.log("🚀 Proceeding to PMS place_order");
    clickPlaceOrderPortfolio(requestData, watchlist, transactionSide, status);

    console.log("🏁 executeBuySellOrderPortfolio - Function end");
  };

  const clickPlaceOrderPortfolio = (
    requestData,
    watchlist,
    transactionSide,
    status,
  ) => {
    const executionType = orderType;

    console.log("🎯 clickPlaceOrderPortfolio — PMS /api/v1/place_order");
    console.log(
      "   transactionSide:",
      transactionSide,
      "executionType:",
      executionType,
    );

    placeOrderViaPms({
      pmsApiBaseUrl,
      sharedData,
      watchlist,
      listStatus: status,
      transactionSide,
      executionType,
      qty: buySellModalDetails.OrderQty,
      limitPrice: buySellModalDetails.LimitPrice,
    }).then((result) => {
      if (result.error) {
        console.error("💥 place_order:", result.error);
        showErrorToast("Failed to place order. Please try again.");
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      const data = result.data;
      console.log("📋 place_order response:", JSON.stringify(data, null, 2));

      const normalized = normalizePlaceOrderResponse(data);

      if (!result.ok) {
        const msg = normalized.message || "Failed to place order";
        showErrorToast(msg);
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      const message = normalized.message || "";
      const rmsResponseCode = normalized.rmsResponseCode;
      const brokerOrderID = normalized.brokerOrderID;
      const exchangeOrderID = normalized.exchangeOrderID;

      if (
        isFivePaisaBroker(sharedData) &&
        (rmsResponseCode === -162 ||
          message.toLowerCase().includes("sell authorization not received") ||
          message.toLowerCase().includes("authorization not received"))
      ) {
        showErrorToast("CDSL authorization required to place sell orders");
        if (transactionSide === "Buy") {
          document.getElementById("buyModalClick")?.click();
        } else if (transactionSide === "Sell") {
          document.getElementById("sellModalClick")?.click();
        }
        setTimeout(() => {
          document.getElementById("openCDSLModalBtn")?.click();
        }, 500);
        return;
      }

      if (normalized.headStatus !== "0") {
        showErrorToast(message || "Failed to place order");
        setTimeout(() => navigate("/Order"), 1500);
        return;
      }

      runPlaceOrderAcceptedFlow({
        transactionSide,
        tr,
        showSuccessToast,
        navigate,
      });
    });

    console.log(
      "🏁 clickPlaceOrderPortfolio - Function end (async PMS call continues)",
    );
  };

  const refreshHoldings = () => {
    console.log("🔄 Starting holdings refresh...");
  };

  const updateMargin = () => {
    console.log("💰 updateMargin - Starting margin update");

    // Get sharedData from localStorage
    const saved = JSON.parse(localStorage.getItem("sharedData"));

    if (!saved || !saved.accessToken || !saved.api_key || !saved.ClientCode) {
      console.error("❌ Missing required data for margin update");
      return;
    }

    const apiUrl =
      "https://Openapi.5paisa.com/VendorsAPI/Service1.svc/V4/Margin";
    console.log("🌐 Margin API URL:", apiUrl);

    const requestBody = {
      head: {
        key: saved.api_key,
      },
      body: {
        ClientCode: saved.ClientCode,
      },
    };

    console.log("📦 Margin request body:", requestBody);

    const requestHeaders = {
      Authorization: `Bearer ${saved.accessToken}`,
      "Content-Type": "application/json",
    };

    console.log("📤 Sending margin update request...");

    fetch(apiUrl, {
      method: "POST",
      headers: requestHeaders,
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        console.log("📥 Margin API response received");
        console.log("✅ Response status:", response.status);

        if (!response.ok) {
          console.error("❌ Margin API response not OK");
          throw new Error("Margin API response was not ok");
        }

        return response.json();
      })
      .then((data) => {
        console.log("📋 Margin API Response Data:");
        console.log(JSON.stringify(data, null, 2));

        // Extract NetAvailableMargin from response
        const equityMargin = data.body?.EquityMargin?.[0];

        if (equityMargin && equityMargin.NetAvailableMargin !== undefined) {
          const netAvailableMargin = equityMargin.NetAvailableMargin;
          console.log("💵 NetAvailableMargin:", netAvailableMargin);

          // Update sharedData in localStorage
          const currentSharedData = JSON.parse(
            localStorage.getItem("sharedData"),
          );
          currentSharedData.margin = netAvailableMargin;

          localStorage.setItem("sharedData", JSON.stringify(currentSharedData));
          console.log("✅ Margin updated in localStorage:", netAvailableMargin);

          const n = Number(netAvailableMargin);
          if (Number.isFinite(n)) {
            setPmsHeaderMargin(n);
            window.dispatchEvent(
              new CustomEvent(PMS_SHARED_DATA_MARGIN_EVENT, { detail: { margin: n } }),
            );
          }

          // Show success toast
          console.log("💰 Available Margin: ₹" + netAvailableMargin.toFixed(2));
        } else {
          console.error("❌ NetAvailableMargin not found in response");
          console.error("📊 EquityMargin data:", equityMargin);
        }
      })
      .catch((error) => {
        console.error("💥 Margin API call failed:");
        console.error("❌ Error type:", error.name);
        console.error("❌ Error message:", error.message);
        console.error("📊 Full error object:", error);
      });

    console.log("🏁 updateMargin - Function end (async call continues)");
  };

  const getPriceForCalculation = () => {
    if (orderType === "Market Order") {
      const cacheKey = getOrderLivePriceCacheKey(buySellModalDetails.order);
      const livePrice = livePriceCache.current[cacheKey];
      return (
        livePrice ||
        buySellModalDetails.order?.CurrentPrice ||
        buySellModalDetails.order?.initialPrice ||
        0
      );
    } else {
      // Use limit price for Limit orders
      return buySellModalDetails.LimitPrice || 0;
    }
  };

  const saveColumnOrder = async (newOrder) => {
    try {
      const userId = Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      const userEmail =
        sharedData?.Email_ID ||
        sharedData?.email ||
        localStorage.getItem("email") ||
        "";
      if (!userEmail || !userId) {
        console.warn("saveColumnOrder: missing user context, skipping PMS reorder");
        return;
      }

      const pmsBrokerFlag = isGrowBroker ? "grow" : "5paisa";
      const columnsPayload = [];
      let sortOrder = 1;
      for (const label of newOrder) {
        if (label === "Actions") continue;
        // For default columns use explicit mapping; for dynamic additional columns
        // (e.g. sector, musaffaindustry) pass the column name as-is.
        const columnKey = WATCHLIST_TABLE_COL_TO_PMS_COLUMN_KEY[label] || label;
        columnsPayload.push({ column_key: columnKey, sort_order: sortOrder });
        sortOrder += 1;
      }
      if (columnsPayload.length === 0) return;

      const response = await fetch(`${pmsApiBaseUrl}/api/v1/columns/order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: userId,
          email: userEmail,
          broker_flag: pmsBrokerFlag,
          module_name: "watchlist",
          columns: columnsPayload,
        }),
      });
      const result = await response.json();
      console.log("Watchlist column reorder (PMS):", result);
    } catch (err) {
      console.error("Error saving column order:", err);
    }
  };

  const appendSelectedExtraColumns = async (checkedNames = []) => {
    try {
      const userId =
        Number(localStorage.getItem("id")) || Number(sharedData?.ID) || 0;
      const userEmail =
        sharedData?.Email_ID ||
        sharedData?.email ||
        localStorage.getItem("email") ||
        "";
      if (!userEmail || !userId) {
        console.warn(
          "appendSelectedExtraColumns: missing user context, skipping PMS extra append",
        );
        return;
      }

      const pmsBrokerFlag = isGrowBroker ? "grow" : "5paisa";
      const columns = Array.from(
        new Set(
          (Array.isArray(checkedNames) ? checkedNames : []).filter(
            (col) => col && !defaultColumns.includes(col) && col !== "Actions",
          ),
        ),
      );

      const response = await fetch(
        `${pmsApiBaseUrl}/api/v1/columns/extra/append`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            broker_flag: pmsBrokerFlag,
            module_name: "watchlist",
            user_id: userId,
            email: userEmail,
            columns,
          }),
        },
      );
      const result = await response.json();
      console.log("Watchlist extra columns append (PMS):", result);
    } catch (err) {
      console.error("Error appending selected extra columns:", err);
    }
  };

  // Drag Start
  const handleDragStart = (e, columnKey) => {
    if (columnKey === "Actions") return;
    setDraggedColumn(columnKey);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", columnKey);

    const dragPreview = document.createElement("div");
    dragPreview.style.position = "absolute";
    dragPreview.style.top = "-9999px";
    dragPreview.style.padding = "6px 16px";
    dragPreview.style.background = "#C9E0FF";
    dragPreview.style.border = "1px solid #99bde0";
    dragPreview.style.borderRadius = "4px";
    dragPreview.style.color = "#000";
    dragPreview.style.fontSize = "16px";
    dragPreview.style.fontWeight = "bold";
    dragPreview.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.15)";
    dragPreview.textContent = columnKey;

    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(dragPreview);
    }, 0);
  };

  // Drag Over
  const handleDragOver = (e) => {
    e.preventDefault(); // Allow drop
    e.dataTransfer.dropEffect = "move";
  };


  const handleDrop = (e, targetColumnKey) => {
    e.preventDefault();
    if (targetColumnKey === "Actions") {
      setDraggedColumn(null);
      return;
    }

    const sourceColumnKey =
      draggedColumn || e.dataTransfer.getData("text/plain");

    const draggedIndex = columnOrder.indexOf(sourceColumnKey);
    const targetIndex = columnOrder.indexOf(targetColumnKey);

    if (
      draggedIndex === -1 ||
      targetIndex === -1 ||
      draggedIndex === targetIndex
    ) {
      setDraggedColumn(null);
      return;
    }

    const tableContainer = document.querySelector(".table")?.closest("div");
    if (tableContainer) tableContainer.style.overflowY = "hidden";

    const newColumnOrder = [...columnOrder];
    const [movedColumn] = newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, movedColumn);

    setColumnOrder(newColumnOrder);
    setDraggedColumn(null);
    saveColumnOrder(newColumnOrder);

    // Animation wrapped in requestAnimationFrame to prevent ResizeObserver loops
    requestAnimationFrame(() => {
      const cells = document.querySelectorAll(
        `[data-column-id="${movedColumn}"]`,
      );

      // Start animation
      cells.forEach((cell) => cell.classList.add("column-drop-animate"));

      // Remove animation after timeout
      setTimeout(() => {
        cells.forEach((cell) => cell.classList.remove("column-drop-animate"));

        // Temporary highlight of table
        const table = document.querySelector("table");
        table?.classList.add("table-highlight-column");
        setTimeout(() => {
          table?.classList.remove("table-highlight-column");
          if (tableContainer) tableContainer.style.overflowY = "";
        }, 600);
      }, 850);
    });
  };

  // Drag End
  const handleDragEnd = () => {
    setDraggedColumn(null);
  };

  return (
    <>
      <Header
        tabName={tabName}
        setUpdateWatchlistTrigger={setUpdateWatchlistTrigger}
        activeTab3={activeTab}
      />
      <div className="wrapper__page pb-5">
        <Sidebar />

        <div className="content_col">
          {/*   <h1>Watchlist</h1> */}

          {/* Watchlist Header with Tabs */}
          <div className="watchlist-header-with-tabs">
            <div className="header-left">
              <h1 className="watchlist-title">{tr("watchlist")}</h1>

              <div
                style={{
                  paddingLeft: "0px",
                  paddingRight: isMobile ? "20px" : "5px",
                  borderRadius: isMobile ? "20px" : "100px",
                }}
                className="centered-white-container"
              >
                <div
                  className="single-row-layout"
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    gap: "10px",
                    alignItems: "center",
                    paddingLeft: "8px",
                    boxSizing: "border-box",
                    width: "100%",
                  }}
                >
                  {/* TABS AREA */}
                  <div
                    className="tabs-container"
                    style={{
                      flex: "1 1 auto",
                      minWidth: isMobile ? "240px" : "300px",
                      maxWidth: "none",
                      borderRadius: "45px 0 0 45px",
                      // border: "2px solid #EEF4FB",
                      // backgroundColor: "#f9fafb",
                      backgroundColor: "transparent",
                      padding: isMobile ? "4px 6px" : "4px 8px",
                      boxSizing: "border-box",
                      overflow: "visible",
                    }}
                  >
                    {isMobile ? (
                      <TablePageSizeSelect
                        value={activeTab}
                        onChange={handleDropdownChange}
                        options={tabs.map((tab) => ({ value: tab, label: tab }))}
                        className="watchlist-tab-dd"
                      />
                    ) : (
                      // Regular tabs for larger screens WITH SCROLLBAR
                      <div
                        className="tabs-scroll tabs-scroll2 "
                        style={{
                          display: "flex",
                          gap: "8px",
                          position: "relative",
                          // overflowX: "visible !important",   // force scrollbar
                          // overflowY: "hidden",
                          padding: "4px 4px",
                          boxSizing: "border-box",
                          // overflowX: "visible !important", // to override any parent overflow hidden,
                        }}
                      >
                        {tabs.map((tab) => (
                          <button
                            key={tab}
                            className={`tab-button ${activeTab === tab ? "active" : ""}`}
                            onClick={(e) => handleTabClick(tab, e)}
                            onMouseEnter={(e) => handleTabHover(tab, e)}
                            onMouseLeave={handleTabLeave}
                            style={{
                              flexShrink: 0,
                              whiteSpace: "nowrap",
                              fontSize: "12px",
                              padding: "4px 12px",
                              borderRadius: "999px",
                              border: "none",
                              background:
                                activeTab === tab ? "#2457BF" : "transparent",
                              color: activeTab === tab ? "#ffffff" : "#0f172a",
                              cursor: "pointer",
                              transition:
                                "background 0.15s ease, color 0.15s ease",
                            }}
                          >
                            {tab}
                          </button>
                        ))}

                        {/* <button
                          className="settings-btn"
                          style={{
                            flexShrink: 0,
                            border: "none",
                            background: "transparent",
                            padding: "4px 6px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img src={SettingIcon} alt={tr("setting")} />
                        </button> */}

                        {/* Single highlight element */}
                        <div
                          className="tab-highlight"
                          style={{
                            left: `${highlightPosition.left}px`,
                            width: `${highlightPosition.width}px`,
                            position: "absolute",
                            height: "24px",
                            borderRadius: "999px",
                            background: "rgba(36, 87, 191, 0.08)",
                            pointerEvents: "none",
                            top: "4px",
                            zIndex: -1,
                            transition: "left 0.2s ease, width 0.2s ease",
                          }}
                        ></div>
                      </div>
                    )}
                  </div>

                  {/* Margin + New Watchlist stays unchanged */}
                  <div
                    className="margin_button_row"
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      gap: "12px",
                      alignItems: "center",
                      flex: "0 0 auto",
                      justifyContent: "flex-start",
                      fontSize: "12px",
                      borderLeft: "1px solid #e7ebf3",
                    }}
                  >
                    <div
                      className="margin-display"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        fontSize: "12px",
                      }}
                    >
                      <span
                        className="margin-label"
                        style={{
                          whiteSpace: "nowrap",
                          fontSize: "12px",
                        }}
                      >
                        {tr("marginLabel")}
                      </span>
                      <span
                        className="margin-value"
                        style={{
                          color:
                            pmsHeaderMargin === null || pmsHeaderMargin === undefined
                              ? "#6c757d"
                              : pmsHeaderMargin > 0
                                ? "#1ea355"
                                : "#E82127",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                          fontSize: "12px",
                        }}
                      >
                        {pmsHeaderMargin !== null &&
                          pmsHeaderMargin !== undefined &&
                          Number.isFinite(pmsHeaderMargin)
                          ? `₹ ${formatNumber(pmsHeaderMargin)}`
                          : "₹ 0"}
                      </span>
                    </div>

                    <button
                      className="add-watchlist-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#createNewWatchlistModal"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        whiteSpace: "nowrap",
                        fontSize: isMobile ? "12px" : "14px",
                        padding: "8px 15px",
                      }}
                      disabled={userWatchlists.length >= 5}
                      title={
                        userWatchlists.length >= 5
                          ? tr("maximum5WatchlistsReached")
                          : tr("createNewWatchlist")
                      }
                    >
                      <FaHeartCircleXmark style={{ fontSize: "16px" }} />{" "}
                      {tr("newWatchlist")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Active Tab --> First Watchlist */}
          {/* Dynamically render all user watchlists */}
          {tabs
            .slice(0, Math.min(tabs.length - staticWatchlistTabs.length, 5))
            .map((watchlistName, watchlistIndex) => {
              // Filter holdings to show only rows matching current watchlist name
              const watchlistFilteredHoldings = holdings.filter(
                (holding) => holding.watchlistName === watchlistName,
              );

              // Apply search filter on top of watchlist filter
              const searchFilteredHoldings = watchlistFilteredHoldings.filter(
                (holding) =>
                  holding.name
                    ?.toLowerCase()
                    .includes(searchQuery.toLowerCase()) ||
                  holding.FullName?.toLowerCase().includes(
                    searchQuery.toLowerCase(),
                  ),
              );

              // Get current tab for this watchlist (default: tab3 for table view)
              const currentTab = watchlistTabs[watchlistIndex] || "tab3";
              const tabSortConfig = quickStrategySortConfig[currentTab];
              const rowsForCurrentTab =
                currentTab === "tab1" || currentTab === "tab2"
                  ? sortQuickStrategyRows(searchFilteredHoldings, tabSortConfig)
                  : (() => {
                    // Apply main watchlist sorting to tab3 (table view)
                    if (!sortConfig?.column || !sortConfig?.direction) {
                      return searchFilteredHoldings;
                    }
                    const sorted = [...searchFilteredHoldings].sort((a, b) => {
                      const valueA = getWatchlistSortableValue(a, sortConfig.column);
                      const valueB = getWatchlistSortableValue(b, sortConfig.column);
                      if (typeof valueA === "number" && typeof valueB === "number") {
                        return valueA - valueB;
                      }
                      return String(valueA).localeCompare(String(valueB));
                    });
                    return sortConfig.direction === "desc" ? sorted.reverse() : sorted;
                  })();

              // Pagination calculations for filtered data
              const indexOfLastItem = currentPage * pageSize;
              const indexOfFirstItem = indexOfLastItem - pageSize;
              const currentItems = rowsForCurrentTab.slice(
                indexOfFirstItem,
                indexOfLastItem,
              );
              const totalPages = Math.ceil(
                rowsForCurrentTab.length / pageSize,
              );

              return (
                activeTab === watchlistName && (
                  <div
                    key={watchlistName}
                    style={{ marginBottom: "30px", marginTop: "30px" }}
                  >
                    {isGrowBroker && false ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: "60vh",
                          marginTop: "40px",
                          padding: "20px",
                        }}
                      >
                        <div
                          style={{
                            marginTop: "24px",
                            padding: "40px 32px",
                            borderRadius: "20px",
                            background: "#FFFFFF",
                            border: "1px solid #E5EAF3",
                            boxShadow: "0 20px 48px rgba(20, 38, 71, 0.10)",
                            maxWidth: "520px",
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          <h4
                            style={{
                              marginBottom: "12px",
                              color: "#1F2937",
                              fontSize: "24px",
                              fontWeight: "600",
                              letterSpacing: "-0.02em",
                            }}
                          >
                            Coming soon
                          </h4>
                          <p
                            style={{
                              margin: 0,
                              color: "#64748B",
                              fontSize: "16px",
                              lineHeight: "1.5",
                            }}
                          >
                            Watchlist for Groww will be available soon.
                          </p>
                        </div>
                      </div>
                    ) : (
                      <>
                        {/* TABS HEADER */}
                        <div
                          className="watchlist-tabs-header"
                          style={{
                            display: "flex",
                            overflow: "hidden",
                            marginBottom: 0,
                          }}
                        >
                          <button
                            style={{
                              flex: 1,
                              padding: "12px 16px",
                              border: "none",
                              background:
                                currentTab === "tab1" ? "#fff" : "transparent",
                              color: currentTab === "tab1" ? "#007bff" : "#666",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "500",
                              borderBottom:
                                currentTab === "tab1"
                                  ? "2px solid #007bff"
                                  : "none",
                            }}
                            onClick={() =>
                              setWatchlistTabs((prev) => ({
                                ...prev,
                                [watchlistIndex]: "tab1",
                              }))
                            }
                          >
                            {tr("quickGlance")}
                          </button>
                          <button
                            style={{
                              flex: 1,
                              padding: "12px 16px",
                              border: "none",
                              background:
                                currentTab === "tab2" ? "#fff" : "transparent",
                              color: currentTab === "tab2" ? "#007bff" : "#666",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "500",
                              borderBottom:
                                currentTab === "tab2"
                                  ? "2px solid #007bff"
                                  : "none",
                            }}
                            onClick={() =>
                              setWatchlistTabs((prev) => ({
                                ...prev,
                                [watchlistIndex]: "tab2",
                              }))
                            }
                          >
                            {tr("strategyView")}
                          </button>
                          <button
                            style={{
                              flex: 1,
                              padding: "12px 16px",
                              border: "none",
                              background:
                                currentTab === "tab3" ? "#fff" : "transparent",
                              color: currentTab === "tab3" ? "#007bff" : "#666",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "500",
                              borderBottom:
                                currentTab === "tab3"
                                  ? "2px solid #007bff"
                                  : "none",
                            }}
                            onClick={() =>
                              setWatchlistTabs((prev) => ({
                                ...prev,
                                [watchlistIndex]: "tab3",
                              }))
                            }
                          >
                            {tr("advancedAnalytics")}
                            <span
                              style={{ marginLeft: "6px", display: "inline-flex" }}
                            >
                              <FaCrown
                                style={{
                                  fontSize: "14px",
                                  color: currentTab === "tab3" ? "#f59e0b" : "#666",
                                }}
                              />
                            </span>
                          </button>
                        </div>

                        {/* TABS CONTENT */}
                        <div className="watchlist-tab-panel">
                          {/* TAB 1: Basic Info - SAME TABLE */}
                          <div
                            style={{
                              display: currentTab === "tab1" ? "block" : "none",
                            }}
                          >
                            {/* YOUR EXISTING TABLE CODE STARTS HERE - COPY EVERYTHING */}
                            <div
                              className="table_main"
                              style={{ marginTop: "0px" }}
                            >
                              <div className="table_title_with_view_all_row">
                                <h5>
                                  {watchlistName}
                                  {/* {tr("valueOverTime")} */}
                                </h5>

                                {activeTab !== "First Watchlist" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "15px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger watchlist-delete-trigger-btn"
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteWatchlistConfirmModal"
                                      style={{
                                        // padding: '0px 18px',
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#b42318",
                                        backgroundColor: "#fff5f5",
                                        border: "1px solid #fecaca",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "7px",
                                        letterSpacing: "-0.2px",
                                        padding: "10px 14px",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#dc2626";
                                        e.currentTarget.style.borderColor = "#dc2626";
                                        e.currentTarget.style.color = "#ffffff";
                                        e.currentTarget.style.transform = "translateY(-1px)";
                                        e.currentTarget.style.boxShadow =
                                          "0 6px 14px rgba(220, 38, 38, 0.24)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "#fff5f5";
                                        e.currentTarget.style.borderColor = "#fecaca";
                                        e.currentTarget.style.color = "#b42318";
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "none";
                                      }}
                                    >
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <path
                                          d="M2 4H14M12.6667 4V13.3333C12.6667 14 12 14.6667 11.3333 14.6667H4.66667C4 14.6667 3.33333 14 3.33333 13.3333V4M5.33333 4V2.66667C5.33333 2 6 1.33333 6.66667 1.33333H9.33333C10 1.33333 10.6667 2 10.6667 2.66667V4M6.66667 7.33333V11.3333M9.33333 7.33333V11.3333"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      {/* <RiDeleteBin6Line /> */}
                                      Delete This Watchlist
                                    </button>
                                  </div>
                                )}
                              </div>
                              {/* Table */}
                              <div className="table-responsive db-watchlist-targets-wrap">
                                {isLoading && (
                                  <Placeholder.Grid
                                    rows={20}
                                    columns={9}
                                    active
                                    style={{
                                      paddingLeft: 20,
                                      paddingRight: 20,
                                      paddingTop: 12,
                                    }}
                                  />
                                )}

{!isLoading && (
  <>
    {watchlistFilteredHoldings.length === 0 ? (
      <div className="table-empty-state-cell">
        <div
          className="table-empty-order-text"
          style={{ textAlign: "center" }}
        >
          <p style={{ marginBottom: "8px" }}>
            No stocks in this watchlist yet.
          </p>

          <button
            onClick={(e) => {
              const btn = e.currentTarget;
              btn.style.cursor = "wait";

              window.scrollTo({ top: 0, behavior: "smooth" });

              setTimeout(() => {
                window.dispatchEvent(new Event("openStockSearch"));
                if (btn) btn.style.cursor = "pointer";
              }, 500);
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#0d6efd";
              e.currentTarget.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "white";
              e.currentTarget.style.color = "#0d6efd";
              e.currentTarget.style.cursor = "pointer";
            }}
            style={{
              backgroundColor: "white",
              color: "#0d6efd",
              border: "1px solid #0d6efd",
              borderRadius: "6px",
              padding: "8px 16px",
              fontWeight: 500,
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Add Stocks
          </button>
        </div>
      </div>
    ) : (
                                      <table className="table db-watchlist-targets-table">
                                        <thead>
                                          <tr>
                                            {/* 1) NAME */}
                                            <th style={{ textAlign: "left", position: "relative", paddingRight: 28 }}>
                                              <div
                                                className="table_head_search"
                                                style={{ marginLeft: "15px" }}
                                              >
                                                <div style={{ padding: "2px" }}>
                                                  <button
                                                    style={{
                                                      padding: "2px 0 2px 5px",
                                                      borderRight:
                                                        "1px solid #e4e4e4ff",
                                                    }}
                                                    onClick={() =>
                                                      searchInputRef.current?.focus()
                                                    }
                                                  >
                                                    <i className="icon-search" />
                                                  </button>
                                                  <input
                                                    type="text"
                                                    placeholder={tr(
                                                      "nameSearchHere",
                                                    )}
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "5px",
                                                    }}
                                                    value={searchQuery}
                                                    onChange={(e) =>
                                                      setSearchQuery(e.target.value)
                                                    }
                                                    ref={searchInputRef}
                                                  />
                                                </div>
                                              </div>
                                              {renderQuickStrategyHeaderMenu("tab1", "Name")}
                                            </th>

                                            {/* 2) SYMBOL */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("symbol")}
                                              {renderQuickStrategyHeaderMenu("tab1", "Symbol")}
                                            </th>

                                            {/* 3) EXCHANGE */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("exchange")}
                                              {renderQuickStrategyHeaderMenu("tab1", "Exchange")}
                                            </th>

                                            {/* 4) CURRENT PRICE */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("currentPrice")}
                                              {renderQuickStrategyHeaderMenu("tab1", "Current Price")}
                                            </th>

                                            {/* 5) NET CHANGE */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("netChange")}
                                              {renderQuickStrategyHeaderMenu("tab1", "Net Change")}
                                            </th>

                                            {/* 6) ACTIONS */}
                                            <th
                                              data-column-id="Actions"
                                              style={{
                                                textAlign: "center",
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                              }}
                                            >
                                              {/* actions header empty */}
                                            </th>
                                          </tr>
                                        </thead>

                                        {/* Tbody */}
                                        <tbody>
                                        {currentItems.length === 0 ? (
  <tr>
    <td
      colSpan={columnOrder.length}
      style={{
        textAlign: "center",
        padding: "24px",
        color: "#6b7280",
        fontSize: "13px",
        fontWeight: 500,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "8px", alignItems: "center" }}>
        <span>No stocks in this watchlist yet.</span>

        <button
          onClick={(e) => {
            const btn = e.currentTarget;
            btn.style.cursor = "wait";

            window.scrollTo({ top: 0, behavior: "smooth" });

            setTimeout(() => {
              window.dispatchEvent(new Event("openStockSearch"));
              if (btn) btn.style.cursor = "pointer";
            }, 500);
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0d6efd";
            e.currentTarget.style.color = "white";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "white";
            e.currentTarget.style.color = "#0d6efd";
            e.currentTarget.style.cursor = "pointer";
          }}
          style={{
            backgroundColor: "white",
            color: "#0d6efd",
            border: "1px solid #0d6efd",
            borderRadius: "6px",
            padding: "8px 16px",
            fontWeight: 500,
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          Add Stocks
        </button>
      </div>
    </td>
  </tr>
) : (
                                            currentItems.map((holding, index) => {
                                              const scripCode = holding.scripcode;
                                              const livePrice =
                                                livePriceCache.current[scripCode];
                                              const pClose =
                                                livePCloseCache.current[scripCode];

                                              const currentPriceVal =
                                                livePrice || 0.0;
                                              const previousCloseVal =
                                                pClose || holding["Current Price"];
                                              const isPriceUp =
                                                parseFloat(currentPriceVal) >=
                                                parseFloat(previousCloseVal);

                                              const currentPriceNum = parseFloat(
                                                livePrice ||
                                                holding["Current Price"] ||
                                                0,
                                              );
                                              const previousCloseNum = parseFloat(
                                                pClose ||
                                                holding["Current Price"] ||
                                                0,
                                              );

                                              let netChangeContent;
                                              if (
                                                !currentPriceNum ||
                                                !previousCloseNum ||
                                                isNaN(currentPriceNum) ||
                                                isNaN(previousCloseNum)
                                              ) {
                                                netChangeContent = (
                                                  <div
                                                    className="trade__price__cell text_muted"
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    ₹0.00 (0.00%)
                                                    <i className="icon-arrow-down" />
                                                  </div>
                                                );
                                              } else {
                                                const diff =
                                                  currentPriceNum -
                                                  previousCloseNum;
                                                const pct = (
                                                  (diff / previousCloseNum) *
                                                  100
                                                ).toFixed(2);
                                                const isUp = diff >= 0;

                                                netChangeContent = (
                                                  <div
                                                    className={`trade__price__cell ${isUp
                                                      ? "text_success_color"
                                                      : "text_danger_color"
                                                      }`}
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    {isUp ? "+" : ""}₹
                                                    {Math.abs(diff).toFixed(2)}
                                                    <span
                                                      style={{
                                                        color: isUp
                                                          ? "green"
                                                          : "red",
                                                        paddingLeft: "4px",
                                                      }}
                                                    >
                                                      ({isUp ? "+" : ""}
                                                      {pct}%)
                                                    </span>
                                                    <i
                                                      className={`icon-arrow-${isUp ? "up" : "down"}`}
                                                      style={{ marginLeft: "4px" }}
                                                    />
                                                  </div>
                                                );
                                              }

                                              const exchLabel =
                                                holding?.exch?.charAt(0) === "N"
                                                  ? "NSE"
                                                  : holding?.exch?.charAt(0) === "B"
                                                    ? "BSE"
                                                    : holding?.exch?.charAt(0) ===
                                                      "M"
                                                      ? "MCX"
                                                      : holding.exch;

                                              const exchTypeLabel =
                                                holding?.exchType?.charAt(0) === "C"
                                                  ? "-CASH"
                                                  : "-DERIVATIVES";

                                              return (
                                                <tr key={holding.Symbol || index}>
                                                  {/* 1) NAME – only company name */}
                                                  <td style={{ textAlign: "left", paddingRight: "28px !important" }}>
                                                    <div className="main_table_company_cell">
                                                      <div
                                                        style={{
                                                          paddingLeft: "15px",
                                                        }}
                                                      >
                                                        <Whisper
                                                          placement="top"
                                                          trigger="hover"
                                                          speaker={
                                                            <Tooltip className="common__tooltip">
                                                              {holding.FullName ||
                                                                holding.name}
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <h5
                                                            className="uppercase"
                                                            style={{
                                                              maxWidth: 170,
                                                              overflow: "hidden",
                                                              textOverflow:
                                                                "ellipsis",
                                                              whiteSpace: "nowrap",
                                                              margin: 0,
                                                            }}
                                                          >
                                                            {holding.FullName ||
                                                              holding.name}
                                                          </h5>
                                                        </Whisper>
                                                      </div>
                                                    </div>
                                                  </td>

                                                  {/* 2) SYMBOL */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    <span className="csymbol">
                                                      {holding.name}
                                                    </span>
                                                  </td>

                                                  {/* 3) EXCHANGE */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    <span className="cbse_nse">
                                                      {exchLabel}
                                                      {exchTypeLabel}
                                                    </span>
                                                  </td>

                                                  {/* 4) CURRENT PRICE */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    <div className="trade__price__cell">
                                                      <span
                                                        className={
                                                          isPriceUp
                                                            ? "text_success_color"
                                                            : "text_danger_color"
                                                        }
                                                      >
                                                        ₹
                                                        {formatNumber(
                                                          currentPriceVal,
                                                        )}
                                                        <i
                                                          className={`icon-arrow-${isPriceUp ? "up" : "down"}`}
                                                          style={{
                                                            paddingLeft: "4px",
                                                          }}
                                                        />
                                                      </span>
                                                    </div>
                                                  </td>

                                                  {/* 5) NET CHANGE */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    {netChangeContent}
                                                  </td>

                                                  {/* 6) ACTIONS (Buy/Sell only) */}
                                                  <td
                                                    className="action-cell"
                                                    style={{
                                                      textAlign: "center",
                                                      paddingLeft: 0,
                                                      paddingRight: 10,
                                                    }}
                                                  >
                                                    <ul
                                                      className="table__action_hover"
                                                      style={{
                                                        top: "0",
                                                        gap: "8px",
                                                        paddingRight: "6px",
                                                        minWidth: "max-content",
                                                        border: "none",
                                                        height: "98%",
                                                        background:
                                                          "linear-gradient(270deg, #FFFFFF 20%, rgba(255,255,255,0.9) 55%, rgba(255,255,255,0) 100%)",
                                                      }}
                                                    >
                                                      <li>
                                                        <div className="buy-sell-segmented">
                                                          <button
                                                            className="btn_buy wl-premium-action-btn wl-premium-buy"
                                                            type="button"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#BuySellModal"
                                                            onClick={() => {
                                                              console.log(
                                                                "Holding Before Buy Click:",
                                                                holding,
                                                              );
                                                              SettingBuyModalDetails(
                                                                holding,
                                                                "Buy",
                                                              );
                                                            }}
                                                          >
                                                            Buy
                                                          </button>

                                                          <button
                                                            className="btn_sell wl-premium-action-btn wl-premium-sell"
                                                            type="button"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#BuySellModal"
                                                            onClick={() => {
                                                              console.log(
                                                                "Holding Before Sell Click:",
                                                                holding,
                                                              );
                                                              SettingBuyModalDetails(
                                                                holding,
                                                                "Sell",
                                                              );
                                                            }}
                                                          >
                                                            Sell
                                                          </button>
                                                        </div>
                                                      </li>
                                                      {!isGrowBroker && (
                                                        <Whisper
                                                          placement="top"
                                                          trigger="hover"
                                                          speaker={
                                                            <Tooltip className="common__tooltip">
                                                              {tr("marketDepth")}
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <li>
                                                            <button
                                                              ref={marketDepthButtonRef}
                                                              onClick={(e) =>
                                                                handleMarketDepthClick(
                                                                  holding,
                                                                  e,
                                                                )
                                                              }
                                                              className="btn_trading wl-premium-action-btn wl-premium-depth"
                                                              style={{
                                                                width: "38px",
                                                                height: "34px",
                                                                borderRadius: "8px",
                                                                border: "none",
                                                                background:
                                                                  "transparent",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent:
                                                                  "center",
                                                                padding: 0,
                                                              }}
                                                            >
                                                              <MarketDepthIcon />
                                                            </button>
                                                          </li>
                                                        </Whisper>
                                                      )}

                                                      <Whisper
                                                        placement="top"
                                                        trigger="hover"
                                                        speaker={
                                                          <Tooltip
                                                            className="common__tooltip"
                                                            style={{ textAlign: "center" }}
                                                          >
                                                            {tr(
                                                              "deleteFromWatchlistTitle",
                                                            )}
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <li>
                                                          <button
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#DeleteWatchlistModal"
                                                            style={{
                                                              height: "34px",
                                                              width: "38px",
                                                              minWidth: "38px",
                                                              padding: 0,
                                                              borderRadius: "8px",
                                                              display: "inline-flex",
                                                              alignItems: "center",
                                                              justifyContent:
                                                                "center",
                                                              cursor:
                                                                isAddWatchlistDisabled
                                                                  ? "not-allowed"
                                                                  : "pointer",
                                                              opacity:
                                                                isAddWatchlistDisabled
                                                                  ? 0.6
                                                                  : 1,
                                                              marginRight: "10px",
                                                            }}
                                                            className="cancel-watchlist-btn wl-premium-action-btn wl-premium-delete"
                                                            onClick={() => {
                                                              setIsAddWatchlistDisabled(
                                                                true,
                                                              );
                                                              handleDeleteClick(
                                                                holding,
                                                              );
                                                              setTimeout(
                                                                () =>
                                                                  setIsAddWatchlistDisabled(
                                                                    false,
                                                                  ),
                                                                2000,
                                                              );
                                                            }}
                                                            disabled={
                                                              isAddWatchlistDisabled
                                                            }
                                                          >
                                                            <Trash2
                                                              size={18}
                                                              strokeWidth={2.1}
                                                            />
                                                          </button>
                                                        </li>
                                                      </Whisper>
                                                    </ul>
                                                  </td>

                                                  {/* Hidden cells for all other columns */}
                                                  {columnOrder
                                                    .filter(
                                                      (col) =>
                                                        ![
                                                          "Name",
                                                          "Current Price",
                                                          "Net Change",
                                                          "Actions",
                                                          // Symbol & Exchange are extra hardcoded cols, not in columnOrder
                                                        ].includes(col),
                                                    )
                                                    .map((col) => (
                                                      <td
                                                        key={col}
                                                        style={{ display: "none" }}
                                                      />
                                                    ))}
                                                </tr>
                                              );
                                            })
                                          )}
                                        </tbody>
                                      </table>
                                    )}
                                  </>
                                )}
                              </div>

                              {!isLoading &&
                                watchlistFilteredHoldings.length > 0 && (
                                  <div className="table__footer_row">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <h6>
                                        {getItemsRangeText(
                                          indexOfFirstItem + 1,
                                          Math.min(
                                            indexOfLastItem,
                                            searchFilteredHoldings.length,
                                          ),
                                          searchFilteredHoldings.length,
                                        )}
                                      </h6>
                                      <TablePageSizeSelect
                                        value={pageSize}
                                        onChange={handlePageSizeChange}
                                      />
                                    </div>

                                    <nav aria-label="Page navigation example">
                                      <ul className="pagination justify-content-center">
                                        <li
                                          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage > 1 && handlePageChange(1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === 1
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="First Page"
                                          >
                                            <MdKeyboardDoubleArrowLeft
                                              style={{ fontSize: "18px" }}
                                            />
                                          </a>
                                        </li>

                                        <li
                                          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage > 1 &&
                                              handlePageChange(currentPage - 1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === 1
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Previous Page"
                                          >
                                            <IoIosArrowBack />
                                          </a>
                                        </li>

                                        {getPageNumbers().map((pageNum) => (
                                          <li
                                            key={pageNum}
                                            className={`page-item ${currentPage === pageNum ? "active" : ""}`}
                                          >
                                            <a
                                              className="page-link"
                                              onClick={() =>
                                                handlePageChange(pageNum)
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              {pageNum}
                                            </a>
                                          </li>
                                        ))}

                                        <li
                                          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage < totalPages &&
                                              handlePageChange(currentPage + 1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === totalPages
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Next Page"
                                          >
                                            <IoIosArrowForward />
                                          </a>
                                        </li>

                                        <li
                                          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage < totalPages &&
                                              handlePageChange(totalPages)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === totalPages
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Last Page"
                                          >
                                            <MdKeyboardDoubleArrowRight
                                              style={{ fontSize: "18px" }}
                                            />
                                          </a>
                                        </li>
                                      </ul>
                                    </nav>
                                  </div>
                                )}
                            </div>
                          </div>

                          {/* TAB 2: Features - SAME TABLE */}
                          <div
                            style={{
                              display: currentTab === "tab2" ? "block" : "none",
                            }}
                          >
                            {/* COPY YOUR ENTIRE EXISTING TABLE CONTENT HERE */}
                            <div
                              className="table_main"
                              style={{ marginTop: "0px" }}
                            >
                              <div className="table_title_with_view_all_row">
                                <h5>
                                  {watchlistName}
                                  {/* {tr("valueOverTime")} */}
                                </h5>

                                {activeTab !== "First Watchlist1" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "15px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger watchlist-delete-trigger-btn"
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteWatchlistConfirmModal"
                                      style={{
                                        // padding: '0px 18px',
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#b42318",
                                        backgroundColor: "#fff5f5",
                                        border: "1px solid #fecaca",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "7px",
                                        letterSpacing: "-0.2px",
                                        padding: "10px 14px",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#dc2626";
                                        e.currentTarget.style.borderColor = "#dc2626";
                                        e.currentTarget.style.color = "#ffffff";
                                        e.currentTarget.style.transform = "translateY(-1px)";
                                        e.currentTarget.style.boxShadow =
                                          "0 6px 14px rgba(220, 38, 38, 0.24)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "#fff5f5";
                                        e.currentTarget.style.borderColor = "#fecaca";
                                        e.currentTarget.style.color = "#b42318";
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "none";
                                      }}
                                    >
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                      >
                                        <path
                                          d="M2 4H14M12.6667 4V13.3333C12.6667 14 12 14.6667 11.3333 14.6667H4.66667C4 14.6667 3.33333 14 3.33333 13.3333V4M5.33333 4V2.66667C5.33333 2 6 1.33333 6.66667 1.33333H9.33333C10 1.33333 10.6667 2 10.6667 2.66667V4M6.66667 7.33333V11.3333M9.33333 7.33333V11.3333"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      Delete This Watchlist
                                    </button>
                                  </div>
                                )}
                              </div>
                              <div className="table-responsive db-watchlist-targets-wrap">
                                {isLoading && (
                                  <Placeholder.Grid
                                    rows={20}
                                    columns={9}
                                    active
                                    style={{
                                      paddingLeft: 20,
                                      paddingRight: 20,
                                      paddingTop: 12,
                                    }}
                                  />
                                )}

   {!isLoading && (
  <>
    {watchlistFilteredHoldings.length === 0 ? (
      <div className="table-empty-state-cell">
        <div
          className="table-empty-order-text"
          style={{ textAlign: "center" }}
        >
          <p style={{ marginBottom: "8px" }}>
            No stocks in this watchlist yet.
          </p>

          <button
            onClick={(e) => {
              const btn = e.currentTarget;
              btn.style.cursor = "wait";

              window.scrollTo({ top: 0, behavior: "smooth" });

              setTimeout(() => {
                window.dispatchEvent(new Event("openStockSearch"));
                if (btn) btn.style.cursor = "pointer";
              }, 500);
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#0d6efd";
              e.currentTarget.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "white";
              e.currentTarget.style.color = "#0d6efd";
              e.currentTarget.style.cursor = "pointer";
            }}
            style={{
              backgroundColor: "white",
              color: "#0d6efd",
              border: "1px solid #0d6efd",
              borderRadius: "6px",
              padding: "8px 16px",
              fontWeight: 500,
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Add Stocks
          </button>
        </div>
      </div>
    ) : (
                                      <table className="table db-watchlist-targets-table">
                                        {/* Thead */}
                                        <thead>
                                          <tr>
                                            {/* 1) NAME + SEARCH */}
                                            <th style={{ textAlign: "left", position: "relative", paddingRight: 28 }}>
                                              <div
                                                className="table_head_search"
                                                style={{ marginLeft: "15px" }}
                                              >
                                                <div style={{ padding: "2px" }}>
                                                  <button
                                                    style={{
                                                      padding: "2px 0 2px 5px",
                                                      borderRight:
                                                        "1px solid #e4e4e4ff",
                                                    }}
                                                    onClick={() =>
                                                      searchInputRef.current?.focus()
                                                    }
                                                  >
                                                    <i className="icon-search" />
                                                  </button>
                                                  <input
                                                    type="text"
                                                    placeholder={tr(
                                                      "nameSearchHere",
                                                    )}
                                                    style={{
                                                      paddingLeft: "10px",
                                                      marginLeft: "5px",
                                                    }}
                                                    value={searchQuery}
                                                    onChange={(e) =>
                                                      setSearchQuery(e.target.value)
                                                    }
                                                    ref={searchInputRef}
                                                  />
                                                </div>
                                              </div>
                                              {renderQuickStrategyHeaderMenu("tab2", "Name")}
                                            </th>

                                            {/* 2) CURRENT PRICE */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("currentPrice")}
                                              {renderQuickStrategyHeaderMenu("tab2", "Current Price")}
                                            </th>

                                            {/* 3) NET CHANGE */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("netChange")}
                                              {renderQuickStrategyHeaderMenu("tab2", "Net Change")}
                                            </th>

                                            {/* 4) TODAY'S HIGH */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("todaysHigh")}
                                              {renderQuickStrategyHeaderMenu("tab2", "TodaysHigh")}
                                            </th>

                                            {/* 5) TODAY'S LOW */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("todaysLow")}
                                              {renderQuickStrategyHeaderMenu("tab2", "TodaysLow")}
                                            </th>

                                            {/* 6) 52 WEEK HIGH */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("fiftyTwoWeekHigh")}
                                              {renderQuickStrategyHeaderMenu("tab2", "52WeekHigh")}
                                            </th>

                                            {/* 7) 52 WEEK LOW */}
                                            <th style={{ textAlign: "center", position: "relative", paddingRight: 28 }}>
                                              {tr("fiftyTwoWeekLow")}
                                              {renderQuickStrategyHeaderMenu("tab2", "52WeekLow")}
                                            </th>

                                            {/* 8) ACTIONS */}
                                            <th
                                              data-column-id="Actions"
                                              style={{
                                                textAlign: "center",
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                              }}
                                            />
                                          </tr>
                                        </thead>

                                        {/* Tbody */}
                                        <tbody>
                                          {currentItems.length === 0 ? (
                                            <tr>
                                              <td
                                                colSpan={8}
                                                style={{
                                                  textAlign: "center",
                                                  padding: "20px",
                                                  color: "#999",
                                                }}
                                              >
                                                {tr("noMatchFound")}
                                              </td>
                                            </tr>
                                          ) : (
                                            currentItems.map((holding, index) => {
                                              const scripCode = holding.scripcode;
                                              const livePrice =
                                                livePriceCache.current[scripCode];
                                              const pClose =
                                                livePCloseCache.current[scripCode];

                                              const currentPriceVal =
                                                livePrice || 0.0;
                                              const previousCloseVal =
                                                pClose || holding["Current Price"];
                                              const isPriceUp =
                                                parseFloat(currentPriceVal) >=
                                                parseFloat(previousCloseVal);

                                              const currentPriceNum = parseFloat(
                                                livePrice ||
                                                holding["Current Price"] ||
                                                0,
                                              );
                                              const previousCloseNum = parseFloat(
                                                pClose ||
                                                holding["Current Price"] ||
                                                0,
                                              );

                                              // Net change
                                              let netChangeContent;
                                              if (
                                                !currentPriceNum ||
                                                !previousCloseNum ||
                                                isNaN(currentPriceNum) ||
                                                isNaN(previousCloseNum)
                                              ) {
                                                netChangeContent = (
                                                  <div
                                                    className="trade__price__cell text_muted"
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    ₹0.00 (0.00%)
                                                    <i className="icon-arrow-down" />
                                                  </div>
                                                );
                                              } else {
                                                const diff =
                                                  currentPriceNum -
                                                  previousCloseNum;
                                                const pct = (
                                                  (diff / previousCloseNum) *
                                                  100
                                                ).toFixed(2);
                                                const isUp = diff >= 0;

                                                netChangeContent = (
                                                  <div
                                                    className={`trade__price__cell ${isUp
                                                      ? "text_success_color"
                                                      : "text_danger_color"
                                                      }`}
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    {isUp ? "+" : ""}₹
                                                    {Math.abs(diff).toFixed(2)}
                                                    <span
                                                      style={{
                                                        color: isUp
                                                          ? "green"
                                                          : "red",
                                                        paddingLeft: "4px",
                                                      }}
                                                    >
                                                      ({isUp ? "+" : ""}
                                                      {pct}%)
                                                    </span>
                                                    <i
                                                      className={`icon-arrow-${isUp ? "up" : "down"}`}
                                                      style={{ marginLeft: "4px" }}
                                                    />
                                                  </div>
                                                );
                                              }

                                              // Today's High/Low
                                              const liveDayHigh =
                                                liveHighCache.current?.[scripCode];
                                              const liveDayLow =
                                                liveLowCache.current?.[scripCode];
                                              const pickPositiveValue = (...values) => {
                                                for (const value of values) {
                                                  const num = Number(value);
                                                  if (Number.isFinite(num) && num > 0) return num;
                                                }
                                                return null;
                                              };
                                              const todaysHigh = pickPositiveValue(
                                                liveDayHigh,
                                                holding.TodaysHigh,
                                              );
                                              const todaysLow = pickPositiveValue(
                                                liveDayLow,
                                                holding.TodaysLow,
                                              );
                                              const livePriceForRange =
                                                livePriceCache.current?.[
                                                scripCode
                                                ] || holding["Current Price"];

                                              const isNearHigh =
                                                todaysHigh > 0 &&
                                                Math.abs(
                                                  ((livePriceForRange -
                                                    todaysHigh) /
                                                    todaysHigh) *
                                                  100,
                                                ) < 0.5;
                                              const isNearLow =
                                                todaysLow > 0 &&
                                                Math.abs(
                                                  ((livePriceForRange - todaysLow) /
                                                    todaysLow) *
                                                  100,
                                                ) < 0.5;

                                              // 52W High/Low
                                              const high52Week =
                                                holding["52WeekHigh"];
                                              const low52Week =
                                                holding["52WeekLow"];

                                              const symbolName = String(
                                                holding.name ||
                                                  holding.Symbol ||
                                                  holding.symbol ||
                                                  holding.TradingSymbol ||
                                                  "",
                                              ).trim();
                                              const exchRaw = String(
                                                holding?.Exch ||
                                                  holding?.exch ||
                                                  "",
                                              ).toUpperCase();
                                              const exchTypeRaw = String(
                                                holding?.ExchType ||
                                                  holding?.exchType ||
                                                  "C",
                                              ).toUpperCase();
                                              const exchShort = exchRaw.startsWith(
                                                "N",
                                              )
                                                ? "NSE"
                                                : exchRaw.startsWith("B")
                                                  ? "BSE"
                                                  : exchRaw.startsWith("M")
                                                    ? "MCX"
                                                    : "BSE";
                                              const exchSegment =
                                                exchTypeRaw.startsWith("D")
                                                  ? "Derivative"
                                                  : "Cash";
                                              const exchFullLabel = `${exchShort} ${exchSegment}`;

                                              return (
                                                <tr key={holding.Symbol || index}>
                                                  {/* 1) NAME (no Set Target) */}
                                                  <td style={{ textAlign: "left", paddingRight: "28px !important" }}>
                                                    <div className="main_table_company_cell">
                                                      <div
                                                        style={{
                                                          paddingLeft: "15px",
                                                        }}
                                                      >
                                                        <h5 className="uppercase">
                                                          {holding.FullName ||
                                                            holding.name}
                                                        </h5>
                                                        <ul
                                                          className="company_table_tags"
                                                          style={{
                                                            paddingLeft: 0,
                                                            marginTop: 4,
                                                            flexWrap: "nowrap",
                                                            alignItems: "center",
                                                            marginBottom: 0,
                                                            gap: "4px",
                                                            minWidth: 0,
                                                          }}
                                                        >
                                                          <li
                                                            className="csymbol"
                                                            style={{
                                                              minWidth: 0,
                                                              maxWidth: 85,
                                                              overflow: "hidden",
                                                            }}
                                                          >
                                                            <Whisper
                                                              placement="top"
                                                              trigger="hover"
                                                              speaker={
                                                                <Tooltip
                                                                  className="common__tooltip"
                                                                  style={{
                                                                    maxWidth: "320px",
                                                                  }}
                                                                >
                                                                  {symbolName || "-"}
                                                                </Tooltip>
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  display: "inline-block",
                                                                  maxWidth: "100%",
                                                                  overflow: "hidden",
                                                                  textOverflow: "ellipsis",
                                                                  whiteSpace: "nowrap",
                                                                  verticalAlign: "bottom",
                                                                  cursor: "default",
                                                                }}
                                                              >
                                                                {symbolName || "-"}
                                                              </span>
                                                            </Whisper>
                                                          </li>
                                                          <li
                                                            className="cbse_nse"
                                                            style={{
                                                              minWidth: 0,
                                                              flexShrink: 0,
                                                            }}
                                                          >
                                                            <Whisper
                                                              placement="top"
                                                              trigger="hover"
                                                              speaker={
                                                                <Tooltip className="common__tooltip">
                                                                  {exchFullLabel}
                                                                </Tooltip>
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  cursor: "default",
                                                                  whiteSpace: "nowrap",
                                                                }}
                                                              >
                                                                {exchShort}
                                                              </span>
                                                            </Whisper>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </td>

                                                  {/* 2) CURRENT PRICE */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    <div className="trade__price__cell">
                                                      <span
                                                        className={
                                                          isPriceUp
                                                            ? "text_success_color"
                                                            : "text_danger_color"
                                                        }
                                                      >
                                                        ₹
                                                        {formatNumber(
                                                          currentPriceVal,
                                                        )}
                                                        <i
                                                          className={`icon-arrow-${isPriceUp ? "up" : "down"}`}
                                                          style={{
                                                            paddingLeft: "4px",
                                                          }}
                                                        />
                                                      </span>
                                                    </div>
                                                  </td>

                                                  {/* 3) NET CHANGE */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    {netChangeContent}
                                                  </td>

                                                  {/* 4) TODAY'S HIGH */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    <div
                                                      className={`trade__price__cell ${isNearHigh
                                                        ? "text_warning_color"
                                                        : ""
                                                        }`}
                                                    >
                                                      {todaysHigh !== null
                                                        ? `₹${formatNumber(todaysHigh)}`
                                                        : "N/A"}
                                                      {isNearHigh && (
                                                        <i
                                                          className="icon-arrow-up"
                                                          style={{
                                                            color: "#FFA726",
                                                            marginLeft: "4px",
                                                          }}
                                                        />
                                                      )}
                                                    </div>
                                                  </td>

                                                  {/* 5) TODAY'S LOW */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    <div
                                                      className={`trade__price__cell ${isNearLow
                                                        ? "text_danger_color"
                                                        : ""
                                                        }`}
                                                    >
                                                      {todaysLow !== null
                                                        ? `₹${formatNumber(todaysLow)}`
                                                        : "N/A"}
                                                      {isNearLow && (
                                                        <i
                                                          className="icon-arrow-down"
                                                          style={{
                                                            color: "#EF5350",
                                                            marginLeft: "4px",
                                                          }}
                                                        />
                                                      )}
                                                    </div>
                                                  </td>

                                                  {/* 6) 52 WEEK HIGH */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    <div className="trade__price__cell">
                                                      {formatNumber(high52Week) ||
                                                        "N/A"}
                                                    </div>
                                                  </td>

                                                  {/* 7) 52 WEEK LOW */}
                                                  <td
                                                    style={{ textAlign: "center" }}
                                                  >
                                                    <div className="trade__price__cell">
                                                      {formatNumber(low52Week) ||
                                                        "N/A"}
                                                    </div>
                                                  </td>

                                                  {/* ACTIONS – keep as it is */}
                                                  <td
                                                    className="action-cell"
                                                    style={{
                                                      textAlign: "center",
                                                      paddingLeft: 0,
                                                      paddingRight: 0,
                                                      marginRight: "10px",
                                                    }}
                                                  >
                                                    <ul
                                                      className="table__action_hover"
                                                      style={{
                                                        top: "0",
                                                        gap: "8px",
                                                        paddingRight: "6px",
                                                        minWidth: "max-content",
                                                        border: "none",
                                                        height: "98%",
                                                        background:
                                                          "linear-gradient(270deg, #FFFFFF 20%, rgba(255,255,255,0.9) 55%, rgba(255,255,255,0) 100%)",
                                                      }}
                                                    >
                                                      <li>
                                                        <div className="buy-sell-segmented">
                                                          <button
                                                            className="btn_buy wl-premium-action-btn wl-premium-buy"
                                                            type="button"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#BuySellModal"
                                                            onClick={() => {
                                                              console.log(
                                                                "Holding Before Buy Click:",
                                                                holding,
                                                              );
                                                              SettingBuyModalDetails(
                                                                holding,
                                                                "Buy",
                                                              );
                                                            }}
                                                          >
                                                            Buy
                                                          </button>
                                                          <button
                                                            className="btn_sell wl-premium-action-btn wl-premium-sell"
                                                            type="button"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#BuySellModal"
                                                            onClick={() => {
                                                              console.log(
                                                                "Holding Before Sell Click:",
                                                                holding,
                                                              );
                                                              SettingBuyModalDetails(
                                                                holding,
                                                                "Sell",
                                                              );
                                                            }}
                                                          >
                                                            Sell
                                                          </button>
                                                        </div>
                                                      </li>
                                                      {!isGrowBroker && (
                                                        <Whisper
                                                          placement="top"
                                                          trigger="hover"
                                                          speaker={
                                                            <Tooltip className="common__tooltip">
                                                              Market Depth
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <li>
                                                            <button
                                                              ref={
                                                                marketDepthButtonRef
                                                              }
                                                              onClick={(e) =>
                                                                handleMarketDepthClick(
                                                                  holding,
                                                                  e,
                                                                )
                                                              }
                                                              className="btn_trading wl-premium-action-btn wl-premium-depth"
                                                              style={{
                                                                width: "38px",
                                                                height: "34px",
                                                                borderRadius: "8px",
                                                                border: "none",
                                                                background:
                                                                  "transparent",
                                                                display:
                                                                  "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent:
                                                                  "center",
                                                                padding: 0,
                                                              }}
                                                            >
                                                              <MarketDepthIcon />
                                                            </button>
                                                          </li>
                                                        </Whisper>
                                                      )}

                                                      <Whisper
                                                        placement="top"
                                                        trigger="hover"
                                                        speaker={
                                                          <Tooltip
                                                            className="common__tooltip"
                                                            style={{ textAlign: "center" }}
                                                          >
                                                            {tr(
                                                              "deleteFromWatchlistTitle",
                                                            )}
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <li>
                                                          <button
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#DeleteWatchlistModal"
                                                            style={{
                                                              height: "34px",
                                                              width: "38px",
                                                              minWidth: "38px",
                                                              padding: 0,
                                                              borderRadius: "8px",
                                                              display:
                                                                "inline-flex",
                                                              alignItems: "center",
                                                              justifyContent:
                                                                "center",
                                                              cursor:
                                                                isAddWatchlistDisabled
                                                                  ? "not-allowed"
                                                                  : "pointer",
                                                              opacity:
                                                                isAddWatchlistDisabled
                                                                  ? 0.6
                                                                  : 1,
                                                              marginRight: "10px",
                                                            }}
                                                            className="cancel-watchlist-btn wl-premium-action-btn wl-premium-delete"
                                                            onClick={() => {
                                                              setIsAddWatchlistDisabled(
                                                                true,
                                                              );
                                                              handleDeleteClick(
                                                                holding,
                                                              );
                                                              setTimeout(
                                                                () =>
                                                                  setIsAddWatchlistDisabled(
                                                                    false,
                                                                  ),
                                                                2000,
                                                              );
                                                            }}
                                                            disabled={
                                                              isAddWatchlistDisabled
                                                            }
                                                          >
                                                            <Trash2
                                                              size={18}
                                                              strokeWidth={2.1}
                                                            />
                                                          </button>
                                                        </li>
                                                      </Whisper>
                                                    </ul>
                                                  </td>
                                                </tr>
                                              );
                                            })
                                          )}
                                        </tbody>
                                      </table>
                                    )}
                                  </>
                                )}
                              </div>

                              {!isLoading &&
                                watchlistFilteredHoldings.length > 0 && (
                                  <div className="table__footer_row">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <h6>
                                        {getItemsRangeText(
                                          indexOfFirstItem + 1,
                                          Math.min(
                                            indexOfLastItem,
                                            searchFilteredHoldings.length,
                                          ),
                                          searchFilteredHoldings.length,
                                        )}
                                      </h6>
                                      <TablePageSizeSelect
                                        value={pageSize}
                                        onChange={handlePageSizeChange}
                                      />
                                    </div>

                                    <nav aria-label="Page navigation example">
                                      <ul className="pagination justify-content-center">
                                        <li
                                          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage > 1 && handlePageChange(1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === 1
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="First Page"
                                          >
                                            <MdKeyboardDoubleArrowLeft
                                              style={{ fontSize: "18px" }}
                                            />
                                          </a>
                                        </li>

                                        <li
                                          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage > 1 &&
                                              handlePageChange(currentPage - 1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === 1
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Previous Page"
                                          >
                                            <IoIosArrowBack />
                                          </a>
                                        </li>

                                        {getPageNumbers().map((pageNum) => (
                                          <li
                                            key={pageNum}
                                            className={`page-item ${currentPage === pageNum ? "active" : ""}`}
                                          >
                                            <a
                                              className="page-link"
                                              onClick={() =>
                                                handlePageChange(pageNum)
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              {pageNum}
                                            </a>
                                          </li>
                                        ))}

                                        <li
                                          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage < totalPages &&
                                              handlePageChange(currentPage + 1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === totalPages
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Next Page"
                                          >
                                            <IoIosArrowForward />
                                          </a>
                                        </li>

                                        <li
                                          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage < totalPages &&
                                              handlePageChange(totalPages)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === totalPages
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Last Page"
                                          >
                                            <MdKeyboardDoubleArrowRight
                                              style={{ fontSize: "18px" }}
                                            />
                                          </a>
                                        </li>
                                      </ul>
                                    </nav>
                                  </div>
                                )}
                            </div>
                          </div>

                          {/* TAB 3: Table View - SAME TABLE */}
                          <div
                            style={{
                              display: currentTab === "tab3" ? "block" : "none",
                            }}
                          >
                            {/* COPY YOUR ENTIRE EXISTING TABLE CONTENT HERE */}
                            <div
                              className="table_main"
                              style={{ marginTop: "0px" }}
                            >
                              <div className="table_title_with_view_all_row">
                                <h5
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                  }}
                                >
                                  <span>
                                    {watchlistName}
                                    {/* {tr("valueOverTime")} */}
                                  </span>

                                  {activeTab !== "First Watchlist" && (
                                    <Whisper
                                      placement="top"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip className="common__tooltip">
                                          Edit watchlist name
                                        </Tooltip>
                                      }
                                    >
                                      <button
                                        ref={editWatchlistButtonRef}
                                        type="button"
                                        className="watchlist-title-edit-btn"
                                        onClick={(e) => {
                                          setEditWatchlistCurrentName(activeTab);
                                          setEditWatchlistNewName(activeTab);
                                          setEditWatchlistError("");
                                          openEditWatchlistPopover(e);
                                        }}
                                      >
                                        <LuPencilLine />
                                      </button>
                                    </Whisper>
                                  )}
                                </h5>
                                {showEditWatchlistPopover &&
                                  typeof document !== "undefined" &&
                                  createPortal(
                                    <div
                                      ref={editWatchlistPopoverRef}
                                      className="watchlist-edit-popover"
                                      style={{
                                        position: "fixed",
                                        top: editWatchlistPopoverPos.top,
                                        left: editWatchlistPopoverPos.left,
                                        zIndex: 1400,
                                      }}
                                    >
                                      <div className="watchlist-edit-popover__title">
                                        Edit watchlist name
                                      </div>
                                      <p className="watchlist-edit-popover__subtitle">
                                        Keep it short and easy to recognize.
                                      </p>
                                      <input
                                        className={`watchlist-edit-popover__input ${editWatchlistError ? "is-error" : ""
                                          }`}
                                        type="text"
                                        value={editWatchlistNewName}
                                        maxLength={30}
                                        onChange={(e) => {
                                          setEditWatchlistNewName(e.target.value);
                                          setEditWatchlistError("");
                                        }}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter" && editWatchlistNewName.trim()) {
                                            handleEditWatchlist();
                                          }
                                        }}
                                        placeholder="e.g. Tech Stocks"
                                        autoFocus
                                      />
                                      {editWatchlistError && (
                                        <div className="watchlist-edit-popover__error">
                                          {editWatchlistError}
                                        </div>
                                      )}
                                      <div className="watchlist-edit-popover__actions">
                                        <button
                                          className="watchlist-edit-popover__btn watchlist-edit-popover__btn--ghost"
                                          type="button"
                                          onClick={() => setShowEditWatchlistPopover(false)}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          className="watchlist-edit-popover__btn watchlist-edit-popover__btn--primary"
                                          type="button"
                                          onClick={handleEditWatchlist}
                                          disabled={!editWatchlistNewName.trim()}
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </div>,
                                    document.body,
                                  )}

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "15px",
                                  }}
                                >
                                  {activeTab !== "First Watchlist" && (
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger watchlist-delete-trigger-btn"
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteWatchlistConfirmModal"
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#b42318",
                                        backgroundColor: "#fff5f5",
                                        border: "1px solid #fecaca",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "7px",
                                        letterSpacing: "-0.2px",
                                        padding: "10px 14px",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#dc2626";
                                        e.currentTarget.style.borderColor = "#dc2626";
                                        e.currentTarget.style.color = "#ffffff";
                                        e.currentTarget.style.transform = "translateY(-1px)";
                                        e.currentTarget.style.boxShadow =
                                          "0 6px 14px rgba(220, 38, 38, 0.24)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "#fff5f5";
                                        e.currentTarget.style.borderColor = "#fecaca";
                                        e.currentTarget.style.color = "#b42318";
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "none";
                                      }}
                                    >
                                      <Trash2 size={16} strokeWidth={2} />
                                      Delete This Watchlist
                                    </button>
                                  )}
                                  <button
                                    ref={additionalColumnsButtonRef}
                                    type="button"
                                    className="watchlist-columns-btn"
                                    onClick={(e) => openAdditionalColumnsDropdown(e)}
                                  >
                                    <Columns3 size={16} strokeWidth={2} />
                                    {tr("additionalColumns")}
                                  </button>
                                </div>
                              </div>
                              <div className="table-responsive db-watchlist-targets-wrap">
                                {isLoading && (
                                  <Placeholder.Grid
                                    rows={20}
                                    columns={9}
                                    active
                                    style={{
                                      paddingLeft: 20,
                                      paddingRight: 20,
                                      paddingTop: 12,
                                    }}
                                  />
                                )}

   {!isLoading && (
  <>
    {watchlistFilteredHoldings.length === 0 ? (
      <div className="table-empty-state-cell">
        <div
          className="table-empty-order-text"
          style={{ textAlign: "center" }}
        >
          <p style={{ marginBottom: "8px" }}>
            No stocks in this watchlist yet.
          </p>

          <button
  onClick={(e) => {
    const btn = e.currentTarget;
    btn.style.cursor = "wait";
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      window.dispatchEvent(new Event("openStockSearch"));
      if (btn) btn.style.cursor = "pointer";
    }, 500);
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#0d6efd";
    e.currentTarget.style.color = "white";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "white";
    e.currentTarget.style.color = "#0d6efd";
    e.currentTarget.style.cursor = "pointer";
  }}
  style={{
    backgroundColor: "white",
    color: "#0d6efd",
    border: "1px solid #0d6efd",
    borderRadius: "6px",
    padding: "8px 16px",
    fontWeight: 500,
    fontSize: "14px",
    cursor: "pointer",
  }}
>
  Add Stocks
</button>
        </div>
      </div>
    ) : (
                                      <>
                                        <style>{`
                    /* Watchlist Targets sticky thead with horizontal scroll support */
                    .db-watchlist-targets-wrap{
                      overflow-x: auto !important;
                      overflow-y: auto !important;
                      max-height: calc(100vh - 280px);
                      position: relative;
                      width: 100%;
                      min-width: 0;
                    }
                    .db-watchlist-targets-table{
                      border-collapse: separate;
                      border-spacing: 0;
                      width: max-content;
                      min-width: 100%;
                      max-width: none;
                    }
                    .db-watchlist-targets-table thead{
                      position: sticky;
                      top: 0;
                      z-index: 50;
                    }
                    .db-watchlist-targets-table thead tr{
                      position: relative;
                      background: #f8fbff !important;
                    }
                    .db-watchlist-targets-table thead th{
                      position: sticky !important;
                      top: 0 !important;
                      z-index: 55 !important;
                      background: #f8fbff !important;
                    }
                    /* Actions: width 0 overlay; transparent thead so it does not blank last headers */
                    .db-watchlist-targets-table thead th[data-column-id="Actions"]{
                      z-index: 60 !important;
                      width: 0 !important;
                      min-width: 0 !important;
                      max-width: 0 !important;
                      background: transparent !important;
                      box-shadow: none !important;
                      border: none !important;
                    }
                    .db-watchlist-targets-table tbody td.action-cell{
                      position: sticky !important;
                      right: 0 !important;
                      z-index: 35 !important;
                      width: 0 !important;
                      min-width: 0 !important;
                      max-width: 0 !important;
                      background: transparent !important;
                      box-shadow: none !important;
                    }
                    .db-watchlist-targets-table tbody tr:hover td.action-cell{
                      background: #fff !important;
                      box-shadow: -8px 0 14px -10px rgba(15, 23, 42, 0.12) !important;
                    }

                    /* Target % driven row gradient (scoped) */
                    .table_main tr.wl-target-gradient-row{
                      background: linear-gradient(
                        90deg,
                        rgba(var(--target-bg-rgb), 1) 0%,
                        rgba(var(--target-bg-rgb), 0) 100%
                      ) !important;
                    }
                    .table_main tr.wl-target-gradient-row td,
                    .table_main tr.wl-target-gradient-row:hover td{
                      background: transparent !important;
                    }

                    /* Premium action button hover states */
                    .wl-premium-action-btn{
                      transition: all 0.2s ease;
                    }
                    .wl-premium-action-btn:hover{
                      transform: translateY(-1px);
                    }
                    .wl-premium-buy:hover{
                      background: #C8F8E8 !important;
                      border-color: transparent !important;
                      color: #1DAA7F !important;
                      box-shadow: 0 4px 10px rgba(35,183,137,0.16) !important;
                    }
                    .wl-premium-sell:hover{
                      background: #F8D3D3 !important;
                      border-color: transparent !important;
                      color: #BD4545 !important;
                      box-shadow: 0 4px 10px rgba(201,74,74,0.14) !important;
                    }
                    .wl-premium-depth:hover{
                      background: #F3F7FF !important;
                      box-shadow: 0 5px 14px rgba(20,38,71,0.20) !important;
                    }
                    .wl-premium-delete:hover{
                      background: #FFF1F1 !important;
                      box-shadow: 0 5px 14px rgba(119, 119, 119, 0.2) !important;
                    }
                    .wl-premium-action-btn:disabled{
                      transform: none !important;
                      box-shadow: none !important;
                    }
                    /* Prevent action strip overlay from blocking row interactions */
                    .table_main .table__action_hover{
                      pointer-events: none;
                    }
                    .table_main .table__action_hover li,
                    .table_main .table__action_hover li button{
                      pointer-events: auto;
                    }
                  `}</style>
                                        <table className="table db-watchlist-targets-table">
                                          {/* Thead */}
                                          <thead>
                                            <tr
                                              style={{ position: "sticky", top: 0 }}
                                            >
                                              {columnOrder.map((col) => (
                                                <th
                                                  key={col}
                                                  ref={(el) => applyPinnedHeaderPriority(el, col)}
                                                  className={`${pinnedColumns[col] === "left"
                                                    ? "wl-pinned-left"
                                                    : pinnedColumns[col] === "right"
                                                      ? "wl-pinned-right"
                                                      : ""
                                                    } ${col === "Actions" ? "wl-pinned-actions" : ""}`.trim()}
                                                  draggable={col !== "Actions"}
                                                  onDragStart={(e) =>
                                                    handleDragStart(e, col)
                                                  }
                                                  onDragOver={(e) =>
                                                    handleDragOver(e)
                                                  }
                                                  onDrop={(e) => handleDrop(e, col)}
                                                  onDragEnd={handleDragEnd}
                                                  data-column-id={col}
                                                  style={{
                                                    boxSizing: "border-box",
                                                    ...(columnWidths[col]
                                                      ? {
                                                        width: `${columnWidths[col]}px`,
                                                        minWidth: `${columnWidths[col]}px`,
                                                        maxWidth: `${columnWidths[col]}px`,
                                                      }
                                                      : {}),
                                                    ...(pinnedColumns[col] ||
                                                      col === "Actions" ||
                                                      col === "Name"
                                                      ? {
                                                        width: `${getColumnDisplayWidth(col)}px`,
                                                        minWidth: `${getColumnDisplayWidth(col)}px`,
                                                        maxWidth: `${getColumnDisplayWidth(col)}px`,
                                                      }
                                                      : {}),
                                                    transition: "all 0.3s ease",
                                                    transform:
                                                      draggedColumn === col
                                                        ? "scale(1.03)"
                                                        : "scale(1)",
                                                    boxShadow:
                                                      draggedColumn === col
                                                        ? "0 0 10px #C9E0FF"
                                                        : "none",
                                                    cursor: "grab",
                                                    position: "sticky",
                                                    top: 0,
                                                    left:
                                                      pinnedColumns[col] === "left"
                                                        ? `${pinnedOffsets.left[col] || 0}px`
                                                        : undefined,
                                                    right:
                                                      col === "Actions"
                                                        ? 0
                                                        : pinnedColumns[col] === "right"
                                                          ? `${pinnedOffsets.right[col] || 0}px`
                                                          : undefined,
                                                    zIndex:
                                                      pinnedColumns[col]
                                                        ? 1200
                                                        : col === "Actions"
                                                          ? 1100
                                                          : 40,
                                                    textAlign:
                                                      col === "Name"
                                                        ? "left"
                                                        : [
                                                          "ProfitPct",
                                                          "Volume",
                                                        ].includes(col)
                                                          ? "center"
                                                          : "center",
                                                    overflow:
                                                      col === "Name" || pinnedColumns[col]
                                                        ? "hidden"
                                                        : undefined,
                                                    whiteSpace:
                                                      col === "Name"
                                                        ? "nowrap"
                                                        : undefined,
                                                    paddingLeft:
                                                      col === "Actions"
                                                        ? 0
                                                        : undefined,
                                                    paddingRight:
                                                      col === "Actions" ? 0 : 30,
                                                    display: [
                                                      "TodaysLow",
                                                      "Profit %",
                                                      "52WeekLow",
                                                      "Target Price",
                                                      "DaysLeft",
                                                      "Net Change",
                                                    ].includes(col)
                                                      ? "none"
                                                      : undefined,
                                                  }}
                                                >
                                                  {col === "Name" ? (
                                                    <div
                                                      className="table_head_search"
                                                      style={{
                                                        minWidth: "200px",
                                                        width: "200px",
                                                      }}
                                                    >
                                                      <div
                                                        style={{ padding: "2px" }}
                                                      >
                                                        <button
                                                          style={{
                                                            padding:
                                                              "2px 0 2px 5px",
                                                            borderRight:
                                                              "1px solid #e4e4e4ff",
                                                          }}
                                                          onClick={() =>
                                                            searchInputRef.current?.focus()
                                                          }
                                                        >
                                                          <i className="icon-search" />
                                                        </button>
                                                        <input
                                                          type="text"
                                                          placeholder={tr("nameSearchHere")}
                                                          style={{
                                                            paddingLeft: "10px",
                                                            marginLeft: "5px",
                                                            maxWidth: "150px",
                                                            width: "100%",
                                                            boxSizing: "border-box",
                                                          }}
                                                          value={watchlistSearchQuery}
                                                          onChange={(e) =>
                                                            setWatchlistSearchQuery(e.target.value)
                                                          }
                                                          ref={watchlistSearchInputRef}
                                                        />
                                                      </div>

                                                    </div>
                                                  ) : col === "Actions" ? (
                                                    <></>
                                                  ) : // : col === "Current Price" ? (
                                                    col === "Current Price" ? (
                                                      <Whisper
                                                        placement="top"
                                                        trigger="hover"
                                                        speaker={
                                                          <Tooltip
                                                            className="common__tooltip"
                                                            style={{
                                                              maxWidth: "400px",
                                                            }}
                                                          >
                                                            {tr(
                                                              "currentPriceNetChangeTitle",
                                                            )}
                                                            :<br />-{" "}
                                                            {tr(
                                                              "currentPriceNetChangeTop",
                                                            )}
                                                            <br />-{" "}
                                                            {tr(
                                                              "currentPriceNetChangeBottom",
                                                            )}
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <>{tr("currentPrice")}</>
                                                      </Whisper>
                                                    ) : col === "Net Change" ? (
                                                      <></>
                                                    ) : col === "Initial Price" ? (
                                                      <Whisper
                                                        placement="top"
                                                        trigger="hover"
                                                        speaker={
                                                          <Tooltip
                                                            className="common__tooltip"
                                                            style={{
                                                              maxWidth: "400px",
                                                            }}
                                                          >
                                                            {tr(
                                                              "initialTargetPriceTitle",
                                                            )}
                                                            :
                                                            <br />-{" "}
                                                            {tr(
                                                              "initialTargetPriceTop",
                                                            )}
                                                            <br />-{" "}
                                                            {tr(
                                                              "initialTargetPriceBottom",
                                                            )}
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <>
                                                          {tr("initialTargetPrice")}
                                                        </>
                                                      </Whisper>
                                                    ) : col === "Target Price" ? (
                                                      <></>
                                                    ) : col === "Target %" ? (
                                                      <Whisper
                                                        placement="top"
                                                        trigger="hover"
                                                        speaker={
                                                          <Tooltip
                                                            className="common__tooltip"
                                                            style={{
                                                              maxWidth: "400px",
                                                            }}
                                                          >
                                                            {tr("targetPercent")}:
                                                            <br />-{" "}
                                                            {tr(
                                                              "targetPercentTooltip",
                                                            )}
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <>{tr("targetPercent")}</>
                                                      </Whisper>
                                                    ) : // : col === "52WeekHigh" ? (
                                                      col === "52WeekHigh" ? (
                                                        <Whisper
                                                          placement="top"
                                                          trigger="hover"
                                                          speaker={
                                                            <Tooltip
                                                              className="common__tooltip"
                                                              style={{
                                                                maxWidth: "400px",
                                                              }}
                                                            >
                                                              {tr(
                                                                "fiftyTwoWeekHighLowTitle",
                                                              )}
                                                              :
                                                              <br />-{" "}
                                                              {tr(
                                                                "fiftyTwoWeekHighLowTopDetail",
                                                              )}
                                                              <br />-{" "}
                                                              {tr(
                                                                "fiftyTwoWeekHighLowBottomDetail",
                                                              )}
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <>
                                                            {tr("fiftyTwoWeekHighLow")}
                                                          </>
                                                        </Whisper>
                                                      ) : col === "52WeekLow" ? (
                                                        <></>
                                                      ) : col === "TodaysHigh" ? (
                                                        <Whisper
                                                          placement="top"
                                                          trigger="hover"
                                                          speaker={
                                                            <Tooltip
                                                              className="common__tooltip"
                                                              style={{
                                                                maxWidth: "400px",
                                                              }}
                                                            >
                                                              {tr("todaysHighLowTitle")}
                                                              :
                                                              <br />-{" "}
                                                              {tr(
                                                                "todaysHighLowTopDetail",
                                                              )}
                                                              <br />-{" "}
                                                              {tr(
                                                                "todaysHighLowBottomDetail",
                                                              )}
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <>{tr("todaysHighLow")}</>
                                                        </Whisper>
                                                      ) : col === "TodaysLow" ? (
                                                        <></>
                                                      ) : defaultColumns.includes(
                                                        col,
                                                      ) ? (
                                                        col
                                                      ) : (
                                                        additionalColumnConfig.find(
                                                          (config) =>
                                                            config.colName === col,
                                                        )?.UIName ||
                                                        pmsColumnLabelMap[col] ||
                                                        col
                                                      )}
                                                  {renderWatchlistHeaderMenu(col)}
                                                </th>
                                              ))}
                                            </tr>
                                          </thead>

                                          {/* Tbody */}
                                          <tbody>
                                            {currentItems.length === 0 ? (
                                              <tr>
                                                <td
                                                  colSpan={columnOrder.length}
                                                  style={{
                                                    textAlign: "center",
                                                    padding: "20px",
                                                    color: "#999",
                                                  }}
                                                >
                                                  {tr("noMatchFound")}
                                                </td>
                                              </tr>
                                            ) : (
                                              currentItems.map((holding, index) => (
                                                <tr
                                                  key={holding.Symbol || index}
                                                  onClick={() => {
                                                    if (supportsCandleChart(broker_type)) {
                                                      handleRowClick(holding);
                                                    }
                                                  }}
                                                  className={(() => {
                                                    const target = parseFloat(
                                                      holding.targetPrice,
                                                    );
                                                    const initial = parseFloat(
                                                      holding.initialPrice,
                                                    );
                                                    const scripCode =
                                                      holding.ScripCode;
                                                    const livePrice = parseFloat(
                                                      livePriceCache.current?.[
                                                      scripCode
                                                      ],
                                                    );
                                                    const currentPrice = !isNaN(
                                                      livePrice,
                                                    )
                                                      ? livePrice
                                                      : parseFloat(
                                                        holding["Current Price"],
                                                      );

                                                    if (
                                                      isNaN(target) ||
                                                      isNaN(initial) ||
                                                      target === initial ||
                                                      isNaN(currentPrice)
                                                    )
                                                      return undefined;

                                                    const targetLogic =
                                                      holding.target_logic;
                                                    let percent;
                                                    if (
                                                      targetLogic === "lower_target"
                                                    ) {
                                                      percent =
                                                        100 -
                                                        ((currentPrice - target) /
                                                          target) *
                                                        100;
                                                    } else {
                                                      percent =
                                                        ((currentPrice - target) /
                                                          target) *
                                                        100 +
                                                        100;
                                                    }

                                                    if (percent >= 100)
                                                      return "wl-target-gradient-row";
                                                    if (percent >= 90)
                                                      return "wl-target-gradient-row";
                                                    return undefined;
                                                  })()}
                                                  style={{
                                                    cursor: supportsCandleChart(broker_type)
                                                      ? "pointer"
                                                      : "default",
                                                    "--target-bg-rgb": (() => {
                                                      const target = parseFloat(
                                                        holding.targetPrice,
                                                      );
                                                      const initial = parseFloat(
                                                        holding.initialPrice,
                                                      );
                                                      const scripCode =
                                                        holding.ScripCode;
                                                      const livePrice = parseFloat(
                                                        livePriceCache.current?.[
                                                        scripCode
                                                        ],
                                                      );
                                                      const currentPrice = !isNaN(
                                                        livePrice,
                                                      )
                                                        ? livePrice
                                                        : parseFloat(
                                                          holding[
                                                          "Current Price"
                                                          ],
                                                        );

                                                      if (
                                                        isNaN(target) ||
                                                        isNaN(initial) ||
                                                        target === initial ||
                                                        isNaN(currentPrice)
                                                      )
                                                        return undefined;

                                                      const targetLogic =
                                                        holding.target_logic;
                                                      let percent;
                                                      if (
                                                        targetLogic ===
                                                        "lower_target"
                                                      ) {
                                                        percent =
                                                          100 -
                                                          ((currentPrice - target) /
                                                            target) *
                                                          100;
                                                      } else {
                                                        percent =
                                                          ((currentPrice - target) /
                                                            target) *
                                                          100 +
                                                          100;
                                                      }

                                                      // 90%  -> #e2ffed
                                                      // 100% -> #e0ffea
                                                      if (percent >= 100)
                                                        return "201,255,219";
                                                      if (percent >= 90)
                                                        return "226,255,237";
                                                      return undefined;
                                                    })(),
                                                  }}
                                                >
                                                  {columnOrder.map((col) => {
                                                    let content = holding[col];
                                                    if (
                                                      (content === undefined ||
                                                        content === null ||
                                                        content === "") &&
                                                      !defaultColumns.includes(col) &&
                                                      col !== "Actions"
                                                    ) {
                                                      content =
                                                        resolveAdditionalColumnValue(
                                                          holding?.additionalData,
                                                          col,
                                                        );
                                                    }

                                                    if (col === "Name") {
                                                      const symbolName = String(
                                                        holding.name ||
                                                          holding.Symbol ||
                                                          holding.symbol ||
                                                          holding.TradingSymbol ||
                                                          "",
                                                      ).trim();
                                                      const exchRaw = String(
                                                        holding?.Exch ||
                                                          holding?.exch ||
                                                          "",
                                                      ).toUpperCase();
                                                      const exchTypeRaw = String(
                                                        holding?.ExchType ||
                                                          holding?.exchType ||
                                                          "C",
                                                      ).toUpperCase();
                                                      const exchShort =
                                                        exchRaw.startsWith("N")
                                                          ? "NSE"
                                                          : exchRaw.startsWith(
                                                                "B",
                                                              )
                                                            ? "BSE"
                                                            : exchRaw.startsWith(
                                                                  "M",
                                                                )
                                                              ? "MCX"
                                                              : "BSE";
                                                      const exchSegment =
                                                        exchTypeRaw.startsWith(
                                                          "D",
                                                        )
                                                          ? "Derivative"
                                                          : "Cash";
                                                      const exchFullLabel = `${exchShort} ${exchSegment}`;

                                                      content = (
                                                        <div
                                                          className="main_table_company_cell"
                                                          style={{ minWidth: 0 }}
                                                        >
                                                          <div
                                                            style={{
                                                              paddingLeft: "10px",
                                                              minWidth: 0,
                                                            }}
                                                          >
                                                            <Whisper
                                                              placement="top"
                                                              trigger="hover"
                                                              speaker={
                                                                <Tooltip className="common__tooltip">
                                                                  {holding.full_name ||
                                                                    holding.FullName ||
                                                                    holding.name}
                                                                </Tooltip>
                                                              }
                                                            >
                                                              <h5
                                                                className="uppercase"
                                                                style={{
                                                                  maxWidth: 145,
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  margin: 0,
                                                                }}
                                                              >
                                                                {holding.full_name ||
                                                                  holding.FullName ||
                                                                  holding.name}
                                                              </h5>
                                                            </Whisper>
                                                            <ul
                                                              className="company_table_tags"
                                                              style={{
                                                                paddingLeft: 0,
                                                                marginTop: 4,
                                                                flexWrap: "nowrap",
                                                                alignItems: "center",
                                                                marginBottom: 0,
                                                                gap: "4px",
                                                                minWidth: 0,
                                                              }}
                                                            >
                                                              <li
                                                                className="csymbol"
                                                                style={{
                                                                  minWidth: 0,
                                                                  maxWidth: 85,
                                                                  overflow: "hidden",
                                                                }}
                                                              >
                                                                <Whisper
                                                                  placement="top"
                                                                  trigger="hover"
                                                                  speaker={
                                                                    <Tooltip
                                                                      className="common__tooltip"
                                                                      style={{
                                                                        maxWidth:
                                                                          "320px",
                                                                      }}
                                                                    >
                                                                      {symbolName ||
                                                                        "-"}
                                                                    </Tooltip>
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      display:
                                                                        "inline-block",
                                                                      maxWidth:
                                                                        "100%",
                                                                      overflow:
                                                                        "hidden",
                                                                      textOverflow:
                                                                        "ellipsis",
                                                                      whiteSpace:
                                                                        "nowrap",
                                                                      verticalAlign:
                                                                        "bottom",
                                                                      cursor:
                                                                        "default",
                                                                    }}
                                                                    onClick={(e) =>
                                                                      e.stopPropagation()
                                                                    }
                                                                  >
                                                                    {symbolName ||
                                                                      "-"}
                                                                  </span>
                                                                </Whisper>
                                                              </li>
                                                              <li
                                                                className="cbse_nse"
                                                                style={{
                                                                  minWidth: 0,
                                                                  flexShrink: 0,
                                                                }}
                                                              >
                                                                <Whisper
                                                                  placement="top"
                                                                  trigger="hover"
                                                                  speaker={
                                                                    <Tooltip className="common__tooltip">
                                                                      {
                                                                        exchFullLabel
                                                                      }
                                                                    </Tooltip>
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      cursor:
                                                                        "default",
                                                                      whiteSpace:
                                                                        "nowrap",
                                                                    }}
                                                                    onClick={(e) =>
                                                                      e.stopPropagation()
                                                                    }
                                                                  >
                                                                    {exchShort}
                                                                  </span>
                                                                </Whisper>
                                                              </li>
                                                              <Whisper
                                                                placement="top"
                                                                trigger="hover"
                                                                speaker={
                                                                  <Tooltip className="common__tooltip">
                                                                    Set Target
                                                                  </Tooltip>
                                                                }
                                                              >
                                                                <li
                                                                  className="cset__target"
                                                                  role="button"
                                                                  tabIndex={0}
                                                                  aria-label="Set Target"
                                                                  style={{
                                                                    zIndex: 30,
                                                                    minWidth:
                                                                      "unset",
                                                                    padding:
                                                                      "2px 6px",
                                                                    cursor:
                                                                      "pointer",
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                    justifyContent:
                                                                      "center",
                                                                    lineHeight: 1,
                                                                  }}
                                                                  onClick={(
                                                                    e,
                                                                  ) => {
                                                                    e.stopPropagation();
                                                                    openSetTargetModal(
                                                                      holding,
                                                                    );
                                                                  }}
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    if (
                                                                      e.key ===
                                                                        "Enter" ||
                                                                      e.key ===
                                                                        " "
                                                                    ) {
                                                                      e.preventDefault();
                                                                      e.stopPropagation();
                                                                      openSetTargetModal(
                                                                        holding,
                                                                      );
                                                                    }
                                                                  }}
                                                                >
                                                                  <TbTarget
                                                                    size={16}
                                                                  />
                                                                </li>
                                                              </Whisper>
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      );
                                                    }

                                                    else if (
                                                      col === "Current Price"
                                                    ) {
                                                      const scripCode =
                                                        holding.scripcode;
                                                      const livePrice =
                                                        livePriceCache.current[
                                                        scripCode
                                                        ];
                                                      const pClose =
                                                        livePCloseCache.current[
                                                        scripCode
                                                        ];
                                                      const currentPrice =
                                                        livePrice ||
                                                        holding["Current Price"] ||
                                                        holding.CurrentPrice ||
                                                        0.0;
                                                      const previousClose =
                                                        pClose ||
                                                        holding.PClose ||
                                                        holding.PreviousClose ||
                                                        holding.dayOpen ||
                                                        holding["Current Price"];
                                                      const isPositive =
                                                        parseFloat(currentPrice) >=
                                                        parseFloat(previousClose);

                                                      // Get Net Change data
                                                      const priceCurrentPrice =
                                                        parseFloat(
                                                          livePrice ||
                                                          holding[
                                                          "Current Price"
                                                          ] ||
                                                          0,
                                                        );
                                                      const pricePreviousClose =
                                                        parseFloat(
                                                          pClose ||
                                                          holding.PClose ||
                                                          holding.PreviousClose ||
                                                          holding.dayOpen ||
                                                          holding[
                                                          "Current Price"
                                                          ] ||
                                                          0,
                                                        );
                                                      const hasChangeData =
                                                        priceCurrentPrice &&
                                                        pricePreviousClose &&
                                                        !isNaN(priceCurrentPrice) &&
                                                        !isNaN(pricePreviousClose);
                                                      const priceDifference =
                                                        priceCurrentPrice -
                                                        pricePreviousClose;
                                                      const changePercent = (
                                                        (priceDifference /
                                                          pricePreviousClose) *
                                                        100
                                                      ).toFixed(2);
                                                      const isChangePositive =
                                                        priceDifference >= 0;

                                                      content = (
                                                        <div
                                                          className="trade__price__cell"
                                                          style={{
                                                            textAlign: "center",
                                                            minWidth: "140px",
                                                          }}
                                                        >
                                                          {/* Current Price (Top) */}
                                                          <div
                                                            className={
                                                              isPositive
                                                                ? "text_success_color"
                                                                : "text_danger_color"
                                                            }
                                                          >
                                                            ₹
                                                            {formatNumber(
                                                              currentPrice,
                                                            )}
                                                            <i
                                                              className={`icon-arrow-${isPositive ? "up" : "down"}`}
                                                              style={{
                                                                paddingLeft: "4px",
                                                              }}
                                                            ></i>
                                                          </div>

                                                          {/* Separator Line */}
                                                          <div
                                                            style={{
                                                              width: "30px",
                                                              height: "1px",
                                                              background:
                                                                "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                                              margin: "4px auto",
                                                              opacity: "0.5",
                                                            }}
                                                          ></div>

                                                          {/* Net Change (Bottom) */}
                                                          <div
                                                            className={
                                                              hasChangeData
                                                                ? isChangePositive
                                                                  ? "text_success_color"
                                                                  : "text_danger_color"
                                                                : "text_muted"
                                                            }
                                                            style={{}}
                                                          >
                                                            {hasChangeData ? (
                                                              <>
                                                                {isChangePositive
                                                                  ? "+"
                                                                  : ""}
                                                                ₹
                                                                {Math.abs(
                                                                  priceDifference,
                                                                ).toFixed(2)}
                                                                <span
                                                                  style={{
                                                                    paddingLeft:
                                                                      "4px",
                                                                  }}
                                                                >
                                                                  (
                                                                  {isChangePositive
                                                                    ? "+"
                                                                    : ""}
                                                                  {changePercent}%)
                                                                </span>
                                                                <i
                                                                  className={`icon-arrow-${isChangePositive ? "up" : "down"}`}
                                                                  style={{
                                                                    marginLeft:
                                                                      "4px",
                                                                  }}
                                                                ></i>
                                                              </>
                                                            ) : (
                                                              <>
                                                                ₹0.00 (0.00%)
                                                                <i
                                                                  className="icon-arrow-down"
                                                                  style={{
                                                                    marginLeft:
                                                                      "4px",
                                                                  }}
                                                                />
                                                              </>
                                                            )}
                                                          </div>
                                                        </div>
                                                      );
                                                    } else if (
                                                      col === "Net Change"
                                                    ) {
                                                      content = <></>;
                                                    }

                                                    else if (col === "TodaysHigh") {
                                                      const scripCode =
                                                        holding.scripcode;
                                                      const liveDayHigh =
                                                        liveHighCache.current?.[
                                                        scripCode
                                                        ];
                                                      const liveDayLow =
                                                        liveLowCache.current?.[
                                                        scripCode
                                                        ];
                                                      const pickPositiveValue = (
                                                        ...values
                                                      ) => {
                                                        for (const value of values) {
                                                          const num = Number(value);
                                                          if (
                                                            Number.isFinite(num) &&
                                                            num > 0
                                                          ) {
                                                            return num;
                                                          }
                                                        }
                                                        return null;
                                                      };
                                                      const currentDayHigh =
                                                        pickPositiveValue(
                                                          liveDayHigh,
                                                          holding.TodaysHigh,
                                                        );
                                                      const currentDayLow =
                                                        pickPositiveValue(
                                                          liveDayLow,
                                                          holding.TodaysLow,
                                                        );
                                                      const livePrice =
                                                        livePriceCache.current?.[
                                                        scripCode
                                                        ] ||
                                                        holding["Current Price"];

                                                      const isNearHigh =
                                                        currentDayHigh > 0 &&
                                                        Math.abs(
                                                          ((livePrice -
                                                            currentDayHigh) /
                                                            currentDayHigh) *
                                                          100,
                                                        ) < 0.5;
                                                      const isNearLow =
                                                        currentDayLow > 0 &&
                                                        Math.abs(
                                                          ((livePrice -
                                                            currentDayLow) /
                                                            currentDayLow) *
                                                          100,
                                                        ) < 0.5;

                                                      content = (
                                                        <div
                                                          className="trade__price__cell"
                                                          style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            margin: "auto",
                                                          }}
                                                        >
                                                          {/* Today's High (Top) */}
                                                          <div
                                                            className={
                                                              isNearHigh
                                                                ? "text_warning_color"
                                                                : ""
                                                            }
                                                            style={{
                                                              display: "grid",
                                                              gridTemplateColumns:
                                                                "20px 1fr",
                                                              alignItems: "center",
                                                              justifyItems:
                                                                "center",
                                                              gap: "4px",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                fontSize: "0.7em",
                                                                opacity: "0.6",
                                                                color: "#16A34A",
                                                                fontWeight: "600",
                                                              }}
                                                            >
                                                              H
                                                            </span>
                                                            <div
                                                              style={{
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              {currentDayHigh !==
                                                                null
                                                                ? `₹${formatNumber(currentDayHigh)}`
                                                                : "N/A"}
                                                              {isNearHigh && (
                                                                <i
                                                                  className="icon-arrow-up"
                                                                  style={{
                                                                    color:
                                                                      "#FFA726",
                                                                    marginLeft:
                                                                      "4px",
                                                                  }}
                                                                ></i>
                                                              )}
                                                            </div>
                                                          </div>

                                                          {/* Separator Line */}
                                                          <div
                                                            style={{
                                                              width: "30px",
                                                              height: "1px",
                                                              background:
                                                                "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                                              margin: "4px auto",
                                                              opacity: "0.5",
                                                            }}
                                                          ></div>

                                                          {/* Today's Low (Bottom) */}
                                                          <div
                                                            className={
                                                              isNearLow
                                                                ? "text_danger_color"
                                                                : ""
                                                            }
                                                            style={{
                                                              display: "grid",
                                                              gridTemplateColumns:
                                                                "20px 1fr",
                                                              alignItems: "center",
                                                              justifyItems:
                                                                "center",
                                                              gap: "4px",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                fontSize: "0.7em",
                                                                opacity: "0.6",
                                                                color: "#DC2626",
                                                                fontWeight: "600",
                                                              }}
                                                            >
                                                              L
                                                            </span>
                                                            <div
                                                              style={{
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              {currentDayLow !==
                                                                null
                                                                ? `₹${formatNumber(currentDayLow)}`
                                                                : "N/A"}
                                                              {isNearLow && (
                                                                <i
                                                                  className="icon-arrow-down"
                                                                  style={{
                                                                    color:
                                                                      "#EF5350",
                                                                    marginLeft:
                                                                      "4px",
                                                                  }}
                                                                ></i>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      );
                                                    } else if (
                                                      col === "TodaysLow"
                                                    ) {
                                                      content = <></>;
                                                    }

                                                    else if (col === "52WeekHigh") {
                                                      const high52Week =
                                                        holding["52WeekHigh"];
                                                      const low52Week =
                                                        holding["52WeekLow"];

                                                      content = (
                                                        <div
                                                          className="trade__price__cell"
                                                          style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            margin: "auto",
                                                          }}
                                                        >
                                                          {/* 52 Week High (Top) */}
                                                          <div
                                                            style={{
                                                              display: "grid",
                                                              gridTemplateColumns:
                                                                "20px 1fr",
                                                              alignItems: "center",
                                                              justifyItems:
                                                                "center",
                                                              gap: "4px",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                fontSize: "0.7em",
                                                                opacity: "0.6",
                                                                color: "#16A34A",
                                                                fontWeight: "600",
                                                              }}
                                                            >
                                                              H
                                                            </span>
                                                            <div
                                                              style={{
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              {high52Week !== null ? (
                                                                formatNumber(high52Week)
                                                              ) : (
                                                                <span style={{ color: "#9CA3AF", fontStyle: "italic" }}>
                                                                  N/A
                                                                </span>
                                                              )}
                                                            </div>
                                                          </div>

                                                          {/* Separator Line */}
                                                          <div
                                                            style={{
                                                              width: "30px",
                                                              height: "1px",
                                                              background:
                                                                "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                                              margin: "4px auto",
                                                              opacity: "0.5",
                                                            }}
                                                          ></div>

                                                          {/* 52 Week Low (Bottom) */}
                                                          <div
                                                            style={{
                                                              display: "grid",
                                                              gridTemplateColumns:
                                                                "20px 1fr",
                                                              alignItems: "center",
                                                              justifyItems:
                                                                "center",
                                                              gap: "4px",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                fontSize: "0.7em",
                                                                opacity: "0.6",
                                                                color: "#DC2626",
                                                                fontWeight: "600",
                                                              }}
                                                            >
                                                              L
                                                            </span>
                                                            <div
                                                              style={{
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              {low52Week !== null ? (
                                                                formatNumber(low52Week)
                                                              ) : (
                                                                <span style={{ color: "#9CA3AF", fontStyle: "italic" }}>
                                                                  N/A
                                                                </span>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      );
                                                    } else if (
                                                      col === "52WeekLow"
                                                    ) {
                                                      content = <></>;
                                                    }

                                                    else if (
                                                      col === "Initial Price"
                                                    ) {
                                                      const initialPrice =
                                                        holding["initialPrice"];
                                                      const targetPrice =
                                                        holding["targetPrice"];
                                                      const hasTargetData =
                                                        !!holding?.hasTargetData;

                                                      content = (
                                                        <div
                                                          className="trade__price__cell"
                                                          style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            margin: "auto",
                                                          }}
                                                        >
                                                          {/* Initial Price (Top) */}
                                                          <div
                                                            style={{
                                                              display: "grid",
                                                              gridTemplateColumns:
                                                                "20px 1fr",
                                                              alignItems: "center",
                                                              justifyItems:
                                                                "center",
                                                              gap: "4px",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                fontSize: "0.7em",
                                                                opacity: "0.6",
                                                                color: "#2457BF",
                                                                fontWeight: "600",
                                                              }}
                                                            >
                                                              I
                                                            </span>
                                                            <div
                                                              style={{
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              {hasTargetData
                                                                ? (formatNumber(initialPrice) || (
                                                                  <span style={{ color: "#9CA3AF", fontStyle: "italic" }}>
                                                                    N/A
                                                                  </span>
                                                                ))
                                                                : (
                                                                  <span style={{ color: "#9CA3AF", fontStyle: "italic" }}>
                                                                    N/A
                                                                  </span>
                                                                )}
                                                            </div>
                                                          </div>

                                                          {/* Separator Line */}
                                                          <div
                                                            style={{
                                                              width: "30px",
                                                              height: "1px",
                                                              background:
                                                                "linear-gradient(90deg, transparent, #cbd5e1, transparent)",
                                                              margin: "4px auto",
                                                              opacity: "0.5",
                                                            }}
                                                          ></div>

                                                          {/* Target Price (Bottom) */}
                                                          <div
                                                            style={{
                                                              display: "grid",
                                                              gridTemplateColumns:
                                                                "20px 1fr",
                                                              alignItems: "center",
                                                              justifyItems:
                                                                "center",
                                                              gap: "4px",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                fontSize: "0.7em",
                                                                opacity: "0.6",
                                                                color: "#D67A1F",
                                                                fontWeight: "600",
                                                              }}
                                                            >
                                                              T
                                                            </span>
                                                            <div
                                                              style={{
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              {hasTargetData
                                                                ? (formatNumber(targetPrice) || (
                                                                  <span style={{ color: "#9CA3AF", fontStyle: "italic" }}>
                                                                    N/A
                                                                  </span>
                                                                ))
                                                                : (
                                                                  <span style={{ color: "#9CA3AF", fontStyle: "italic" }}>
                                                                    N/A
                                                                  </span>
                                                                )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      );
                                                    } else if (
                                                      col === "Target Price"
                                                    ) {
                                                      content = <></>;
                                                    } else if (col === "Target %") {
                                                      const target = parseFloat(
                                                        holding.targetPrice,
                                                      );
                                                      const initial = parseFloat(
                                                        holding.initialPrice,
                                                      );

                                                      const scripCode =
                                                        holding.ScripCode;
                                                      const livePrice = parseFloat(
                                                        livePriceCache.current[
                                                        scripCode
                                                        ],
                                                      );
                                                      const currentPrice = !isNaN(
                                                        livePrice,
                                                      )
                                                        ? livePrice
                                                        : parseFloat(
                                                          holding[
                                                          "Current Price"
                                                          ],
                                                        );
                                                      const reasonText =
                                                        holding.targetReason ||
                                                        holding.target_reason ||
                                                        holding.reason ||
                                                        "";
                                                      const reasonDetailsText =
                                                        holding.targetReasonDetails ||
                                                        holding.target_reason_details ||
                                                        holding.reason_details ||
                                                        "";
                                                      const hasReason =
                                                        !!String(reasonText).trim();

                                                      if (
                                                        isNaN(target) ||
                                                        isNaN(initial) ||
                                                        target === initial ||
                                                        isNaN(currentPrice)
                                                      ) {
                                                        content = (
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems: "center",
                                                              justifyContent:
                                                                "center",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              openSetTargetModal(
                                                                holding,
                                                                currentPrice,
                                                              );
                                                            }}
                                                            // data-bs-toggle="modal"
                                                            // data-bs-target="#SetTargetModal"
                                                            aria-label="Set Target"
                                                          >
                                                            <Whisper
                                                              placement="top"
                                                              trigger="hover"
                                                              speaker={
                                                                <Tooltip className="common__tooltip">
                                                                  Set Target
                                                                </Tooltip>
                                                              }
                                                            >
                                                              <div
                                                                style={{
                                                                  padding:
                                                                    "5px 10px",
                                                                  background:
                                                                    "#EBF2FA",
                                                                  borderRadius:
                                                                    "5px",
                                                                  border:
                                                                    "1px solid #BAD0FD",
                                                                }}
                                                              >
                                                                <button
                                                                  type="button"
                                                                  className="p-0 border-0 bg-transparent"
                                                                  style={{
                                                                    lineHeight: 1,
                                                                    color:
                                                                      "inherit",
                                                                    display: "flex",
                                                                    alignItems:
                                                                      "center",
                                                                    justifyContent:
                                                                      "center",
                                                                    cursor:
                                                                      "pointer",
                                                                    padding: 0,
                                                                    minWidth:
                                                                      "unset",
                                                                  }}
                                                                >
                                                                  <TbTarget
                                                                    size={16}
                                                                  />
                                                                </button>
                                                              </div>
                                                            </Whisper>
                                                          </div>
                                                        );
                                                      } else {
                                                        const targetLogic =
                                                          holding.target_logic;
                                                        let percent;

                                                        if (
                                                          targetLogic ===
                                                          "lower_target"
                                                        ) {
                                                          percent =
                                                            100 -
                                                            ((currentPrice -
                                                              target) /
                                                              target) *
                                                            100;
                                                        } else {
                                                          percent =
                                                            ((currentPrice -
                                                              target) /
                                                              target) *
                                                            100 +
                                                            100;
                                                        }

                                                        const getTargetColor = (
                                                          percentage,
                                                        ) => {
                                                          const clampedPercent =
                                                            Math.max(
                                                              0,
                                                              Math.min(
                                                                100,
                                                                percentage,
                                                              ),
                                                            );

                                                          let r, g, b;

                                                          if (clampedPercent < 50) {
                                                            r = Math.floor(
                                                              200 +
                                                              (clampedPercent *
                                                                55) /
                                                              50,
                                                            );
                                                            g = Math.floor(
                                                              (clampedPercent *
                                                                140) /
                                                              50,
                                                            );
                                                            b = 0;
                                                          } else {
                                                            const adjustedPercent =
                                                              clampedPercent - 50;
                                                            r = Math.floor(
                                                              255 -
                                                              (adjustedPercent *
                                                                235) /
                                                              50,
                                                            );
                                                            g = Math.floor(
                                                              140 +
                                                              (adjustedPercent *
                                                                40) /
                                                              50,
                                                            );
                                                            b = 0;
                                                          }

                                                          return `rgb(${r}, ${g}, ${b})`;
                                                        };

                                                        const textColor =
                                                          getTargetColor(percent);

                                                        content = (
                                                          <div
                                                            style={{
                                                              display:
                                                                "inline-flex",
                                                              alignItems: "center",
                                                              gap: 6,
                                                            }}
                                                          >
                                                            <span
                                                              className="medium_font"
                                                              style={{
                                                                color: textColor,
                                                                fontWeight: "600",
                                                              }}
                                                            >
                                                              {percent.toFixed(2)}%
                                                            </span>

                                                            {hasReason ? (
                                                              <Whisper
                                                                placement="top"
                                                                trigger="hover"
                                                                speaker={
                                                                  <Tooltip
                                                                    className="common__tooltip"
                                                                    style={{
                                                                      maxWidth:
                                                                        "320px",
                                                                    }}
                                                                  >
                                                                    <div>
                                                                      <b>Reason:</b>{" "}
                                                                      {String(
                                                                        reasonText,
                                                                      ).trim()}
                                                                    </div>
                                                                    <div
                                                                      style={{
                                                                        marginTop:
                                                                          "4px",
                                                                      }}
                                                                    >
                                                                      <b>
                                                                        Details:
                                                                      </b>{" "}
                                                                      {String(
                                                                        reasonDetailsText,
                                                                      ).trim() ||
                                                                        "No additional details provided."}
                                                                    </div>
                                                                  </Tooltip>
                                                                }
                                                              >
                                                                <button
                                                                  type="button"
                                                                  data-bs-toggle="modal"
                                                                  data-bs-target="#TargetReasonDetailsModal"
                                                                  aria-label="View target reason details"
                                                                  onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setTargetReasonModalData(
                                                                      {
                                                                        stockName:
                                                                          holding.FullName ||
                                                                          holding.fullName ||
                                                                          holding.name ||
                                                                          "-",
                                                                        reason:
                                                                          String(
                                                                            reasonText,
                                                                          ).trim(),
                                                                        details:
                                                                          String(
                                                                            reasonDetailsText,
                                                                          ).trim(),
                                                                      },
                                                                    );
                                                                  }}
                                                                  style={{
                                                                    width: "16px",
                                                                    height: "16px",
                                                                    minWidth:
                                                                      "16px",
                                                                    borderRadius:
                                                                      "50%",
                                                                    border:
                                                                      "1px solid #CBD5E1",
                                                                    background:
                                                                      "#FFFFFF",
                                                                    color:
                                                                      "#475569",
                                                                    fontSize:
                                                                      "11px",
                                                                    fontWeight: 700,
                                                                    lineHeight: 1,
                                                                    display:
                                                                      "inline-flex",
                                                                    alignItems:
                                                                      "center",
                                                                    justifyContent:
                                                                      "center",
                                                                    cursor:
                                                                      "pointer",
                                                                    padding: 0,
                                                                  }}
                                                                >
                                                                  !
                                                                </button>
                                                              </Whisper>
                                                            ) : null}
                                                          </div>
                                                        );
                                                      }
                                                    } else if (col === "Actions") {
                                                      content = (
                                                        <ul
                                                        onClick={(e) => e.stopPropagation()}
                                                          className="table__action_hover"
                                                          style={{
                                                            top: "0",
                                                            gap: "8px",
                                                            paddingRight: "6px",
                                                            minWidth: "max-content",
                                                            border: "none",
                                                            height: "98%",
                                                            background:
                                                              "linear-gradient(270deg, #FFFFFF 20%, rgba(255,255,255,0.9) 55%, rgba(255,255,255,0) 100%)",
                                                          }}
                                                        >
                                                          <li>
                                                            <div className="buy-sell-segmented">
                                                              <button
                                                                className="btn_buy wl-premium-action-btn wl-premium-buy"
                                                                type="button"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#BuySellModal"
                                                                onClick={() => {
                                                                  console.log(
                                                                    "Holding Before Buy Click:",
                                                                    holding,
                                                                  );
                                                                  SettingBuyModalDetails(
                                                                    holding,
                                                                    "Buy",
                                                                  );
                                                                }}
                                                              >
                                                                {tr("buy")}
                                                              </button>

                                                              <button
                                                                className="btn_sell wl-premium-action-btn wl-premium-sell"
                                                                type="button"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#BuySellModal"
                                                                onClick={() => {
                                                                  console.log(
                                                                    "Holding Before Sell Click:",
                                                                    holding,
                                                                  );
                                                                  SettingBuyModalDetails(
                                                                    holding,
                                                                    "Sell",
                                                                  );
                                                                }}
                                                              >
                                                                {tr("sell")}
                                                              </button>
                                                            </div>
                                                          </li>
                                                          {!isGrowBroker && (
                                                            <Whisper
                                                              placement="top"
                                                              trigger="hover"
                                                              speaker={
                                                                <Tooltip className="common__tooltip">
                                                                  {tr("marketDepth")}
                                                                </Tooltip>
                                                              }
                                                            >
                                                              <li>
                                                                <button
                                                                  ref={
                                                                    marketDepthButtonRef
                                                                  }
                                                                  onClick={(e) =>
                                                                    handleMarketDepthClick(
                                                                      holding,
                                                                      e,
                                                                    )
                                                                  }
                                                                  className="btn_trading wl-premium-action-btn wl-premium-depth"
                                                                  style={{
                                                                    width: "38px",
                                                                    height: "34px",
                                                                    borderRadius:
                                                                      "8px",
                                                                    border: "none",
                                                                    background:
                                                                      "transparent",
                                                                    display:
                                                                      "inline-flex",
                                                                    alignItems:
                                                                      "center",
                                                                    justifyContent:
                                                                      "center",
                                                                    padding: 0,
                                                                  }}
                                                                >
                                                                  <MarketDepthIcon />
                                                                </button>
                                                              </li>
                                                            </Whisper>
                                                          )}

                                                          <Whisper
                                                            placement="top"
                                                            trigger="hover"
                                                            speaker={
                                                              <Tooltip
                                                                className="common__tooltip"
                                                                style={{ textAlign: "center" }}
                                                              >
                                                                {tr(
                                                                  "deleteFromWatchlistTitle",
                                                                )}
                                                              </Tooltip>
                                                            }
                                                          >
                                                            <li>
                                                              <button
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#DeleteWatchlistModal"
                                                                style={{
                                                                  height: "34px",
                                                                  width: "38px",
                                                                  minWidth: "38px",
                                                                  padding: 0,
                                                                  borderRadius:
                                                                    "8px",
                                                                  display:
                                                                    "inline-flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                  cursor:
                                                                    isAddWatchlistDisabled
                                                                      ? "not-allowed"
                                                                      : "pointer",
                                                                  opacity:
                                                                    isAddWatchlistDisabled
                                                                      ? 0.6
                                                                      : 1,
                                                                }}
                                                                className="cancel-watchlist-btn wl-premium-action-btn wl-premium-delete"
                                                                onClick={() => {
                                                                  setIsAddWatchlistDisabled(
                                                                    true,
                                                                  );
                                                                  handleDeleteClick(
                                                                    holding,
                                                                  );
                                                                  setTimeout(
                                                                    () =>
                                                                      setIsAddWatchlistDisabled(
                                                                        false,
                                                                      ),
                                                                    2000,
                                                                  );
                                                                }}
                                                                disabled={
                                                                  isAddWatchlistDisabled
                                                                }
                                                              >
                                                                <Trash2
                                                                  size={18}
                                                                  strokeWidth={2.1}
                                                                />
                                                              </button>
                                                            </li>
                                                          </Whisper>
                                                        </ul>
                                                      );
                                                    } else {
                                                      let value =
                                                        holding[col] ??
                                                        resolveAdditionalColumnValue(
                                                          holding?.additionalData,
                                                          col,
                                                        );

                                                      if (
                                                        value === null ||
                                                        value === undefined
                                                      ) {
                                                        value = (
                                                          <span
                                                            style={{
                                                              color: "#9CA3AF",
                                                              fontStyle: "italic",
                                                            }}
                                                          >
                                                            N/A
                                                          </span>
                                                        );
                                                      } else {
                                                        const numValue =
                                                          Number(value);
                                                        if (!isNaN(numValue)) {
                                                          value =
                                                            formatNumber(numValue);
                                                        }
                                                      }

                                                      content = (
                                                        <div
                                                          style={{
                                                            textAlign:
                                                              col === "Name"
                                                                ? "left"
                                                                : [
                                                                  "ProfitPct",
                                                                  "Volume",
                                                                ].includes(col)
                                                                  ? "center"
                                                                  : "center",
                                                          }}
                                                        >
                                                          {value}
                                                        </div>
                                                      );
                                                    }

                                                    return (
                                                      <td
                                                        key={col}
                                                        className={`${col === "Actions"
                                                          ? "action-cell wl-pinned-actions"
                                                          : ""
                                                          } ${pinnedColumns[col] === "left"
                                                            ? "wl-pinned-left"
                                                            : pinnedColumns[col] === "right"
                                                              ? "wl-pinned-right"
                                                              : ""
                                                          }`.trim()}
                                                        style={{
                                                          boxSizing: "border-box",
                                                          ...(columnWidths[col]
                                                            ? {
                                                              width: `${columnWidths[col]}px`,
                                                              minWidth: `${columnWidths[col]}px`,
                                                              maxWidth: `${columnWidths[col]}px`,
                                                            }
                                                            : {}),
                                                          ...(pinnedColumns[col] ||
                                                            col === "Actions" ||
                                                            col === "Name"
                                                            ? {
                                                              width: `${getColumnDisplayWidth(col)}px`,
                                                              minWidth: `${getColumnDisplayWidth(col)}px`,
                                                              maxWidth: `${getColumnDisplayWidth(col)}px`,
                                                            }
                                                            : {}),
                                                          textAlign:
                                                            col === "Name"
                                                              ? "left"
                                                              : [
                                                                "ProfitPct",
                                                                "Volume",
                                                              ].includes(col)
                                                                ? "center"
                                                                : "center",
                                                          paddingLeft:
                                                            col === "Actions"
                                                              ? 0
                                                              : undefined,
                                                          paddingRight:
                                                            col === "Actions"
                                                              ? 0
                                                              : undefined,
                                                          position:
                                                            col === "Actions" || pinnedColumns[col]
                                                              ? "sticky"
                                                              : undefined,
                                                          left:
                                                            pinnedColumns[col] === "left"
                                                              ? `${pinnedOffsets.left[col] || 0}px`
                                                              : undefined,
                                                          right:
                                                            col === "Actions"
                                                              ? 0
                                                              : pinnedColumns[col] === "right"
                                                                ? `${pinnedOffsets.right[col] || 0}px`
                                                                : undefined,
                                                          display: [
                                                            "TodaysLow",
                                                            "Profit %",
                                                            "52WeekLow",
                                                            "Target Price",
                                                            "DaysLeft",
                                                            "Net Change",
                                                          ].includes(col)
                                                            ? "none"
                                                            : undefined,
                                                          zIndex:
                                                            pinnedColumns[col]
                                                              ? 170
                                                              : col === "Actions"
                                                                ? 150
                                                                : undefined,
                                                        }}
                                                      >
                                                        {content !== undefined
                                                          ? content
                                                          : "-"}
                                                      </td>
                                                    );
                                                  })}
                                                </tr>
                                              ))
                                            )}
                                          </tbody>
                                        </table>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>

                              {!isLoading &&
                                watchlistFilteredHoldings.length > 0 && (
                                  <div className="table__footer_row">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <h6>
                                        {getItemsRangeText(
                                          indexOfFirstItem + 1,
                                          Math.min(
                                            indexOfLastItem,
                                            searchFilteredHoldings.length,
                                          ),
                                          searchFilteredHoldings.length,
                                        )}
                                      </h6>
                                      <TablePageSizeSelect
                                        value={pageSize}
                                        onChange={handlePageSizeChange}
                                      />
                                    </div>

                                    <nav aria-label="Page navigation example">
                                      <ul className="pagination justify-content-center">
                                        <li
                                          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage > 1 && handlePageChange(1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === 1
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="First Page"
                                          >
                                            <MdKeyboardDoubleArrowLeft
                                              style={{ fontSize: "18px" }}
                                            />
                                          </a>
                                        </li>

                                        <li
                                          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage > 1 &&
                                              handlePageChange(currentPage - 1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === 1
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Previous Page"
                                          >
                                            <IoIosArrowBack />
                                          </a>
                                        </li>

                                        {getPageNumbers().map((pageNum) => (
                                          <li
                                            key={pageNum}
                                            className={`page-item ${currentPage === pageNum ? "active" : ""}`}
                                          >
                                            <a
                                              className="page-link"
                                              onClick={() =>
                                                handlePageChange(pageNum)
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              {pageNum}
                                            </a>
                                          </li>
                                        ))}

                                        <li
                                          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage < totalPages &&
                                              handlePageChange(currentPage + 1)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === totalPages
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Next Page"
                                          >
                                            <IoIosArrowForward />
                                          </a>
                                        </li>

                                        <li
                                          className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={() =>
                                              currentPage < totalPages &&
                                              handlePageChange(totalPages)
                                            }
                                            style={{
                                              cursor:
                                                currentPage === totalPages
                                                  ? "not-allowed"
                                                  : "pointer",
                                            }}
                                            title="Last Page"
                                          >
                                            <MdKeyboardDoubleArrowRight
                                              style={{ fontSize: "18px" }}
                                            />
                                          </a>
                                        </li>
                                      </ul>
                                    </nav>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )
              );
            })}

          {activeTab === "Top Growth" && (
            <div style={{ padding: "16px" }}>
              {" "}
              {/* Reduced from 20px */}
              {/* Loading Skeleton */}
              {isLoadingTopGainers && (
                <>
                  <Placeholder.Grid
                    rows={2}
                    columns={2}
                    active
                    style={{
                      padding: "16px 32px",
                      marginBottom: "8px",
                      backgroundColor: "white",
                    }}
                  />
                  <Placeholder.Grid
                    rows={3}
                    columns={3}
                    active
                    style={{
                      padding: "16px 32px",
                      marginBottom: "8px",
                      backgroundColor: "white",
                    }}
                  />
                  <Placeholder.Grid
                    rows={12}
                    columns={7}
                    active
                    style={{
                      padding: 32,
                      marginBottom: "8px",
                      backgroundColor: "white",
                    }}
                  />
                </>
              )}
              {/* Professional Error State */}
              {!isLoadingTopGainers && !topGainersData && (
                <div
                  style={{
                    maxWidth: "500px",
                    margin: "80px auto",
                    padding: "24px",
                    borderRadius: "12px",
                    background: "#ffffff",
                    border: "2px solid #fee2e2",
                    boxShadow: "0 6px 20px rgba(220, 38, 38, 0.1)",
                    textAlign: "center",
                  }}
                >
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 64 64"
                    fill="none"
                    style={{ margin: "0 auto 16px" }}
                  >
                    <circle
                      cx="32"
                      cy="32"
                      r="30"
                      stroke="#dc2626"
                      strokeWidth="3"
                      fill="#fef2f2"
                    />
                    <path
                      d="M32 20V36M32 44H32.02"
                      stroke="#dc2626"
                      strokeWidth="4"
                      strokeLinecap="round"
                    />
                  </svg>
                  <h2
                    style={{
                      margin: "0 0 10px 0",
                      fontWeight: "700",
                      fontSize: "20px",
                      color: "#0f172a",
                      letterSpacing: "-0.3px",
                    }}
                  >
                    Data Unavailable
                  </h2>
                  <p
                    style={{
                      margin: 0,
                      lineHeight: "1.5",
                      color: "#64748b",
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    Unable to fetch Top Gainers data. Please try again later.
                  </p>
                </div>
              )}
              {/* Main Content */}
              {!isLoadingTopGainers && topGainersData && (
                <>
                  <div className="tg-panel">
                    <div className="tg-panel__row">
                      <div>
                        <h5 className="tg-panel__title">
                          <IoTrendingUp
                            style={{ color: "#1EA355", fontSize: "22px" }}
                          />
                          Top Gainers —{" "}
                          {topGainersData[selectedCategory]?.label}
                        </h5>
                        <p className="tg-panel__meta">
                          {topGainersData[selectedCategory]?.timestamp}
                        </p>
                      </div>
                      <div className="tg-panel__actions">
                        <CustomSelect
                          value={selectedCategory}
                          onChange={(e) => handleCategoryChange(e.target.value)}
                          options={topGainerCategoryOptions}
                          aria-label={tr("allSecurities")}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="tg-hero-grid">
                    {currentTopGainers.slice(0, 3).map((stock, index) => {
                      const icons = [
                        <FaTrophy key="t" />,
                        <FaMedal key="m" />,
                        <FaAward key="a" />,
                      ];
                      const rankClass = `tg-hero-card--${index + 1}`;

                      const scripCode = stock.scripcode;
                      const livePrice =
                        livePriceCache.current[scripCode] || stock.ltp;
                      const livePClose =
                        livePCloseCache.current[scripCode] ||
                        findTopGainerStockData(selectedCategory, stock)
                          ?.prev_price ||
                        stock.ltp;

                      const liveChange = livePrice - livePClose;
                      const livePerChange = livePClose
                        ? (liveChange / livePClose) * 100
                        : stock.perChange;

                      return (
                        <div
                          key={index}
                          className={`tg-hero-card ${rankClass}`}
                        >
                          <div className="tg-hero-card__shine" aria-hidden />

                          <div className="tg-hero-card__top">
                            <div className="tg-hero-card__symbol-block">
                              <div className="tg-hero-card__icon">
                                {icons[index]}
                              </div>
                              <div>
                                <div className="tg-hero-card__symbol">
                                  {stock.symbol}
                                </div>
                                <div className="tg-hero-card__rank">
                                  RANK #{stock.rank}
                                </div>
                              </div>
                            </div>
                            <div className="tg-hero-card__chg">
                              <i className="icon-arrow-up" aria-hidden />
                              +{livePerChange.toFixed(2)}%
                            </div>
                          </div>

                          <div className="tg-hero-card__bottom">
                            <div className="tg-hero-card__name">
                              {stock.fullName}
                            </div>
                            <div className="tg-hero-card__price">
                              ₹
                              {livePrice.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Professional Full Table */}
                  <div className="table_main">
                    <div className="table_title_with_view_all_row">
                      <h5>All Gainers ({currentTopGainers.length} stocks)</h5>
                    </div>

                    <div className="table-responsive db-top-gainers-table-wrap">
                      <style>{`
                        .db-top-gainers-table-wrap{
                          overflow-x: auto !important;
                          overflow-y: auto !important;
                          max-height: calc(100vh - 280px);
                          position: relative;
                        }
                        .db-top-gainers-table{
                          border-collapse: separate;
                          border-spacing: 0;
                          width: 100%;
                          min-width: 980px;
                        }
                        .db-top-gainers-table thead{
                          position: sticky;
                          top: 0;
                          z-index: 50;
                        }
                        .db-top-gainers-table thead tr{
                          position: relative;
                          background: #f8fbff !important;
                        }
                        .db-top-gainers-table thead th{
                          position: -webkit-sticky !important;
                          position: sticky !important;
                          top: 0 !important;
                          z-index: 55 !important;
                          background: #f8fbff !important;
                        }
                      `}</style>
                      <table className="table db-top-gainers-table">
                        {/* Thead */}
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}>
                              <div
                                className="table_head_search"
                                style={{ marginLeft: "15px" }}
                              >
                                <div style={{ padding: "2px" }}>
                                  <button
                                    style={{
                                      padding: "2px 0 2px 5px",
                                      borderRight: "1px solid #e4e4e4ff",
                                    }}
                                    onClick={() =>
                                      topGainersSearchInputRef.current?.focus()
                                    }
                                  >
                                    <i className="icon-search" />
                                  </button>
                                  <input
                                    type="text"
                                    placeholder={tr("nameSearchHere")}
                                    style={{
                                      paddingLeft: "10px",
                                      marginLeft: "5px",
                                    }}
                                    value={topGainersSearchQuery}
                                    onChange={(e) =>
                                      setTopGainersSearchQuery(e.target.value)
                                    }
                                    ref={topGainersSearchInputRef}
                                  />
                                </div>
                              </div>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={
                                  <Tooltip className="common__tooltip">
                                    {tr("rankTooltip")}
                                  </Tooltip>
                                }
                              >
                                <span>{tr("rank")}</span>
                              </Whisper>
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              onClick={() => handleTopGainersSort("ltp")}
                            >
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={
                                  <Tooltip className="common__tooltip">
                                    {tr("currentPrice")}:{" "}
                                    {tr("currentPriceTooltip")}
                                  </Tooltip>
                                }
                              >
                                <span>
                                  LTP{" "}
                                  {topGainersSortBy === "ltp" &&
                                    (topGainersSortOrder === "asc" ? "↑" : "↓")}
                                </span>
                              </Whisper>
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              onClick={() => handleTopGainersSort("perChange")}
                            >
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={
                                  <Tooltip className="common__tooltip">
                                    {tr("changePercentTooltip")}
                                  </Tooltip>
                                }
                              >
                                <span>
                                  Change %{" "}
                                  {topGainersSortBy === "perChange" &&
                                    (topGainersSortOrder === "asc" ? "↑" : "↓")}
                                </span>
                              </Whisper>
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              onClick={() => handleTopGainersSort("open_price")}
                            >
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={
                                  <Tooltip className="common__tooltip">
                                    {tr("todaysOpenTooltip")}
                                  </Tooltip>
                                }
                              >
                                <span>
                                  Open{" "}
                                  {topGainersSortBy === "open_price" &&
                                    (topGainersSortOrder === "asc" ? "↑" : "↓")}
                                </span>
                              </Whisper>
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              onClick={() => handleTopGainersSort("prev_price")}
                            >
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={
                                  <Tooltip className="common__tooltip">
                                    {tr("previousCloseTooltip")}
                                  </Tooltip>
                                }
                              >
                                <span>
                                  Prev Close{" "}
                                  {topGainersSortBy === "prev_price" &&
                                    (topGainersSortOrder === "asc" ? "↑" : "↓")}
                                </span>
                              </Whisper>
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              onClick={() => handleTopGainersSort("high_price")}
                            >
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={
                                  <Tooltip className="common__tooltip">
                                    {tr("todaysHighTooltip")}
                                  </Tooltip>
                                }
                              >
                                <span>
                                  High{" "}
                                  {topGainersSortBy === "high_price" &&
                                    (topGainersSortOrder === "asc" ? "↑" : "↓")}
                                </span>
                              </Whisper>
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              onClick={() => handleTopGainersSort("low_price")}
                            >
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={
                                  <Tooltip className="common__tooltip">
                                    {tr("todaysLowTooltip")}
                                  </Tooltip>
                                }
                              >
                                <span>
                                  Low{" "}
                                  {topGainersSortBy === "low_price" &&
                                    (topGainersSortOrder === "asc" ? "↑" : "↓")}
                                </span>
                              </Whisper>
                            </th>
                            <th
                              style={{
                                textAlign: "center",
                                cursor: "pointer",
                                userSelect: "none",
                              }}
                              onClick={() =>
                                handleTopGainersSort("trade_quantity")
                              }
                            >
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={
                                  <Tooltip className="common__tooltip">
                                    {tr("volumeTooltip")}
                                  </Tooltip>
                                }
                              >
                                <span>
                                  Volume{" "}
                                  {topGainersSortBy === "trade_quantity" &&
                                    (topGainersSortOrder === "asc" ? "↑" : "↓")}
                                </span>
                              </Whisper>
                            </th>
                          </tr>
                        </thead>

                        {/* Tbody - Keep same as before */}
                        <tbody>
                          {(() => {
                            let stocks = [...currentTopGainers];

                            if (topGainersSortBy) {
                              stocks = stocks.sort((a, b) => {
                                const scripCodeA = a.scripcode;
                                const scripCodeB = b.scripcode;

                                let aValue, bValue;

                                if (topGainersSortBy === "ltp") {
                                  aValue =
                                    livePriceCache.current[scripCodeA] || a.ltp;
                                  bValue =
                                    livePriceCache.current[scripCodeB] || b.ltp;
                                } else if (topGainersSortBy === "perChange") {
                                  const aPClose =
                                    livePCloseCache.current[scripCodeA] ||
                                    findTopGainerStockData(
                                      selectedCategory,
                                      a,
                                    )?.prev_price ||
                                    a.ltp;
                                  const bPClose =
                                    livePCloseCache.current[scripCodeB] ||
                                    findTopGainerStockData(
                                      selectedCategory,
                                      b,
                                    )?.prev_price ||
                                    b.ltp;
                                  const aLivePrice =
                                    livePriceCache.current[scripCodeA] || a.ltp;
                                  const bLivePrice =
                                    livePriceCache.current[scripCodeB] || b.ltp;
                                  aValue =
                                    ((aLivePrice - aPClose) / aPClose) * 100;
                                  bValue =
                                    ((bLivePrice - bPClose) / bPClose) * 100;
                                } else if (topGainersSortBy === "high_price") {
                                  const aData = findTopGainerStockData(
                                    selectedCategory,
                                    a,
                                  );
                                  const bData = findTopGainerStockData(
                                    selectedCategory,
                                    b,
                                  );
                                  aValue =
                                    liveHighCache.current[scripCodeA] ||
                                    aData?.high_price ||
                                    0;
                                  bValue =
                                    liveHighCache.current[scripCodeB] ||
                                    bData?.high_price ||
                                    0;
                                } else if (topGainersSortBy === "low_price") {
                                  const aData = findTopGainerStockData(
                                    selectedCategory,
                                    a,
                                  );
                                  const bData = findTopGainerStockData(
                                    selectedCategory,
                                    b,
                                  );
                                  aValue =
                                    liveLowCache.current[scripCodeA] ||
                                    aData?.low_price ||
                                    0;
                                  bValue =
                                    liveLowCache.current[scripCodeB] ||
                                    bData?.low_price ||
                                    0;
                                } else if (topGainersSortBy === "open_price") {
                                  const aData = findTopGainerStockData(
                                    selectedCategory,
                                    a,
                                  );
                                  const bData = findTopGainerStockData(
                                    selectedCategory,
                                    b,
                                  );
                                  aValue = aData?.open_price || 0;
                                  bValue = bData?.open_price || 0;
                                } else if (topGainersSortBy === "prev_price") {
                                  const aData = findTopGainerStockData(
                                    selectedCategory,
                                    a,
                                  );
                                  const bData = findTopGainerStockData(
                                    selectedCategory,
                                    b,
                                  );
                                  aValue = aData?.prev_price || 0;
                                  bValue = bData?.prev_price || 0;
                                } else if (
                                  topGainersSortBy === "trade_quantity"
                                ) {
                                  const aData = findTopGainerStockData(
                                    selectedCategory,
                                    a,
                                  );
                                  const bData = findTopGainerStockData(
                                    selectedCategory,
                                    b,
                                  );
                                  aValue = aData?.trade_quantity || 0;
                                  bValue = bData?.trade_quantity || 0;
                                }

                                if (typeof aValue === "string")
                                  aValue = parseFloat(aValue) || 0;
                                if (typeof bValue === "string")
                                  bValue = parseFloat(bValue) || 0;

                                if (topGainersSortOrder === "asc") {
                                  return aValue - bValue;
                                } else {
                                  return bValue - aValue;
                                }
                              });
                            }

                            const filteredStocks = stocks.filter(
                              (stock) =>
                                stock.symbol
                                  ?.toLowerCase()
                                  .includes(
                                    topGainersSearchQuery.toLowerCase(),
                                  ) ||
                                stock.fullName
                                  ?.toLowerCase()
                                  .includes(
                                    topGainersSearchQuery.toLowerCase(),
                                  ),
                            );

                            const indexOfLastItem =
                              topGainersCurrentPage * topGainersPageSize;
                            const indexOfFirstItem =
                              indexOfLastItem - topGainersPageSize;
                            const currentItems = filteredStocks.slice(
                              indexOfFirstItem,
                              indexOfLastItem,
                            );

                            if (currentItems.length === 0) {
                              return (
                                <tr>
                                  <td
                                    colSpan={9}
                                    style={{
                                      textAlign: "center",
                                      padding: "20px",
                                      color: "#999",
                                    }}
                                  >
                                    {tr("noMatchFound")}
                                  </td>
                                </tr>
                              );
                            }

                            return currentItems.map((stock, index) => {
                              const scripCode = stock.scripcode;
                              const apiStockData = findTopGainerStockData(
                                selectedCategory,
                                stock,
                              );

                              const livePrice =
                                livePriceCache.current[scripCode] || stock.ltp;
                              const livePClose =
                                livePCloseCache.current[scripCode] ||
                                apiStockData?.prev_price ||
                                stock.ltp;
                              const liveHigh =
                                liveHighCache.current[scripCode] ||
                                apiStockData?.high_price ||
                                0;
                              const liveLow =
                                liveLowCache.current[scripCode] ||
                                apiStockData?.low_price ||
                                0;

                              const liveChange = livePrice - livePClose;
                              const livePerChange = livePClose
                                ? (liveChange / livePClose) * 100
                                : stock.perChange;
                              const isPositive = livePerChange >= 0;

                              const isNearHigh =
                                liveHigh > 0 &&
                                Math.abs(
                                  ((livePrice - liveHigh) / liveHigh) * 100,
                                ) < 0.5;
                              const isNearLow =
                                liveLow > 0 &&
                                Math.abs(
                                  ((livePrice - liveLow) / liveLow) * 100,
                                ) < 0.5;

                              return (
                                <tr key={stock.symbol || index}>
                                  <td style={{ textAlign: "left", paddingRight: "28px !important" }}>
                                    <div className="main_table_company_cell">
                                      <div style={{ paddingLeft: "15px" }}>
                                        <h5 className="uppercase">
                                          {stock.fullName}
                                        </h5>
                                        <ul
                                          className="company_table_tags"
                                          style={{ paddingLeft: "0" }}
                                        >
                                          <li className="csymbol">
                                            {stock.symbol}
                                          </li>
                                          <li className="cbse_nse">NSE-CASH</li>
                                        </ul>
                                      </div>
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div className="trade__price__cell">
                                      {stock.rank === 1 && (
                                        <FaTrophy
                                          style={{
                                            color: "#2457BF",
                                            fontSize: "20px",
                                          }}
                                        />
                                      )}
                                      {stock.rank === 2 && (
                                        <FaMedal
                                          style={{
                                            color: "#1EA355",
                                            fontSize: "20px",
                                          }}
                                        />
                                      )}
                                      {stock.rank === 3 && (
                                        <FaAward
                                          style={{
                                            color: "#D67A1F",
                                            fontSize: "20px",
                                          }}
                                        />
                                      )}
                                      {stock.rank > 3 && `#${stock.rank}`}
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div
                                      className={`trade__price__cell ${isPositive ? "text_success_color" : "text_danger_color"}`}
                                    >
                                      ₹
                                      {livePrice.toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                      <i
                                        className={`icon-arrow-${isPositive ? "up" : "down"}`}
                                      ></i>
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div
                                      className={`trade__price__cell ${isPositive ? "text_success_color" : "text_danger_color"}`}
                                    >
                                      {isPositive ? "+" : ""}
                                      {livePerChange.toFixed(2)}%
                                      <i
                                        className={`icon-arrow-${isPositive ? "up" : "down"}`}
                                      />
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div className="trade__price__cell">
                                      ₹
                                      {apiStockData?.open_price.toFixed(2) ||
                                        "0.00"}
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div className="trade__price__cell">
                                      ₹{livePClose.toFixed(2)}
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div
                                      className={`trade__price__cell ${isNearHigh ? "text_warning_color" : ""}`}
                                    >
                                      ₹{liveHigh.toFixed(2)}
                                      {isNearHigh && (
                                        <i
                                          className="icon-arrow-up"
                                          style={{
                                            color: "#FFA726",
                                            marginLeft: "4px",
                                          }}
                                        ></i>
                                      )}
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div
                                      className={`trade__price__cell ${isNearLow ? "text_danger_color" : ""}`}
                                    >
                                      ₹{liveLow.toFixed(2)}
                                      {isNearLow && (
                                        <i
                                          className="icon-arrow-down"
                                          style={{
                                            color: "#EF5350",
                                            marginLeft: "4px",
                                          }}
                                        ></i>
                                      )}
                                    </div>
                                  </td>

                                  <td style={{ textAlign: "center" }}>
                                    <div className="trade__price__cell">
                                      {apiStockData?.volume_formatted || "0"}
                                    </div>
                                  </td>
                                </tr>
                              );
                            });
                          })()}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Footer - Keep same as before */}
                    {currentTopGainers.length > 0 &&
                      (() => {
                        const filteredStocks = currentTopGainers.filter(
                          (stock) =>
                            stock.symbol
                              ?.toLowerCase()
                              .includes(topGainersSearchQuery.toLowerCase()) ||
                            stock.fullName
                              ?.toLowerCase()
                              .includes(topGainersSearchQuery.toLowerCase()),
                        );
                        const totalPages = Math.ceil(
                          filteredStocks.length / topGainersPageSize,
                        );
                        const indexOfLastItem =
                          topGainersCurrentPage * topGainersPageSize;
                        const indexOfFirstItem =
                          indexOfLastItem - topGainersPageSize;

                        const getTopGainersPageNumbers = () => {
                          const pages = [];

                          if (topGainersCurrentPage > 1) {
                            pages.push(topGainersCurrentPage - 1);
                          }

                          pages.push(topGainersCurrentPage);

                          if (topGainersCurrentPage < totalPages) {
                            pages.push(topGainersCurrentPage + 1);
                          }

                          return pages;
                        };

                        return (
                          <div className="table__footer_row">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <h6>
                                {getItemsRangeText(
                                  indexOfFirstItem + 1,
                                  Math.min(
                                    indexOfLastItem,
                                    filteredStocks.length,
                                  ),
                                  filteredStocks.length,
                                )}
                              </h6>
                              <TablePageSizeSelect
                                value={topGainersPageSize}
                                onChange={handleTopGainersPageSizeChange}
                              />
                            </div>

                            <nav aria-label="Page navigation example">
                              <ul className="pagination justify-content-center">
                                <li
                                  className={`page-item ${topGainersCurrentPage === 1 ? "disabled" : ""}`}
                                >
                                  <a
                                    className="page-link"
                                    onClick={() =>
                                      topGainersCurrentPage > 1 &&
                                      handleTopGainersPageChange(1)
                                    }
                                    style={{
                                      cursor:
                                        topGainersCurrentPage === 1
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <MdKeyboardDoubleArrowLeft
                                      style={{ fontSize: "18px" }}
                                    />
                                  </a>
                                </li>
                                <li
                                  className={`page-item ${topGainersCurrentPage === 1 ? "disabled" : ""}`}
                                >
                                  <a
                                    className="page-link"
                                    onClick={() =>
                                      topGainersCurrentPage > 1 &&
                                      handleTopGainersPageChange(
                                        topGainersCurrentPage - 1,
                                      )
                                    }
                                    style={{
                                      cursor:
                                        topGainersCurrentPage === 1
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <IoIosArrowBack />
                                  </a>
                                </li>
                                {getTopGainersPageNumbers().map((pageNum) => (
                                  <li
                                    key={pageNum}
                                    className={`page-item ${topGainersCurrentPage === pageNum ? "active" : ""}`}
                                  >
                                    <a
                                      className="page-link"
                                      onClick={() =>
                                        handleTopGainersPageChange(pageNum)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {pageNum}
                                    </a>
                                  </li>
                                ))}
                                <li
                                  className={`page-item ${topGainersCurrentPage === totalPages ? "disabled" : ""}`}
                                >
                                  <a
                                    className="page-link"
                                    onClick={() =>
                                      topGainersCurrentPage < totalPages &&
                                      handleTopGainersPageChange(
                                        topGainersCurrentPage + 1,
                                      )
                                    }
                                    style={{
                                      cursor:
                                        topGainersCurrentPage === totalPages
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <IoIosArrowForward />
                                  </a>
                                </li>
                                <li
                                  className={`page-item ${topGainersCurrentPage === totalPages ? "disabled" : ""}`}
                                >
                                  <a
                                    className="page-link"
                                    onClick={() =>
                                      topGainersCurrentPage < totalPages &&
                                      handleTopGainersPageChange(totalPages)
                                    }
                                    style={{
                                      cursor:
                                        topGainersCurrentPage === totalPages
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <MdKeyboardDoubleArrowRight
                                      style={{ fontSize: "18px" }}
                                    />
                                  </a>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        );
                      })()}
                  </div>
                </>
              )}
            </div>
          )}


        </div>
      </div>

      {/* Buy Sell Modal */}
      <div
        className="modal fade modal_md modern-trading-modal"
        id="BuySellModal"
        aria-labelledby="BuySellModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-modern">
          <div className="modal-content modal-content-modern">
            {/* Modal Header */}
            <div className="modal-header modal-header-modern">
              <div className="modal-header-content">
                <div className="modal-title-wrapper">
                  <div className={`trading-type-badge ${buySellModalDetails.Type.toLowerCase()}`}>
                    <img
                      src={
                        buySellModalDetails.Type === "Buy"
                          ? ArrowTrendUp
                          : ArrowTrendDown
                      }
                      className="trading-icon"
                      alt="icon"
                    />
                    <span className="trading-type-text">{buySellModalDetails.Type}</span>
                  </div>
                  <h3 className="modal-title-modern">
                    {buySellModalDetails.Symbol}
                  </h3>
                </div>
                <button
                  type="button"
                  className="btn-close-modern"
                  data-bs-dismiss="modal"
                  aria-label={tr("close")}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>

            <div className="modal-body modal-body-modern">
              <AnimatePresence mode="wait">
                {/* Screen 1 */}
                {!isPreview && (
                  <motion.div
                    key="screen1"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    {/* <div className="sell__content" style={{backgroundColor:{buySellModalDetails.Type === "BUY" ? "yellow" : "red"}}}> */}
                    <div
                      className="sell__content"
                      style={{
                        backgroundColor:
                          buySellModalDetails.Type === "Buy"
                            ? "#F6FCF9"
                            : "#fff7f7",
                        border: `1px solid ${buySellModalDetails.Type === "Buy" ? "#B5E8CF" : "#F5B5B5"}`,
                      }}
                    >
                      <div className="sell__content_inner d-flex justify-content-between align-items-center">
                        <div>
                          <h5 className="mb-0">{buySellModalDetails.Symbol}</h5>
                          <h6 className="mb-0">
                            {buySellModalDetails.FullName}
                          </h6>
                        </div>
                        {/* LivePrice/ Current Price */}
                        <p className="mb-0">
                          {(() => {
                            const cacheKey = getOrderLivePriceCacheKey(
                              buySellModalDetails.order,
                            );

                            const livePrice = livePriceCache.current[cacheKey];
                            const pClose = livePCloseCache.current[cacheKey];
                            const changePercent =
                              liveChangePercentageCache.current[cacheKey];

                            const currentPrice =
                              livePrice ||
                              buySellModalDetails.order?.CurrentPrice ||
                              0;
                            const previousClose =
                              pClose ||
                              buySellModalDetails.order?.CurrentPrice ||
                              0;
                            const actualChangePercent = changePercent || 0;

                            const isPositive =
                              parseFloat(currentPrice) >=
                              parseFloat(previousClose);

                            return (
                              <>
                                ₹ {formatNumber(currentPrice)} <br />
                                <span
                                  className={
                                    isPositive ? "text-success" : "text-danger"
                                  }
                                >
                                  ({isPositive ? "+" : ""}
                                  {actualChangePercent
                                    ? actualChangePercent.toFixed(2)
                                    : "0.00"}
                                  %)
                                  <i
                                    className={`icon-arrow-${isPositive ? "up" : "down"} ms-1`}
                                    style={{ fontSize: "0.8em" }}
                                  ></i>
                                </span>
                              </>
                            );
                          })()}
                        </p>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', color: '#64748b', marginBottom: '6px' }}>{tr("orderType")}</label>
                        <SelectPicker
                          data={OrderType}
                          searchable={false}
                          container={document.body}
                          className="custom-select-picker"
                          value={orderType}
                          onChange={setOrderType}
                        />
                      </div>

                      {/* <div className="col-md-6">
                                    <label className="form-label">{tr("qty")}</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={qty}
                                      onChange={(e) => setQty(Number(e.target.value))}
                                    />
                                  </div> */}
                      <div className="col-md-6">
                        <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', color: '#64748b', marginBottom: '6px' }}>Qty</label>
                        <input
                          type="number"
                          className="form-control"
                          value={buySellModalDetails.OrderQty}
                          onChange={(e) =>
                            setBuySellModalDetails((prev) => ({
                              ...prev,
                              OrderQty: Number(e.target.value),
                            }))
                          }
                          style={{
                            width: "100%",
                            height: "44px",
                            borderRadius: "10px",
                            border: "1px solid #d5dfed",
                            padding: "10px 12px",
                            fontSize: "14px",
                            color: "#0f172a",
                            outline: "none",
                            boxShadow: "none"
                          }}
                        />
                      </div>
                    </div>

                    {/* {orderType === "Limit Order" && (
                                  <div className="mt-3">
                                    <label className="form-label">{tr("limitPrice")}</label>
                                    <input type="number" className="form-control" />
                                  </div>
                                )} */}
                    {orderType === "Limit Order" && (
                      <div className="mt-3">
                        <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', color: '#64748b', marginBottom: '6px' }}>{tr("limitPrice")}</label>
                        <input
                          type="number"
                          className="form-control"
                          value={buySellModalDetails.LimitPrice}
                          onChange={(e) =>
                            setBuySellModalDetails((prev) => ({
                              ...prev,
                              LimitPrice: Number(e.target.value),
                            }))
                          }
                          style={{
                            width: "100%",
                            height: "44px",
                            borderRadius: "10px",
                            border: "1px solid #d5dfed",
                            padding: "10px 12px",
                            fontSize: "14px",
                            color: "#0f172a",
                            outline: "none",
                            boxShadow: "none"
                          }}
                        />
                      </div>
                    )}

                    {buySellModalDetails.OrderQty > 0 && (
                      <motion.div
                        className="order-summary mt-4 p-3 border roundedX"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.4 }}
                        style={{
                          backgroundColor:
                            buySellModalDetails.Type === "Buy"
                              ? "#F6FCF9"
                              : "#fff7f7",
                          border: `1px solid ${buySellModalDetails.Type === "Buy" ? "#B5E8CF" : "#F5B5B5"}`,
                        }}
                      >
                        <h6 className="fw-bold mb-3">{tr("orderSummary")}</h6>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("orderType")}</span>
                          <span className="value">{orderType}</span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("quantity")}</span>
                          <span className="value">
                            {buySellModalDetails.OrderQty} shares
                          </span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("pricePerShare")}</span>
                          <span className="value">
                            ₹{formatNumber(getPriceForCalculation())}
                          </span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("subtotal")}</span>
                          <span className="value">
                            ₹
                            {formatNumber(
                              buySellModalDetails.OrderQty *
                              getPriceForCalculation(),
                            )}
                          </span>
                        </div>
                        <div className="order-row d-flex justify-content-between">
                          <span className="label">{tr("estFees")}</span>
                          <span className="value">₹0.00</span>
                        </div>
                        <hr />
                        <div className="order-total d-flex justify-content-between fw-bold">
                          <span>{tr("totalAmount")}</span>
                          <span>
                            ₹
                            {formatNumber(
                              buySellModalDetails.OrderQty *
                              getPriceForCalculation() +
                              0.0,
                            )}
                          </span>
                        </div>
                      </motion.div>
                    )}
                  </motion.div>
                )}

                {/* Screen 2 */}
                {isPreview && (
                  <motion.div
                    key="screen2"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <div className="text-center mb-3">
                      <div
                        className="preview_order_icon preview_buy_order_icon"
                        style={{
                          backgroundColor:
                            buySellModalDetails.Type === "Buy"
                              ? "#E1FBE9"
                              : "#fff7f7",
                        }}
                      >
                        {/* <img src={ArrowTrendDown} alt="icon" /> */}
                        <img
                          src={
                            buySellModalDetails.Type === "Buy"
                              ? ArrowTrendUp
                              : ArrowTrendDown
                          }
                          alt="icon"
                        />
                      </div>
                      <h5>{tr("confirmOrder")}</h5>
                      <p>{tr("pleaseReviewOrderDetails")}</p>
                    </div>

                    <div className="order-summary-content">
                      <div className="order-row">
                        <span className="label">{tr("orderType")}</span>
                        <span className="value">{orderType}</span>
                      </div>

                      <div className="order-row">
                        <span className="label">{tr("quantity")}</span>
                        <span className="value">
                          {buySellModalDetails.OrderQty} shares
                        </span>
                      </div>

                      <div className="order-row">
                        <span className="label">{tr("pricePerShare")}</span>
                        <span className="value">
                          ₹{formatNumber(getPriceForCalculation())}
                        </span>
                      </div>

                      <div className="order-row">
                        <span className="label">{tr("subtotal")}</span>
                        <span className="value capitalize">
                          ₹
                          {formatNumber(
                            buySellModalDetails.OrderQty *
                            getPriceForCalculation(),
                          )}
                        </span>
                      </div>

                      <div className="order-row">
                        <span className="label">{tr("estFees")}</span>
                        <span className="value capitalize">₹0.00</span>
                      </div>

                      <div className="divider"></div>

                      <div className="order-total">
                        <span className="total-label">{tr("totalAmount")}</span>
                        <span className="total-value">
                          ₹
                          {formatNumber(
                            buySellModalDetails.OrderQty *
                            getPriceForCalculation(),
                          )}
                        </span>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div
              className="modal-footer modal__footer_btn"
              style={{ width: "100%" }}
            >
              {!isPreview ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    gap: "0.75rem",
                  }}
                >
                  <button
                    type="button"
                    className="btn-modern btn-secondary-modern"
                    data-bs-dismiss="modal"
                  >
                    {tr("cancel")}
                  </button>

                  <button
                    type="button"
                    className="btn-modern"
                    onClick={handlePreview}
                  >
                    {tr("previewOrder")}
                  </button>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      gap: "0.75rem",
                    }}
                  >
                    <button
                      type="button"
                      className="btn-modern btn-secondary-modern"
                      onClick={handleGoBack}
                    >
                      {tr("goBack")}
                    </button>

                    <button
                      type="button"
                      className={`btn-modern btn-success-modern ${buySellModalDetails.Type === 'Buy' ? 'buy' : 'sell'}`}
                      onClick={(e) => {
                        fetchDataPortfolio(
                          buySellModalDetails.order,
                          buySellModalDetails.Type,
                          "Portfolio",
                        );
                        e.target.disabled = true;
                        e.target.textContent = tr("processing");

                        setTimeout(() => {
                          setIsPreview(false); // or handleGoBack()
                          e.target.disabled = false;
                          e.target.textContent = tr("confirmOrder");
                        }, 1000);
                      }}
                      data-bs-dismiss="modal"
                    >
                      {tr("confirmOrder")}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* MarketDepth Modal */}
      {/* Market Depth Popover */}
      {showMarketDepth && (
        <MarketDepthPopover
          popoverRef={marketDepthPopoverRef}
          position={marketDepthPosition}
          depthRows={currentMDModal ? marketDepth || [] : []}
          onClose={closeMarketDepthPopover}
          tr={tr}
          formatNumber={formatNumber}
        />
      )}

      {showAdditionalColumnsDropdown &&
        typeof document !== "undefined" &&
        createPortal(
          <div
            ref={additionalColumnsDropdownRef}
            className="watchlist-columns-dropdown"
            style={{
              position: "fixed",
              top: additionalColumnsDropdownPos.top,
              left: additionalColumnsDropdownPos.left,
              width: 320,
              background: "#ffffff",
              border: "1px solid #dce6f3",
              borderRadius: 12,
              boxShadow: "0 16px 36px rgba(15, 23, 42, 0.18)",
              padding: 12,
              zIndex: 1500,
            }}
          >
            <div style={{ marginBottom: 8 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 8,
                  marginBottom: 8,
                }}
              >
                <div style={{ fontSize: 14, fontWeight: 700, color: "#1f2d42" }}>
                  {tr("additionalColumns")}
                </div>
                <button
                  type="button"
                  onClick={async () => {
                    await resetColumnOrder();
                    setShowAdditionalColumnsDropdown(false);
                  }}
                  style={{
                    border: "none",
                    background: "transparent",
                    color: "#2457bf",
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  {tr("reset")}
                </button>
              </div>
              <div className="column-picker-search">
                <div className="column-picker-search-inner">
                  <i className="icon-search" style={{ fontSize: "14px", color: "#64748b" }} />
                  <input
                    type="text"
                    placeholder={tr("searchColumnsPlaceholder")}
                    value={columnSearch}
                    onChange={(e) => setColumnSearch(e.target.value)}
                    className="column-picker-search-input"
                  />
                </div>
              </div>
            </div>

            <div
              className="column-picker-list-scroll"
              ref={additionalColumnsScrollRef}
              style={{ maxHeight: 300 }}
            >
              {filteredColumns.length === 0 ? (
                <div className="column-picker-empty">{tr("noColumnsMatchSearch")}</div>
              ) : (
                filteredColumns.map((col, index) => (
                  <label
                    key={col.colName}
                    className="column-picker-row"
                    htmlFor={`inline-col-check-${index}`}
                  >
                    <input
                      type="checkbox"
                      value={col.colName}
                      id={`inline-col-check-${index}`}
                      checked={tempCheckedNames.includes(col.colName)}
                      onChange={(e) =>
                        handleCheckboxChange(col.colName, e.target.checked)
                      }
                    />
                    <span className="column-picker-row-label">{col.UIName}</span>
                  </label>
                ))
              )}
            </div>
          </div>,
          document.body,
        )}

      {/* <!--  Add New Watchlist Modal - Premium Design --> */}
      <div
        className="modal fade"
        id="createNewWatchlistModal"
        aria-labelledby="createNewWatchlistModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{
              border: "none",
              borderRadius: "16px",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
              overflow: "hidden",
              backgroundColor: "#ffffff",
            }}
          >
            {/* Premium Header */}
            <div
              className="modal-header"
              style={{
                background: "#d1ddec",
                border: "none",
                padding: "24px 28px",
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: "34px",
                    height: "34px",
                    borderRadius: "10px",
                    background: "rgba(255, 255, 255, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <i
                    className="icon-plus"
                    style={{ color: "#1a42a0", fontSize: "12px" }}
                  ></i>
                </div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#000000",
                    letterSpacing: "-0.3px",
                  }}
                >
                  {tr("createNewWatchlist")}
                </h2>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label={tr("close")}
                onClick={() => {
                  setNewWatchlistName("");
                  setWatchlistError("");
                }}
                style={{
                  filter: "none",
                  color: "#6b7280",
                  opacity: 1,
                  width: "32px",
                  height: "32px",
                  background: "transparent",
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "none",
                  transition: "color 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#4b5563";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "#6b7280";
                }}
              >
                <IoClose size={24} />
              </button>
            </div>

            <div
              className="modal-body"
              style={{ padding: "28px", backgroundColor: "#F2F7FD" }}
            >
              {/* Max watchlist limit error - Premium Design */}
              {userWatchlists.length >= 5 && (
                <div
                  style={{
                    padding: "16px 18px",
                    background:
                      "linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%)",
                    borderRadius: "12px",
                    marginBottom: "24px",
                    border: "1px solid rgba(231, 76, 60, 0.3)",
                    boxShadow: "0 4px 12px rgba(231, 76, 60, 0.08)",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      color: "#c62828",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                      lineHeight: "1.6",
                    }}
                  >
                    <i
                      className="icon-alert"
                      style={{ fontSize: "18px", marginTop: "1px" }}
                    ></i>
                    <span>{tr("maximum5WatchlistsAllowedDetailed")}</span>
                  </p>
                </div>
              )}

              {/* Premium Input field */}
              <div style={{ marginBottom: "24px" }}>
                <label
                  htmlFor="watchlistNameInput"
                  style={{
                    display: "block",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#1a1a1a",
                    letterSpacing: "-0.2px",
                  }}
                >
                  {tr("watchlistName")}{" "}
                  <span style={{ color: "#D67A1F", marginLeft: "2px" }}>*</span>
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    id="watchlistNameInput"
                    className="form-control"
                    placeholder={tr("watchlistNamePlaceholder")}
                    value={newWatchlistName}
                    onChange={(e) => {
                      setNewWatchlistName(e.target.value);
                      setWatchlistError("");
                    }}
                    maxLength={30}
                    disabled={userWatchlists.length >= 5}
                    style={{
                      padding: "14px 16px",
                      fontSize: "14px",
                      border: watchlistError
                        ? "2px solid #ef5350"
                        : "2px solid #e0e7ef",
                      borderRadius: "10px",
                      backgroundColor: "#ffffff",
                      color: "#1a1a1a",
                      transition: "all 0.3s",
                      outline: "none",
                      fontWeight: "500",
                    }}
                    onFocus={(e) => {
                      if (!watchlistError) {
                        e.target.style.border = "2px solid #2457BF";
                        e.target.style.boxShadow =
                          "0 0 0 4px rgba(36, 87, 191, 0.1)";
                      }
                    }}
                    onBlur={(e) => {
                      if (!watchlistError) {
                        e.target.style.border = "2px solid #e0e7ef";
                        e.target.style.boxShadow = "none";
                      }
                    }}
                  />
                </div>

                {/* Character counter - Premium */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "8px",
                    fontSize: "12px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  <span
                    style={{
                      color:
                        newWatchlistName.length >= 25 ? "#D67A1F" : "#64748b",
                    }}
                  >
                    {newWatchlistName.length}/30 {tr("characters")}
                  </span>
                  {newWatchlistName.length >= 25 && (
                    <span style={{ color: "#D67A1F", fontSize: "11px" }}>
                      {30 - newWatchlistName.length} {tr("remaining")}
                    </span>
                  )}
                </div>

                {/* Error message - Premium */}
                {watchlistError && (
                  <div
                    style={{
                      color: "#c62828",
                      fontSize: "13px",
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "10px 12px",
                      backgroundColor: "#fff5f5",
                      borderRadius: "8px",
                      border: "1px solid rgba(231, 76, 60, 0.2)",
                    }}
                  >
                    <i className="icon-alert" style={{ fontSize: "16px" }}></i>
                    <span>{watchlistError}</span>
                  </div>
                )}
              </div>

              {/* Quick suggestions - Premium Design */}
              {userWatchlists.length < 5 && (
                <div style={{ marginBottom: "24px" }}>
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#64748b",
                      marginBottom: "12px",
                      fontWeight: "600",
                      letterSpacing: "-0.1px",
                    }}
                  >
                    {tr("quickSuggestions")}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    {[
                      "Second Watchlist",
                      "Third Watchlist",
                      "Fourth Watchlist",
                      "Fifth Watchlist",
                    ]
                      .filter(
                        (suggestion) => !userWatchlists.includes(suggestion),
                      )
                      .slice(0, 5 - userWatchlists.length)
                      .map((suggestion, index) => (
                        <button
                          key={index}
                          type="button"
                          onClick={() => setNewWatchlistName(suggestion)}
                          style={{
                            padding: "8px 16px",
                            fontSize: "13px",
                            fontWeight: "500",
                            backgroundColor: "#ffffff",
                            color: "#2457BF",
                            border: "1.5px solid #e0e7ef",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "all 0.2s",
                            letterSpacing: "-0.1px",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "#2457BF";
                            e.target.style.color = "#ffffff";
                            e.target.style.borderColor = "#2457BF";
                            e.target.style.transform = "translateY(-1px)";
                            e.target.style.boxShadow =
                              "0 4px 12px rgba(36, 87, 191, 0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "#ffffff";
                            e.target.style.color = "#2457BF";
                            e.target.style.borderColor = "#e0e7ef";
                            e.target.style.transform = "translateY(0)";
                            e.target.style.boxShadow = "none";
                          }}
                        >
                          {suggestion}
                        </button>
                      ))}
                  </div>
                </div>
              )}

              {/* Current watchlists count - Premium Card */}
              <div
                style={{
                  fontSize: "13px",
                  color: "#334155",
                  padding: "16px 18px",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                  border: "1px solid #e0e7ef",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: userWatchlists.length > 0 ? "12px" : "0",
                  }}
                >
                  <strong style={{ fontSize: "14px", color: "#1a1a1a" }}>
                    {tr("yourWatchlists")}
                  </strong>
                  <span
                    style={{
                      padding: "4px 12px",
                      backgroundColor:
                        userWatchlists.length >= 5 ? "#fff5f5" : "#f0f9ff",
                      color: userWatchlists.length >= 5 ? "#c62828" : "#2457BF",
                      borderRadius: "6px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    {userWatchlists.length}/5
                  </span>
                </div>
                {userWatchlists.length > 0 && (
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                  >
                    {userWatchlists.map((name, index) => (
                      <span
                        key={index}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          padding: "5px 12px",
                          backgroundColor: "#F2F7FD",
                          color: "#334155",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: "500",
                          border: "1px solid #e0e7ef",
                        }}
                      >
                        <span
                          style={{
                            width: "6px",
                            height: "6px",
                            backgroundColor: "#2457BF",
                            borderRadius: "50%",
                            marginRight: "8px",
                          }}
                        ></span>
                        {name}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Premium Footer */}
            <div
              className="modal-footer"
              style={{
                borderTop: "1px solid #e0e7ef",
                padding: "20px 28px",
                backgroundColor: "#ffffff",
                display: "flex",
                gap: "12px",
              }}
            >
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                  setNewWatchlistName("");
                  setWatchlistError("");
                }}
                style={{
                  padding: "11px 24px",
                  fontSize: "14px",
                  fontWeight: "600",
                  backgroundColor: "#ffffff",
                  color: "#475467",
                  border: "1px solid #d7e3f4",
                  borderRadius: "10px",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  letterSpacing: "-0.2px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f5f9ff";
                  e.target.style.borderColor = "#bfd3f0";
                  e.target.style.color = "#334155";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#ffffff";
                  e.target.style.borderColor = "#d7e3f4";
                  e.target.style.color = "#475467";
                }}
              >
                {tr("cancel")}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCreateWatchlist}
                disabled={
                  userWatchlists.length >= 5 || !newWatchlistName.trim()
                }
                style={{
                  padding: "11px 24px",
                  fontSize: "14px",
                  fontWeight: "600",
                  background:
                    userWatchlists.length >= 5 || !newWatchlistName.trim()
                      ? "#cbd5e1"
                      : "linear-gradient(135deg, #2457BF 0%, #1a42a0 100%)",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "10px",
                  cursor:
                    userWatchlists.length >= 5 || !newWatchlistName.trim()
                      ? "not-allowed"
                      : "pointer",
                  transition: "all 0.2s",
                  letterSpacing: "-0.2px",
                  boxShadow:
                    userWatchlists.length >= 5 || !newWatchlistName.trim()
                      ? "none"
                      : "0 4px 12px rgba(36, 87, 191, 0.3)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={(e) => {
                  if (
                    !(userWatchlists.length >= 5 || !newWatchlistName.trim())
                  ) {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 6px 20px rgba(36, 87, 191, 0.4)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (
                    !(userWatchlists.length >= 5 || !newWatchlistName.trim())
                  ) {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 4px 12px rgba(36, 87, 191, 0.3)";
                  }
                }}
              >
                <i className="icon-plus"></i>
                {tr("createWatchlist")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Watchlist Name Modal */}
      <div
        className="modal fade"
        id="editWatchlistModal"
        aria-labelledby="editWatchlistModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{
              border: "none",
              borderRadius: "20px",
              overflow: "hidden",
              maxWidth: "480px",
              margin: "auto",
              background: "linear-gradient(145deg, #ffffff, #f8fafc)",
              boxShadow:
                "0 25px 80px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.6)",
            }}
          >
            {/* HEADER */}
            <div
              className="modal-header"
              style={{
                border: "none",
                padding: "28px 28px 16px",
                position: "relative",
              }}
            >
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label={tr("close")}
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "20px",
                  opacity: 0.4,
                  transform: "scale(0.9)",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "0.4";
                  e.target.style.transform = "scale(0.9)";
                }}
              />

              <div style={{ paddingRight: "40px" }}>
                <h2
                  id="editWatchlistModalLabel"
                  style={{
                    margin: "0 0 6px 0",
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#0f172a",
                    letterSpacing: "-0.3px",
                  }}
                >
                  Edit Watchlist
                </h2>

                <p
                  style={{
                    margin: 0,
                    fontSize: "13px",
                    color: "#64748b",
                  }}
                >
                  Rename{" "}
                  <span style={{ fontWeight: "600", color: "#1e293b" }}>
                    {editWatchlistCurrentName}
                  </span>
                </p>
              </div>
            </div>

            {/* BODY */}
            <div
              className="modal-body"
              style={{
                padding: "8px 28px 28px",
              }}
            >
              <div>
                <label
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#475569",
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  New Name
                </label>

                <input
                  type="text"
                  value={editWatchlistNewName}
                  maxLength={30}
                  onChange={(e) => {
                    setEditWatchlistNewName(e.target.value);
                    setEditWatchlistError("");
                  }}
                  placeholder="e.g. Tech Stocks"
                  style={{
                    width: "100%",
                    padding: "13px 14px",
                    fontSize: "14px",
                    borderRadius: "12px",
                    border: editWatchlistError
                      ? "2px solid #ef4444"
                      : "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    transition: "all 0.25s ease",
                    outline: "none",
                    fontWeight: "500",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                  }}
                  onFocus={(e) => {
                    e.target.style.border = "1.5px solid #2457BF";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(36, 87, 191, 0.15)";
                  }}
                  onBlur={(e) => {
                    e.target.style.border = editWatchlistError
                      ? "2px solid #ef4444"
                      : "1.5px solid #e2e8f0";
                    e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.05)";
                  }}
                />

                {/* ERROR */}
                {editWatchlistError && (
                  <div
                    style={{
                      marginTop: "10px",
                      fontSize: "12px",
                      color: "#dc2626",
                      background: "rgba(239,68,68,0.08)",
                      padding: "10px 12px",
                      borderRadius: "10px",
                      border: "1px solid rgba(239,68,68,0.2)",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    ⚠ {editWatchlistError}
                  </div>
                )}
              </div>
            </div>

            {/* FOOTER */}
            <div
              className="modal-footer"
              style={{
                borderTop: "1px solid #f1f5f9",
                padding: "18px 24px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                background: "#ffffff",
              }}
            >
              {/* Cancel */}
              <button
                type="button"
                data-bs-dismiss="modal"
                style={{
                  padding: "10px 18px",
                  fontSize: "13px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  background: "#ffffff",
                  color: "#475569",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#f8fafc";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "#ffffff";
                }}
              >
                {tr("cancel")}
              </button>

              {/* Update */}
              <button
                type="button"
                onClick={handleEditWatchlist}
                disabled={!editWatchlistNewName.trim()}
                style={{
                  padding: "10px 20px",
                  fontSize: "13px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  border: "none",
                  color: "#fff",
                  cursor: !editWatchlistNewName.trim()
                    ? "not-allowed"
                    : "pointer",
                  background: !editWatchlistNewName.trim()
                    ? "#cbd5f5"
                    : "linear-gradient(135deg, #2457BF, #1d4ed8)",
                  boxShadow: !editWatchlistNewName.trim()
                    ? "none"
                    : "0 6px 16px rgba(36, 87, 191, 0.35)",
                  transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  if (editWatchlistNewName.trim()) {
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.boxShadow =
                      "0 10px 22px rgba(36, 87, 191, 0.45)";
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 6px 16px rgba(36, 87, 191, 0.35)";
                }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Watchlist Confirmation Modal */}
      <div
        className="modal fade watchlist-delete-modal"
        id="deleteWatchlistConfirmModal"
        aria-labelledby="deleteWatchlistConfirmModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered watchlist-delete-modal__dialog">
          <div className="modal-content watchlist-delete-modal__content">
            <div className="modal-header watchlist-delete-modal__header">
              <button
                type="button"
                className="btn-close watchlist-delete-modal__close"
                data-bs-dismiss="modal"
                aria-label={tr("close")}
              ></button>

              <div className="watchlist-delete-modal__header-copy">
                <h2 id="deleteWatchlistConfirmModalLabel" className="watchlist-delete-modal__title">
                  {tr("deleteWatchlist")}
                </h2>
                <p className="watchlist-delete-modal__subtitle">
                  Confirm permanent removal of{" "}
                  <strong className="watchlist-delete-modal__watchlist-name">"{activeTab}"</strong>
                </p>
              </div>
            </div>

            <div className="modal-body watchlist-delete-modal__body">
              <div className="watchlist-delete-modal__warning">
                <div className="watchlist-delete-modal__warning-icon" aria-hidden>
                  !
                </div>
                <div>
                  <p className="watchlist-delete-modal__warning-title">
                    {tr("thisActionCannotBeUndone")}
                  </p>
                  <p className="watchlist-delete-modal__warning-text">
                    {tr("allStocksPermanentlyRemoved")}
                  </p>
                </div>
              </div>

              <div className="watchlist-delete-modal__info">
                <span className="watchlist-delete-modal__info-dot" aria-hidden></span>
                <span>{tr("otherWatchlistsRemainSafe")}</span>
              </div>

              <div className="watchlist-delete-modal__actions">
                <button
                  type="button"
                  className="watchlist-delete-modal__btn watchlist-delete-modal__btn--ghost"
                  data-bs-dismiss="modal"
                >
                  {tr("cancel")}
                </button>
                <button
                  type="button"
                  className="watchlist-delete-modal__btn watchlist-delete-modal__btn--danger"
                  onClick={handleDeleteWatchlist}
                >
                  {tr("deleteWatchlist")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <div
        className="modal fade"
        id="DeleteWatchlistModal"
        aria-labelledby="DeleteWatchlistModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content border-0"
            style={{
              borderRadius: "18px",
              overflow: "hidden",
              boxShadow: "0 24px 60px rgba(15, 23, 42, 0.22)",
            }}
          >
            <div
              className="modal-header"
              style={{
                background: "linear-gradient(180deg, #FFF5F5 0%, #FFFFFF 100%)",
                borderBottom: "1px solid #FEE2E2",
                padding: "16px 18px",
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  style={{
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    background: "#FEE2E2",
                    color: "#DC2626",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 700,
                    fontSize: "14px",
                  }}
                >
                  !
                </div>
                <h5
                  className="modal-title mb-0"
                  id="DeleteWatchlistModalLabel"
                  style={{ fontWeight: 700, color: "#111827" }}
                >
                  {tr("deleteFromWatchlistTitle")}
                </h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label={tr("close")}
              />
            </div>

            <div className="modal-body" style={{ padding: "18px" }}>
              <p className="mb-2" style={{ color: "#334155", fontSize: "15px" }}>
                {tr("confirmDeleteStockFromWatchlist")}
              </p>

              <div
                style={{
                  background: "#F8FAFC",
                  border: "1px solid #E2E8F0",
                  borderRadius: "12px",
                  padding: "10px 12px",
                  fontWeight: 600,
                  color: "#0F172A",
                  marginBottom: "16px",
                }}
              >
                {selectedOrderId?.FullName || selectedOrderId?.name || "-"}
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-light"
                  data-bs-dismiss="modal"
                  onClick={handleCancelDelete}
                  style={{
                    minWidth: "96px",
                    border: "1px solid #E2E8F0",
                    borderRadius: "10px",
                    fontWeight: 600,
                    color: "#334155",
                  }}
                >
                  {tr("cancel")}
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    handleConfirmDelete();
                    setTimeout(() => {
                      setSelectedOrderId(null);
                    }, 2000);
                  }}
                  style={{
                    minWidth: "96px",
                    borderRadius: "10px",
                    fontWeight: 600,
                  }}
                >
                  {tr("confirm")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Target Reason Details Modal - Modern Design */}
      <div
        className="modal fade"
        id="TargetReasonDetailsModal"
        aria-labelledby="TargetReasonDetailsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div
            className="modal-content border-0"
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              boxShadow: "0 20px 50px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.08)",
              overflow: "hidden",
              border: "1px solid rgba(0, 0, 0, 0.06)",
            }}
          >
            {/* Modern Header */}
            <div
              style={{
                background: "#f5f6ff",
                padding: "1.2rem 1.3rem",
                position: "relative",
              }}
            >
              <button
                type="button"
                className="btn-close position-absolute"
                data-bs-dismiss="modal"
                aria-label={tr("close")}
                style={{
                  top: "0.9rem",
                  right: "0.9rem",
                  opacity: 0.6,
                  fontSize: "0.7rem"
                }}
              ></button>

              <div style={{ marginRight: "2rem" }}>
                <h5
                  className="mb-1"
                  id="TargetReasonDetailsModalLabel"
                  style={{
                    color: "#000",
                    fontSize: "1rem",
                    fontWeight: 600,
                  }}
                >
                  Target Reason
                </h5>
                <p
                  className="mb-0"
                  style={{ color: "#757575", fontSize: "0.88rem" }}
                >
                  {targetReasonModalData.stockName || "-"}
                </p>
              </div>
            </div>

            <div style={{ padding: "1.2rem 1.3rem 1.3rem 1.3rem" }}>
              {/* Modern Body */}
              <div style={{ padding: "2rem", background: "#FAFBFC" }}>
                {/* Reason Section */}
                <div style={{ marginBottom: "1.5rem" }}>
                  <div
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      color: "#64748B",
                      letterSpacing: "0.05em",
                      textTransform: "uppercase",
                      marginBottom: "0.75rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem"
                    }}
                  >
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        borderRadius: "50%",
                        background: "#667eea"
                      }}
                    ></div>
                    Reason
                  </div>
                  <div
                    style={{
                      fontSize: "1rem",
                      color: "#1E293B",
                      fontWeight: 500,
                      lineHeight: 1.6,
                      background: "#FFFFFF",
                      border: "1px solid #E2E8F0",
                      borderRadius: "12px",
                      padding: "1rem 1.25rem",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    {targetReasonModalData.reason || "No reason provided"}
                  </div>
                </div >

                {/* Details Section */}
                < div style={{ marginBottom: "2rem" }}>
                  <div
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      color: "#64748B",
                      letterSpacing: "0.05em",
                      textTransform: "uppercase",
                      marginBottom: "0.75rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem"
                    }}
                  >
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        borderRadius: "50%",
                        background: "#667eea"
                      }}
                    ></div>
                    Details
                  </div>
                  <div
                    style={{
                      fontSize: "0.95rem",
                      color: "#334155",
                      lineHeight: 1.7,
                      background: "#FFFFFF",
                      border: "1px solid #E2E8F0",
                      borderRadius: "12px",
                      padding: "1rem 1.25rem",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                      minHeight: "80px",
                    }}
                  >
                    {targetReasonModalData.details || "No additional details provided"}
                  </div>
                </div >

                {/* Action Buttons */}
                < div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.75rem",
                    paddingTop: "1rem",
                    borderTop: "1px solid #E2E8F0"
                  }}
                >
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    style={{
                      background: "#F1F5F9",
                      color: "#475569",
                      border: "1px solid #CBD5E1",
                      borderRadius: "10px",
                      padding: "0.6rem 1.5rem",
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      transition: "all 0.2s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = "#E2E8F0";
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = "#F1F5F9";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      color: "#FFFFFF",
                      border: "none",
                      borderRadius: "10px",
                      padding: "0.6rem 1.5rem",
                      fontSize: "0.9rem",
                      fontWeight: 600,
                      boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                      transition: "all 0.2s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.4)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.3)";
                    }}
                    onClick={(e) => {
                      // Copy to clipboard functionality
                      const textToCopy = `Target Reason - ${targetReasonModalData.stockName}\n\nReason: ${targetReasonModalData.reason}\n\nDetails: ${targetReasonModalData.details}`;
                      navigator.clipboard.writeText(textToCopy).then(() => {
                        // Show success feedback
                        const originalText = e.target.textContent;
                        e.target.textContent = "Copied!";
                        setTimeout(() => {
                          e.target.textContent = originalText;
                        }, 2000);
                      });
                    }}
                  >
                    Copy Details
                  </button>
                </div >
              </div >
            </div >
          </div >
        </div >

        {/* CDSL Authorization Modal */}

        < button
          id="openCDSLModalBtn"
          type="button"
          class="d-none"
          data-bs-toggle="modal"
          data-bs-target="#CDSLAuthorizationModal"
        ></button >

        <div
          className="modal fade"
          id="CDSLAuthorizationModal"
          aria-labelledby="CDSLAuthorizationModalLabel"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div
              className="modal-content shadow-lg rounded-4"
              style={{
                backgroundColor: "#ffffffff",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                border: "2px solid #ff6b35",
              }}
            >
              <div
                className="modal-header pb-0"
                style={{ borderBottom: "2px solid #ff6b35" }}
              >
                <h5
                  className="modal-title"
                  id="CDSLAuthorizationModalLabel"
                  style={{
                    color: "#212529",
                    fontWeight: "700",
                    fontSize: "1.5rem",
                    paddingBottom: "12px",
                  }}
                >
                  {tr("authorizeCDSLAccess")}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label={tr("close")}
                  style={{ filter: "brightness(0.5)" }}
                />
              </div>

              <div
                className="modal-body py-4 text-center"
                style={{ color: "#2e3031ff" }}
              >
                <div className="mb-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    fill="#ff6b35"
                    className="bi bi-shield-lock"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                    <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z" />
                  </svg>
                </div>

                <h3
                  style={{
                    fontWeight: "600",
                    marginBottom: "1rem",
                    color: "#212529",
                  }}
                >
                  {tr("cdslSellAuthorizationRequired")}
                </h3>

                <p
                  style={{
                    fontSize: "1.05rem",
                    marginBottom: "2rem",
                    lineHeight: "1.6",
                  }}
                >
                  {tr("cdslAuthorizationDescription")}
                </p>

                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-outline-secondary px-4 py-2 fw-semibold"
                    data-bs-dismiss="modal"
                    style={{
                      borderRadius: "30px",
                      fontSize: "1rem",
                      letterSpacing: "0.03em",
                    }}
                  >
                    {tr("cancel")}
                  </button>

                  <form
                    name="CDSLAuthForm"
                    method="post"
                    action="https://dev-openapi.5paisa.com/WebVendorLogin/EDISAuthorization/Authorization"
                    target="_blank"
                    style={{ margin: 0 }}
                  >
                    <input
                      type="hidden"
                      name="AccessToken"
                      value={sharedData.accessToken}
                    />
                    <input
                      type="hidden"
                      name="ClientCode"
                      value={sharedData.ClientCode}
                    />
                    <input
                      type="hidden"
                      name="VendorKey"
                      value={sharedData.api_key}
                    />
                    <input
                      type="hidden"
                      name="ResponseURL"
                      value={`https://beta.infomanav.in/zerodhaReact/authorization/${sharedData.ID}`}
                    />

                    <button
                      type="submit"
                      className="btn px-4 py-2 fw-semibold"
                      style={{
                        borderRadius: "30px",
                        fontSize: "1rem",
                        letterSpacing: "0.03em",
                        backgroundColor: "#ff6b35",
                        color: "white",
                        border: "none",
                      }}
                      data-bs-dismiss="modal"
                    >
                      {tr("authorize")}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>






        
      </div>
      <SetTargetModal
        modalId="SetTargetModal"
        stock={targetDetails}
        tr={tr}
        formatNumber={formatNumber}
        apiBaseUrl={pmsApiBaseUrl}
        source="watchlist"
        sourceWatchlist={activeTab}
        userId={sharedData?.ID}
        brokerType={sharedData?.broker_type || localStorage.getItem("broker_type") || ""}
        onSuccess={() => {
          setUpdateWatchlistTrigger((prev) => prev + 1);
        }}
        showSuccessToast={showSuccessToast}
        showErrorToast={showErrorToast}
        showWarningToast={showWarningToast}
      />


      <StockCandleModal
        isOpen={!!selectedStock}
        onClose={() => setSelectedStock(null)}
        stock={selectedStock}
        Exch={selectedStock?.Exch || selectedStock?.exch}
        ExchType={selectedStock?.ExchType || selectedStock?.exchType}
        ExchSeg={selectedStock?.ExchSeg || selectedStock?.exch_seg}
        ScripCode={
          selectedStock?.ScripCode ||
          selectedStock?.scripcode ||
          selectedStock?.Scripcode
        }
        symbolToken={
          selectedStock?.token ||
          selectedStock?.Token ||
          selectedStock?.scripcode ||
          selectedStock?.ScripCode
        }
        Name={selectedStock?.FullName || selectedStock?.full_name || selectedStock?.name}
        Symbol={selectedStock?.Symbol || selectedStock?.symbol || selectedStock?.name}
        onBuy={(holding) =>
          openBuySellFromStockPreview(holding || selectedStock, "Buy")
        }
        onSell={(holding) =>
          openBuySellFromStockPreview(holding || selectedStock, "Sell")
        }
      />


    </>
  );
}

export default Watchlist;
